// src/screens/admin/StoreAdminScreen.js
// 80차: 운영시간 탭 테마별 "시작 시간/플레이시간/준비시간" 3열 입력란이 시작 시간 라벨만
// "시작 시간 (비우면 매장 공통)"으로 길어 2줄로 줄바꿈되면서, 같은 줄인데도 입력창 시작
// 위치가 옆 두 칸(1줄 라벨)보다 아래로 밀려 어긋나 보이던 버그 — 라벨을 "시작 시간"으로
// 줄이고(1줄 고정) 비우면 매장 공통을 쓴다는 안내는 행 아래 별도 문구로 이동.
// 80차: 체험형 공연(정원제) 테마 — ManualReservationTab의 수동입력이 reserveShowSlot(CF,
//       isManual:true)로 분기, 점주 취소도 cancelShowReservation(CF)로 분기(정원 원복),
//       ReservationsTab의 탈출 성공/실패/초기화 버튼은 이 포맷에선 개념이 없어 숨김.
// "공휴일 자동 차단" 제목의 🎌(crossed flags) 이모지가 실기기에서 일장기 2개로 렌더링되는
// 문제 발견 — 국적 의미가 전혀 없는 이모지인데 플랫폼별 글리프가 하필 일본 국기 모양이라
// 국내 서비스에서 치명적. 다른 CollapsibleBlock들과 동일하게 SVG Icon(CalendarCheckIcon)으로 교체.
// 78차 63차: 운영시간 탭에서 플레이시간(duration)이 읽기 전용 텍스트뿐이라 일괄등록 때
// 잘못 입력해도 고칠 방법이 없었음 — 준비시간과 같은 방식으로 직접 수정 가능하게 함.
// 78차 62차: plan 게이트를 store 최상위 대신 getEffectivePlan(store, scopeBranchIdx)
// 기준으로 통일(지점별 plan 지원) + 공휴일 자동차단을 "예약 불가 날짜" 달력에도
// 표시하고 개별 날짜 단위로 예외 처리(holidayOverrides) 가능하게 함.
// 10차 수정: 📈 리포트 탭 추가 (MonthlyReportTab)
// 탭: 대시보드 / 예약관리 / 📈 리포트 / 운영시간 / 이벤트
// 46차: 다중 매장 지원 — managedStores 전체 사용, 헤더 매장 선택 드롭다운 추가
// 51차: 색 theme.js 단일화 — 자체 색 정의를 COLORS 참조로 (초록/빨강/주황/파랑/보라 통일), THEME_COLORS 팔레트는 보존
// 55차: DashboardTab — UNLOCK 기여도 카드 추가 (즐겨찾기/리뷰/평점 + 조회수·전환율 안내)
// 60차: ScheduleTab — 반복 요일 차단(blockedWeekdays) + 예약 오픈 기간(reservationWindowDays) 추가
// 62차: ThemeSection 기본 닫힘 + 오늘 예약 자동 열림, ManualReservationTab 날짜 달력·금액 잠금, StatsTab 어제/오늘·주간 비교 추가, ScheduleTab 미저장 경고
// 63차: 점주 예약 취소 버튼 추가 (ReservationsTab)
// 69차: EventsTab의 store 미정의 참조 오류(ReferenceError) 수정 — 즐겨찾기 알림이 조용히 실패하던 문제 해결
// 69차: 이벤트 탭을 BOOST 플랜 전용 기능으로 재정의하여 SettingsComboTab에 복원
//       (58차에서 진입점이 삭제되어 BOOST 플랜을 구매해도 이벤트 등록이 불가능했던 상태였음)
//       + 62차에 만들어졌던 ScheduleTab 미저장 경고 콜백을 다시 연결
// 70차: "이벤트" 명칭 → "PICK 테마"로 변경 (할인코드를 반드시 줘야 할 것 같은 인상 해소)
// 70차: 등록/수정 폼을 FlatList 내부에서 독립 Modal로 분리 — 타이핑 시 키보드가
//       사라지던 버그(ListHeaderComponent 인라인 함수 리마운트) 및 "수정" 시 폼이
//       엉뚱한 위치(최상단)에 떠서 혼동되던 문제를 함께 해결
// 70차: 시작일/종료일을 텍스트 입력 → 캘린더 선택으로 변경 (날짜 형식 오류로 인한
//       "기간 내인데 종료됨으로 표시" 버그의 근본 원인 제거)
// 71차: ManualReservationTab — addManualReservation이 슬롯 잠금을 체크하도록
//       바뀌면서 새로 던지는 SLOT_TAKEN 에러에 안내 메시지 추가
// 71차: PICK 테마 등록 알림의 storeName이 존재하지 않는 store.name을 참조해
//       항상 branch[0] 이름으로 새던 것을 store.ownerName 우선으로 수정
// 71차: 설정 탭에 "리뷰 답글" 서브탭 신규 추가 — ReviewCard.js의 기존 adminUid
//       답변 UI를 재사용 (모든 플랜 공통, 잠금 없음)
// 71차: PICK 테마 알림의 storeName을 productService.getStoreDisplayName()으로 교체
// 72차: 헤더의 지점 선택(scopeBranchIdx)에 홈/통계/설정 탭도 반응하도록 분리.
//       branches 배열 자체는 절대 자르지 않고(운영시간 저장·productId 위치 인덱스가
//       깨지므로) 각 탭이 인덱스로 표시만 필터링하는 방식으로 구현.
// 72차: 매장 "플랜"(BASIC/STANDARD/PREMIUM/BOOST)별 탭 게이트 추가 — TAB_MIN_PLAN.
//       SuperAdmin이 store.plan을 바꾸면 곧바로 이용 가능한 탭이 달라짐.
// 72차: 통계 탭 일별 매출 그래프 라벨을 "만/k" 혼용 → "만" 단일 표기로 통일
// 72차: 설정 탭 운영시간 섹션 순서 재배치(시작/종료/간격→예약 오픈 기간→예약불가
//       시간·날짜·요일[각각 접기 가능]→예약 URL), PICK 테마에 지점 선택 필드 추가
// 72차: PICK 테마 등록 폼을 자유입력(제목/종류/쿠폰) → 매장이 등록한 테마 중 선택하는
//       방식으로 단순화 (productId 저장 → BookingScreen PICK 배지와 연결)
// 72차: section prop 추가 — navigation/index.js가 이 화면을 매장관리(홈·통계)/
//       운영관리(예약·설정) 두 하단 탭으로 나눠 등록할 수 있도록 지원
// 72차: 위 분리 직후 실사용 테스트에서 두 탭 간 지점 선택이 안 맞던 문제 발견 —
//       selectedBranchKey를 StoreAdminBranchContext로 끌어올려 두 탭이 공유하도록 수정
// 72차: BookingComboTab에 가벼운 온보딩 배너 추가 — 운영시간(availableTimes)이 한 번도
//       생성된 적 없는 신규 매장이면 설정 탭에서 먼저 시간을 입력하라고 안내
// 75차: 수동입력(과거 날짜)이 이미 정산(billings) 생성된 달이면 "자동 반영 안 됨" 안내만
//       추가 — 자동 재계산은 하지 않기로 함(이미 총괄관리자가 확인/발송했을 수 있는
//       정산서를 코드가 조용히 바꾸는 리스크가 더 크다고 판단). firestore.rules의
//       billings read를 총괄관리자 전용 → 매장관리자도 자기 매장 건은 읽기 허용으로 확장.
// 78차 48차: BulkThemeImportTab(75차, 엑셀 테마 일괄 등록) 탭 삭제 — 사용자 요청.
// xlsx/expo-document-picker/expo-file-system import도 이 파일에선 더 안 쓰여 함께 제거
// (SuperAdminStoresScreen.js의 매장 일괄등록은 별개 기능이라 영향 없음).
// 75차: 데드코드 정리 — MonthlyReportTab(10차에 만든 "📈 리포트" 탭, KpiBox 헬퍼 +
// 전용 rp 스타일시트 포함) 삭제. TABS 배열에 'report' 키 자체가 없어 그 어떤 탭에서도
// 렌더된 적이 없는 완전한 죽은 코드였음(72차 하단탭 분리 리팩터링 때 진입점이 빠진 뒤
// 안 지워지고 남아있던 것으로 추정) — 필요하면 나중에 통계 탭 쪽으로 다시 설계.
// 78차: load()의 관리 매장 순차 조회(for...of + await)를 Promise.all 병렬 조회로 변경 —
// 멀티 지점 관리자일수록 로딩이 매장 수만큼 선형으로 느려지던 문제. 매장별 로직(예약 없을
// 때 getAllReservations() 폴백 포함)은 동작 변화 없이 그대로 유지.
// 78차: PREMIUM "UNLOCK 내 위치" 카드의 "업계 평균" 3개 지표가 하드코딩된 "준비 중"
// 문자열이었던 것을 신규 CF getIndustryAverageCF(전체 활성 매장의 이번달 예약수/매출/
// 성공률 평균을 서버에서 집계)로 실제 값 연결.
// 78차 13차: ops 섹션(예약관리/매장설정)의 TabBar 행을 없애고 AppHeader 중앙의 작은
// HeaderTabSwitch로 대체했었으나(3단 구성 데이터 영역 문제 해결 목적), 78차 21차에
// 사용자 요청으로 이전 방식(TabBar 그대로 노출)으로 롤백 — HeaderTabSwitch 삭제.
// PICK 테마 폼에 "자동 갱신"(events.autoRenew) 체크박스 추가 — 90일 상한은
// 유지하되(무기한 노출 방지), 계속 노출을 원하는 매장은 매번 재등록하지 않도록
// functions/index.js의 scheduledPickAutoRenew(매일 03:00 KST, PREMIUM 플랜 유지
// 매장만 90일 연장)가 대신 처리.

import React, { useState, useEffect, useCallback, useRef, useContext } from 'react';
import { useNavigation } from '@react-navigation/native';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  TextInput, Alert, Modal,
  FlatList, Image, Animated, Keyboard, Share,
} from 'react-native';

import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db } from '../../services/firebase';
import { functions } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { getAllReservations, updateReservationResult, addManualReservation, cancelReservationByStore, reserveShowSlot, cancelShowReservation, sumReservationCount, addManualDailyTotal, addManualByTheme, getManualBulkLogSummary } from '../../services/reservationService';
import { cancelBulkRoomReservation } from '../../services/recruitService';
import { getReviewsByStoreId, getReplyTemplate } from '../../services/reviewService';
import { ReviewList } from '../../components/common/ReviewCard';
import AppHeader from '../../components/common/AppHeader';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import { Calendar } from 'react-native-calendars';
import { COLORS } from '../../constants/theme';
// 68차: plan 4단계 게이트 헬퍼 + 수수료 계산 단일화 함수
import { planAtLeast, getPickHighlights, PICK_HIGHLIGHT_MAX, PICK_HIGHLIGHT_CUSTOM_MAX_LEN, KOREAN_HOLIDAYS } from '../../constants';
import { PICK_FREE_SLOT_COUNT, PICK_ADDON_FEE } from '../../services/feeService';
import { calcStoreFee, getStoreThemeCount, getPickAddonFee, getPlanFee, getPlanDiscountRate, getEffectivePlan, getBranchPlan, hasOpsAddon, getOpsAddonFee } from '../../services/feeService';
import { getPaidPickSlotCountForMonth } from '../../services/eventService';
import { generateAndShareInvoice } from '../../services/invoiceService';
import { getStoreDisplayName, parseProductId, invalidateStoreCache } from '../../services/productService';
import { StoreAdminBranchContext } from '../../contexts/StoreAdminBranchContext';
import { PlanBadge, SecondaryButton, DangerButton, TextButton } from '../../components/common/Buttons';
import PlanInfoView from '../../components/common/PlanInfoView';
import GradientButton from '../../components/common/GradientButton';
import { normalizeTimeStr } from '../../utils/dateUtils';
import MinutesPickerField from '../../components/common/MinutesPickerField';
import {
  PlanLockedIcon, EmptyStoresIcon, StatsIcon, MenuReservationIcon, MenuPointsIcon,
  PeopleIcon, PriceIcon, LinkIcon, EditIcon, MenuStoreIcon, ReceiptIcon,
  MenuInquiryIcon, IconLabel,
  HourglassIcon, CancelIcon, EmptyReservationsIcon,
  ClockIcon, SpotlightStarIcon, CalendarCheckIcon,
  ContribFavoriteIcon, ContribReviewIcon, ContribRatingIcon, ViewsIcon, TrendingUpIcon,
  DashboardHomeIcon, TodayRevenueIcon, MonthlyBookingsIcon, MonthlyCancelsIcon,
  OccupancyGaugeIcon, TodayBookingClipboardIcon, EscapeSuccessRateIcon,
  EscapeRecordSuccessIcon, EscapeRecordFailIcon, ReservationCancelIcon, HintUsageIcon,
  MenuReviewIcon, EscapeSuccessIcon, RefreshIcon, CheckmarkIcon,
  NoEntryIcon, PersonIcon, PhoneIcon, MenuEscapeIcon,
} from '../../components/common/Icons';

const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const SURFACE    = COLORS.surface;
const SURFACE2   = COLORS.surface2;
const BORDER     = COLORS.border;
const TEXT       = COLORS.text;
const TEXT_SEC   = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const GREEN      = COLORS.green;
const RED        = COLORS.red;
const ORANGE     = COLORS.orange;
const BLUE       = COLORS.blue;
const PURPLE     = COLORS.purple;
const ON_GOLD    = COLORS.onGold;

// ─── 공통 컴포넌트 ────────────────────────────────────────────
const Card = ({ children, style }) => (
  <View style={[card.wrap, style]}>{children}</View>
);
const card = StyleSheet.create({
  wrap: {
    backgroundColor: SURFACE, borderRadius: 14, borderWidth: 1,
    borderColor: BORDER, padding: 16, marginBottom: 14,
  },
});

const CardTitle = ({ children, Icon }) => (
  Icon ? (
    <IconLabel Icon={Icon} size={14} color={GOLD}
      textStyle={{ color: GOLD, fontSize: 14, fontWeight: '800' }}
      style={{ marginBottom: 12, paddingBottom: 10, borderBottomWidth: 1, borderBottomColor: BORDER }}>
      {children}
    </IconLabel>
  ) : (
    <Text style={{ color: GOLD, fontSize: 14, fontWeight: '800', marginBottom: 12,
      paddingBottom: 10, borderBottomWidth: 1, borderBottomColor: BORDER }}>{children}</Text>
  )
);

// 78차: 이 파일 전용으로 따로 있던 Btn(primary/ghost/danger variant) 구현을 공용
// GradientButton/SecondaryButton/DangerButton으로 위임 — 컴포넌트 하나만 고치면
// 이 파일 안의 15개 호출부 전부가 디자인 시스템(design_handoff_unlock)과 일치하게 됨.
const btnTextStyle = { fontSize: 12 };
const Btn = ({ label, onPress, variant = 'primary', disabled, style }) => {
  if (variant === 'danger') {
    return <DangerButton label={label} onPress={onPress} disabled={disabled} style={style} textStyle={btnTextStyle} />;
  }
  if (variant === 'ghost') {
    return <SecondaryButton label={label} onPress={onPress} disabled={disabled} style={style} textStyle={btnTextStyle} />;
  }
  return <GradientButton label={label} onPress={onPress} disabled={disabled} style={style} textStyle={btnTextStyle} />;
};

// ─── 탭 바 — 38차: 6탭 → 3탭 통합, 58차: 홈/예약/통계/설정 4탭으로 재편 ──
// 홈: 핵심지표 + UNLOCK 기여도 (한눈에 보기)
// 예약: 목록 + 달력 + 수동입력 3-way 뷰 전환
// 통계: 일별매출/테마별매출/전달비교/월별리포트 (구 홈 탭 상세 통계 분리)
// 설정: 운영시간 + 이벤트 통합
// 75차: "예약"/"설정" 탭 이름이 안에 뭐가 있는지 직관적으로 안 와닿는다는 피드백 —
// "예약"은 고객의 "예약하기"와 혼동될 수 있어 "예약 관리"로, "설정"은 계정 설정처럼
// 보여서 실제 내용(운영시간·PICK 테마·리뷰 답글)과 안 맞아 "매장 설정"으로 변경.
const TABS = [
  { key: 'home',     label: '홈', Icon: DashboardHomeIcon },
  { key: 'stats',    label: '통계', Icon: StatsIcon },
  { key: 'booking',  label: '예약 관리', Icon: MenuReservationIcon },
  { key: 'settings', label: '🛠 매장 설정' },
];

// 80차 후속: 탭 게이트를 plan(노출 등급)이 아니라 매장관리자 기능 애드온(opsAddon)
// 기준으로 재편 — 홈/통계 탭은 예약 현황·정산 같은 "운영도구" 성격이라 애드온이 있어야
// 보이고, 예약관리·매장설정은 노출 플랜/애드온과 무관하게 항상 이용 가능(PICK 등록 같은
// PREMIUM 전용 기능은 설정 탭 안에서 개별적으로 게이트, planAtLeast 그대로 유지).
const TAB_NEEDS_OPS = new Set(['home', 'stats']);

// 72차: 하단 탭 분리 — 이 화면 하나에 4개 내부탭이 다 몰려 있어 복잡하다는 피드백으로
// 매장관리(홈·통계)/운영관리(예약·설정) 두 개의 별도 하단 탭으로 나눔(navigation/index.js).
// section prop 없이 호출되면(과거 방식) 기존처럼 4개 다 보여준다.
const SECTION_TAB_KEYS = {
  dashboard: ['home', 'stats'],
  ops:       ['booking', 'settings'],
};

// 58차: ScrollView → View로 교체, 탭이 화면 전체 너비 균등하게 채우도록
// 72차: 항상 렌더할 탭 목록(tabs)을 props로 받도록 변경 — 플랜 게이트로 줄어든 탭만 표시
const TabBar = ({ active, onSelect, tabs = TABS }) => (
  <View style={tb.wrap}>
    <View style={tb.row}>
      {tabs.map(t => (
        <TouchableOpacity key={t.key} style={[tb.tab, active === t.key && tb.tabActive]}
          onPress={() => onSelect(t.key)}>
          {t.Icon
            ? <IconLabel Icon={t.Icon} size={13} color={active === t.key ? undefined : TEXT_MUTED} textStyle={[tb.label, active === t.key && tb.labelActive]}>{t.label}</IconLabel>
            : <Text style={[tb.label, active === t.key && tb.labelActive]}>{t.label}</Text>}
        </TouchableOpacity>
      ))}
    </View>
  </View>
);
// 78차 13차: ops 섹션(예약 관리/매장 설정) 상단 TabBar를 없애고 AppHeader 중앙의
// 세그먼트 스위치로 대체했었으나, 78차 21차에 사용자 요청으로 이전 방식(아래 TabBar
// 그대로 노출)으로 롤백 — HeaderTabSwitch는 더 이상 쓰지 않아 삭제.
const tb = StyleSheet.create({
  wrap: {
    backgroundColor: SURFACE,
    borderBottomWidth: 1,
    borderBottomColor: BORDER,
    flexGrow: 0,
    flexShrink: 0,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 6,
    gap: 6,
  },
  tab: {
    flex: 1,                    // 균등 분배
    alignItems: 'center',
    paddingVertical: 8,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  tabActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
  label: { color: TEXT_MUTED, fontSize: 11, fontWeight: '600' },
  labelActive: { color: GOLD, fontWeight: '800' },
});

// ─── 날짜 유틸 ───────────────────────────────────────────────
// 78차 66차: TODAY/THIS_M/PREV_M이 모듈 로드 시점에 딱 한 번만 계산되는 상수였음 — 앱을
// 자정 너머로 계속 켜두면 날짜가 절대 안 바뀌고, 게다가 toISOString()은 UTC 기준이라
// 새벽 0~9시(KST)엔 실제 날짜보다 하루 전으로 계산됨(CalendarTab.getLocalToday()가 이미
// "모듈 상수 사용 금지"로 경고해둔 바로 그 버그) — "오늘/이번주 매출이 안 잡힘" 신고의
// 근본 원인. 로컬 날짜 기준으로 호출할 때마다 새로 계산하는 함수로 교체.
const toYM = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
const toLocalYMD = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const TODAY  = () => toLocalYMD(new Date());
const THIS_M = () => toYM(new Date());
const PREV_M = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return toYM(d);
};
const mLabel = (ym) => `${parseInt(ym.split('-')[1], 10)}월`;

// 80차 후속: [버그 수정, fork로 발견] DashboardTab의 가동률(occupancyRate)이 체험형(show)
// 정원을 무시하고 "예약 문서 개수 / 슬롯 개수"로만 계산해 실제보다 크게 부풀려지고 있었음
// (capacity=4인 회차가 1명만 차도 슬롯 1개 전부 소진으로 카운트됨). 처음엔 StatsTab의
// myOccupancyRate 방식(실제 예약이 있었던 슬롯만 맵에 등록해 그 슬롯의 정원을 분모에
// 더하는 방식)을 그대로 공용화하려 했으나, 그 방식 자체가 "한 번도 예약이 없었던 슬롯은
// 분모(정원)에도 아예 안 잡히는" 별개의 결함을 갖고 있어(하루 중 완전히 빈 회차가 있어도
// 분모에서 빠져 소진율이 부풀려짐) 그대로 재사용하면 안 됨을 재검토 중 발견 — room 캐파
// 계산과 동일하게 "테마의 하루 회차 수 × 경과일" 구조를 그대로 쓰고 회차당 정원만 곱하는
// 방식으로 재설계(예약 유무와 무관하게 실제 존재하는 회차 전부가 분모에 반영됨).
// 같은 조사 중 StatsTab 쪽은 revenueDuplicate(모집 그룹예약 참가자 중복 문서, 78차44차)를
// 안 걸러낸 배열(thisAll 기반 thisShowAll)로 좌석수를 합산하고 있어서, 그룹예약 좌석이
// 참가자 수배로 중복 합산되던 버그도 함께 발견 — 반드시 revenueDuplicate!==true로 걸러진
// 배열(thisR/thisShowR)만 넘기도록 통일.
function calcShowCapacity(showThemes, daysElapsed) {
  return showThemes.reduce((s, t) => s + (t.availableTimes?.length || 0) * (Number(t.capacity) || 0), 0) * daysElapsed;
}
function calcShowFilled(dedupedShowRecords) {
  return dedupedShowRecords.reduce((s, r) => s + (Number(r.people) || 0), 0);
}

// ─── 대시보드 ────────────────────────────────────────────────
// ─── 58차: 홈 탭 — 핵심지표 + UNLOCK 기여도만 (상세 통계는 별도 통계 탭으로 분리) ─
// 80차 후속: "UNLOCK 기여도" 카드 본문을 방탈출/체험형 각각에 재사용하기 위해 분리 —
// 매장이 두 형식을 다 갖고 있으면 두 번(각각 formatLabel과 함께) 렌더, 한쪽만 있으면
// formatLabel 없이 한 번만 렌더해 기존과 동일하게 보이게 한다.
function ContribBlock({ themes, records, favCount, effectivePlan, formatLabel }) {
  const reviewCount = themes.reduce((s, t) => s + (t.reviewCount || 0), 0);
  const ratedThemes = themes.filter(t => t.reviewCount > 0);
  const avgRating = ratedThemes.length
    ? (ratedThemes.reduce((s, t) => s + (t.rating || 0), 0) / ratedThemes.length).toFixed(1)
    : null;
  const totalViewCount = themes.reduce((s, t) => s + (t.viewCount || 0), 0);
  // 80차 후속: 조회수 대비 "전환율"은 앱에서 직접 예약한 건만 의미가 있음 — 간편 일괄
  // 입력(isBulkLog, 외부채널 예약을 사후 기록한 것)까지 섞으면 앱과 무관한 예약이
  // 분자에 끼어들어 전환율이 왜곡됨(심하면 100% 초과도 가능) — 명시적으로 제외.
  const totalReservationCount = records.filter(r => !r.cancelled && !r.isBulkLog).length;
  const conversionRate = totalViewCount > 0
    ? Math.round((totalReservationCount / totalViewCount) * 100)
    : null;
  return (
    <View>
      {formatLabel && <Text style={contrib.formatLabel}>{formatLabel}</Text>}
      {planAtLeast(effectivePlan, 'premium') ? (
        <>
          <View style={{ flexDirection: 'row', gap: 8, marginBottom: 10 }}>
            <View style={contrib.item}>
              <Text style={[contrib.value, { color: GOLD }]}>{favCount}</Text>
              <IconLabel Icon={ContribFavoriteIcon} size={11} textStyle={contrib.label}>즐겨찾기</IconLabel>
            </View>
            <View style={contrib.item}>
              <Text style={[contrib.value, { color: PURPLE }]}>{reviewCount}</Text>
              <IconLabel Icon={ContribReviewIcon} size={11} textStyle={contrib.label}>리뷰</IconLabel>
            </View>
            <View style={contrib.item}>
              <Text style={[contrib.value, { color: GOLD }]}>{avgRating ?? '-'}</Text>
              <IconLabel Icon={ContribRatingIcon} size={11} textStyle={contrib.label}>평균 평점</IconLabel>
            </View>
          </View>
          <View style={contrib.comingSoonRow}>
            <View style={contrib.comingSoonItem}>
              <ViewsIcon size={18} />
              <Text style={contrib.comingSoonLabel}>조회수</Text>
              <View style={contrib.comingSoonBadge}>
                <Text style={contrib.comingSoonBadgeText}>
                  {totalViewCount > 0 ? `총 ${totalViewCount.toLocaleString()}회` : '아직 없음'}
                </Text>
              </View>
            </View>
            <View style={contrib.comingSoonItem}>
              <TrendingUpIcon size={18} />
              <Text style={contrib.comingSoonLabel}>전환율</Text>
              <View style={contrib.comingSoonBadge}>
                <Text style={contrib.comingSoonBadgeText}>
                  {conversionRate !== null ? `${conversionRate}%` : '조회 데이터 필요'}
                </Text>
              </View>
            </View>
          </View>
          <Text style={contrib.hint}>
            누적 조회수 {totalViewCount.toLocaleString()}회 · 예약 {totalReservationCount.toLocaleString()}건 기준 전환율입니다.
          </Text>
        </>
      ) : (
        <View style={contrib.blurWrap}>
          <View style={contrib.blurContent} pointerEvents="none">
            <View style={{ flexDirection: 'row', gap: 8, marginBottom: 10 }}>
              {[
                { Icon: ContribFavoriteIcon, label: '즐겨찾기', fake: reviewCount + favCount + 3 },
                { Icon: ContribReviewIcon,   label: '리뷰',     fake: reviewCount },
                { Icon: ContribRatingIcon,   label: '평균 평점', fake: avgRating ?? '4.2' },
              ].map(({ Icon, label, fake }) => (
                <View key={label} style={[contrib.item, { opacity: 1 }]}>
                  <Text style={[contrib.value, { color: GOLD }]}>{fake}</Text>
                  <IconLabel Icon={Icon} size={11} textStyle={contrib.label}>{label}</IconLabel>
                </View>
              ))}
            </View>
            <View style={contrib.comingSoonRow}>
              <View style={contrib.comingSoonItem}>
                <ViewsIcon size={18} />
                <Text style={contrib.comingSoonLabel}>조회수</Text>
              </View>
              <View style={contrib.comingSoonItem}>
                <TrendingUpIcon size={18} />
                <Text style={contrib.comingSoonLabel}>전환율</Text>
              </View>
            </View>
          </View>
          <View style={contrib.blurOverlay}>
            <PlanLockedIcon size={48} />
            <Text style={contrib.blurTitle}>PREMIUM에서 확인하세요</Text>
            <Text style={contrib.blurDesc}>
              고객들이 우리 매장을{'\n'}얼마나 찾고 있는지 보여드려요
            </Text>
            <View style={contrib.blurBadge}>
              <Text style={contrib.blurBadgeTxt}>즐겨찾기 · 리뷰 · 평점 · 조회수 · 전환율</Text>
            </View>
            <Text style={contrib.blurFooter}>총괄 관리자에게 플랜 전환을 요청하세요</Text>
          </View>
        </View>
      )}
    </View>
  );
}

function DashboardTab({ records, store, profile, storeId, scopeBranchIdx = null }) {
  // 55차: UNLOCK 기여도 카드 — 즐겨찾기 집계
  // 57차: products 컬렉션 자동생성ID로 잘못 수정했었음 — 되돌림.
  //        실제 product.id는 normalizeProduct/flattenStoreThemes가 생성하는
  //        "storeId_branchIdx_themeIdx" 합성 ID이며, ThemeDetailScreen·리뷰·
  //        즐겨찾기 등 앱 전역에서 이 합성 ID를 그대로 사용한다 (products 컬렉션은 별도/검색용).
  // 72차: scopeBranchIdx가 지정되면(특정 지점 선택 중) 해당 지점의 테마만 집계.
  //       branches 배열 자체는 자르지 않고 인덱스(bi)로만 걸러 productId의
  //       "storeId_branchIdx_themeIdx" 위치 인덱스가 항상 실제 값과 일치하도록 유지.
  // 78차 62차: plan은 지점(branches[i])별로 다를 수 있어 store 최상위 값 대신
  // scopeBranchIdx로 해석한 유효 plan(getEffectivePlan)을 기준으로 게이트한다.
  const effectivePlan = getEffectivePlan(store, scopeBranchIdx);
  const [showPlanInfo, setShowPlanInfo] = useState(false); // 78차 64차: 플랜 안내 모달
  // 80차 후속: 방탈출/체험형 각각 즐겨찾기 수 — "UNLOCK 기여도"를 형식별로 분리 표시하기 위함
  const [favCountRoom, setFavCountRoom] = useState(0);
  const [favCountShow, setFavCountShow] = useState(0);
  const navigation = useNavigation();
  // 78차: "리뷰 답변 페이지가 따로 없어 알림을 타고 들어가는 수밖에 없다"는 신고 —
  // 대시보드 홈에 미답변 리뷰 수 + 바로가기 카드 추가(딥링크는 StoreAdminOps→매장설정→리뷰답글).
  const [unansweredCount, setUnansweredCount] = useState(0);
  useEffect(() => {
    if (!storeId) return;
    let cancelled = false;
    (async () => {
      try {
        const reviews = await getReviewsByStoreId(storeId);
        const visible = scopeBranchIdx === null
          ? reviews
          : reviews.filter(r => parseProductId(r.productId)?.branchIdx === scopeBranchIdx);
        if (!cancelled) setUnansweredCount(visible.filter(r => !r.reply?.text).length);
      } catch { if (!cancelled) setUnansweredCount(0); }
    })();
    return () => { cancelled = true; };
  }, [storeId, scopeBranchIdx]);
  useEffect(() => {
    if (!planAtLeast(effectivePlan, 'premium') || !storeId) { setFavCountRoom(0); setFavCountShow(0); return; }
    let cancelled = false;
    (async () => {
      try {
        const themeRefs = (store?.branches || []).flatMap((b, bi) =>
          (scopeBranchIdx !== null && bi !== scopeBranchIdx) ? [] :
          (b.themes || []).map((t, ti) => ({ id: `${storeId}_${bi}_${ti}`, isShow: t.bookingFormat === 'show' }))
        );
        if (!themeRefs.length) { if (!cancelled) { setFavCountRoom(0); setFavCountShow(0); } return; }
        const idToIsShow = new Map(themeRefs.map(r => [r.id, r.isShow]));
        const productIds = themeRefs.map(r => r.id);
        // Firestore 'in' 쿼리는 최대 10개 제한 — 10개씩 끊어서 합산, 형식별로 분리 집계
        let room = 0, show = 0;
        for (let i = 0; i < productIds.length; i += 10) {
          const chunk = productIds.slice(i, i + 10);
          const snap = await getDocs(
            query(collection(db, 'favorites'), where('productId', 'in', chunk))
          );
          snap.docs.forEach(d => { idToIsShow.get(d.data().productId) ? show++ : room++; });
        }
        if (!cancelled) { setFavCountRoom(room); setFavCountShow(show); }
      } catch {
        if (!cancelled) { setFavCountRoom(0); setFavCountShow(0); }
      }
    })();
    return () => { cancelled = true; };
  }, [storeId, store, scopeBranchIdx]);

  // 75차: paymentStatus:'pending'(모집 일괄예약 등 결제/입금 확인 전) 건이 매출에 그대로
  // 잡히고 있었음 — SuperAdminScreen.js/HomeScreen.js/reviewService.js는 이미 pending을
  // 제외하고 계산하는데 이 화면만 빠져 있어서, 아직 확정 안 된 예약까지 "오늘/이번달 매출"에
  // 포함돼 실제보다 부풀려 보일 수 있었음.
  // 78차 44차: 모집 일괄예약은 참가자별로 문서가 여러 개라 revenueDuplicate:true인
  // 문서(그룹당 첫 참가자를 제외한 나머지)는 매출 집계에서 제외 — 예약 건수 집계
  // (totalReservationCount 등, 별도 배열)에는 영향 없음.
  // 78차 55차: 위 주석의 "예약 건수는 별도 배열"이라는 전제가 실제로는
  // totalReservationCount 한 곳에만 해당했음 — 가동률(occupancyRate)/"이번달 예약" KPI가
  // 매출용으로 필터링된 active/thisR의 .length를 그대로 건수로도 재사용하고 있어서,
  // 모집 그룹예약(참가자 N명, revenueDuplicate로 N-1건 제외)이 있으면 실제 예약 인원보다
  // 적게 집계되던 버그 — 건수 전용 activeAll/thisAll을 별도로 두고 분리.
  const active    = records.filter(r => !r.cancelled && r.paymentStatus !== 'pending' && r.revenueDuplicate !== true);
  const activeAll = records.filter(r => !r.cancelled && r.paymentStatus !== 'pending');
  const todayR    = active.filter(r => r.date === TODAY());
  const thisR     = active.filter(r => r.date?.startsWith(THIS_M()));
  const thisAll   = activeAll.filter(r => r.date?.startsWith(THIS_M()));
  const prevR     = active.filter(r => r.date?.startsWith(PREV_M()));

  const todayRev  = todayR.reduce((s, r) => s + (r.price || 0), 0);
  const thisRev   = thisR.reduce((s, r) => s + (r.price || 0), 0);
  const prevRev   = prevR.reduce((s, r) => s + (r.price || 0), 0);
  const diffRate  = prevRev > 0 ? Math.round(((thisRev - prevRev) / prevRev) * 100) : null;

  const cancelCount = records.filter(r => r.cancelled && r.date?.startsWith(THIS_M())).length;

  // 55차: 기여도 카드 데이터
  // 57차: reviewService.js 실제 저장 필드(theme.rating, theme.reviewCount)에 맞춰 수정
  //        (records.reviewed / avgRating은 잘못된 필드 참조였음)
  // 78차 46차: 소프트 삭제된 지점/테마(isDeleted:true)는 더 이상 운영하지 않으므로
  // 가동률(dailySlotCapacity)·기여도 집계에서 제외.
  const allThemes = (store?.branches || []).flatMap((b, bi) =>
    (b.isDeleted === true || (scopeBranchIdx !== null && bi !== scopeBranchIdx)) ? [] : (b.themes || []).filter(t => t.isDeleted !== true)
  );
  // 80차 후속: "UNLOCK 기여도"를 방탈출/체험형으로 나눠 보여주기 위한 분리 —
  // 계산 자체(reviewCount/avgRating/조회수/전환율)는 ContribBlock 안으로 이동.
  const roomThemes = allThemes.filter(t => (t.bookingFormat || 'room') !== 'show');
  const showThemes = allThemes.filter(t => t.bookingFormat === 'show');
  const roomRecords = records.filter(r => (r.bookingFormat || 'room') !== 'show');
  const showRecords = records.filter(r => r.bookingFormat === 'show');

  // 78차 32차: 가동률 — 이번달 실제 예약 건수 / (테마별 하루 슬롯 수 합계 × 이번달
  // 경과일). 각 테마의 하루 슬롯 수는 theme.availableTimes(운영시간/휴게시간이 이미
  // 반영된 실제 예약 가능 시간 목록, ScheduleTab의 generateSlots 결과)를 그대로 씀 —
  // 정기휴무 개념이 이 앱엔 없어 매일 동일하게 열려있다고 가정. 미래 날짜는 아직
  // "미달성"이 아니라 "미확정"이라 분모에서 빼야 해서 분모를 오늘까지의 경과일로 한정.
  // 80차 후속: [버그 수정] room은 "슬롯 1개=1 캐파"라 thisR(중복제거된 예약 건수)이
  // 그대로 채움량이지만, show는 슬롯 1개가 capacity명을 수용해 채움량을 정원 대비로
  // 따로 계산해야 함 — 방탈출/체험형을 각자 계산 후 캐파·채움량을 합산.
  const daysElapsedThisMonth = new Date().getDate();
  const roomCapacity = roomThemes.reduce((s, t) => s + (t.availableTimes?.length || 0), 0) * daysElapsedThisMonth;
  // 80차 후속: 간편 일괄 입력(bulkCount>1)이 실제 대표하는 건수를 반영하려면 .length
  // 대신 sumReservationCount — room 캐파는 "슬롯 1개=1건"이라 이게 그대로 채움량.
  const roomFilled = sumReservationCount(thisR.filter(r => (r.bookingFormat || 'room') !== 'show'));
  const showCapacity = calcShowCapacity(showThemes, daysElapsedThisMonth);
  const showFilled = calcShowFilled(thisR.filter(r => r.bookingFormat === 'show'));
  const totalCapacity = roomCapacity + showCapacity;
  const occupancyRate = totalCapacity > 0
    ? Math.min(100, Math.round(((roomFilled + showFilled) / totalCapacity) * 100))
    : null;

  return (
    <ScrollView contentContainerStyle={{ padding: 14 }} showsVerticalScrollIndicator={false}>

      {/* 77차: design 폴더 매장관리자 콘솔 스펙 — 매장명 + 플랜 뱃지 헤더 */}
      <View style={ds.dashHeader}>
        <Text style={ds.dashHeaderLabel}>매장 관리자</Text>
        <View style={ds.dashHeaderRow}>
          <Text style={ds.dashHeaderName} numberOfLines={1}>{getStoreDisplayName(store)}</Text>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <PlanBadge plan={effectivePlan} opsAddon={hasOpsAddon(store, scopeBranchIdx)} />
            {/* 78차 64차: 총관리자 화면에만 있던 "플랜 안내"를 매장관리자도 볼 수 있게 */}
            <TextButton label="플랜 안내" onPress={() => setShowPlanInfo(true)} textStyle={{ fontSize: 11 }} />
          </View>
        </View>
      </View>

      <Modal visible={showPlanInfo} animationType="slide" onRequestClose={() => setShowPlanInfo(false)}>
        <View style={{ flex: 1, backgroundColor: BG }}>
          <AppHeader
            centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>플랜 안내</Text>}
            rightElement={<TextButton label="✕ 닫기" onPress={() => setShowPlanInfo(false)} textStyle={{ fontSize: 14, color: TEXT_MUTED }} style={{ alignSelf: 'flex-end' }} />}
          />
          <ScrollView contentContainerStyle={{ padding: 16 }}>
            <PlanInfoView />
          </ScrollView>
        </View>
      </Modal>

      {/* 핵심 지표 */}
      <Card>
        <CardTitle>핵심 지표</CardTitle>
        <View style={ds.statsGrid}>
          {[
            { Icon: TodayRevenueIcon, label: '오늘 매출',   value: `${todayRev.toLocaleString()}원` },
            { Icon: MenuReservationIcon, label: '이번달 매출', value: `${thisRev.toLocaleString()}원` },
            { Icon: MonthlyBookingsIcon, label: '이번달 예약', value: `${sumReservationCount(thisAll)}건` },
            { Icon: MonthlyCancelsIcon, label: '이번달 취소', value: `${cancelCount}건` },
            { Icon: OccupancyGaugeIcon, label: '가동률', value: occupancyRate != null ? `${occupancyRate}%` : '-' },
          ].map((s, idx) => (
            <View key={s.label} style={[ds.statItem, idx === 0 && ds.statItemHighlight]}>
              {s.Icon ? <View style={{marginBottom:0}}><s.Icon size={22} color={GOLD} /></View> : <Text style={{ fontSize: 22 }}>{s.icon}</Text>}
              <Text style={[ds.statValue, idx === 0 && ds.statValueHighlight]}>{s.value}</Text>
              <Text style={ds.statLabel}>{s.label}</Text>
            </View>
          ))}
        </View>
        {/* 78차 38차: "가동률"이 뭘 뜻하는지 어디에도 설명이 없다는 피드백 — 계산 기준을
            한 줄로 명시(전환율은 아래 UNLOCK 기여도 카드에 이미 계산 기준 문구가 있음) */}
        <Text style={ds.metricHint}>가동률 = 이번달 예약 건수 ÷ (테마별 하루 예약 가능 슬롯 수 합계 × 이번달 경과일)</Text>
        {/* 전달 대비 배너 */}
        <View style={ds.compareBanner}>
          <Text style={{ color: TEXT_SEC, fontSize: 13 }}>전달 대비</Text>
          <Text style={[ds.compareRate, {
            color: diffRate === null ? TEXT_MUTED : diffRate >= 0 ? GREEN : RED
          }]}>
            {diffRate === null
              ? `${new Date().getDate()}일차 집계 중`
              : diffRate >= 0 ? `▲ ${diffRate}%` : `▼ ${Math.abs(diffRate)}%`}
          </Text>
          <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>
            (전달: {prevRev.toLocaleString()}원)
          </Text>
        </View>
      </Card>

      {/* 78차: 고객 리뷰 답변 바로가기 — 지금까지 알림을 눌러야만 접근 가능했음 */}
      <TouchableOpacity
        onPress={() => navigation.navigate('StoreAdminOps', { initialSettingsView: 'reviews' })}
        activeOpacity={0.8}
      >
        <Card style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <ContribReviewIcon size={22} color={GOLD} />
          <View style={{ flex: 1 }}>
            <Text style={{ color: TEXT, fontSize: 14, fontWeight: '700' }}>고객 리뷰에 답변하기</Text>
            <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 2 }}>
              {unansweredCount > 0 ? `아직 답변하지 않은 리뷰 ${unansweredCount}건` : '모든 리뷰에 답변했어요'}
            </Text>
          </View>
          {unansweredCount > 0 && (
            <View style={{ backgroundColor: GOLD, borderRadius: 10, minWidth: 20, height: 20, alignItems: 'center', justifyContent: 'center', paddingHorizontal: 5 }}>
              <Text style={{ color: '#1A1A24', fontSize: 11, fontWeight: '800' }}>{unansweredCount}</Text>
            </View>
          )}
          <Text style={{ color: TEXT_MUTED, fontSize: 16 }}>›</Text>
        </Card>
      </TouchableOpacity>

      {/* 55차: UNLOCK 기여도 카드, 56차: 프리미엄 플랜 게이트, 59차: 블러 업셀로 교체 */}
      {/* 80차 후속: 방탈출/체험형을 둘 다 운영하는 매장은 두 블록으로 분리, 한쪽만
          있으면 기존과 동일하게 단일 블록(ContribBlock, formatLabel 없이) */}
      <Card>
        <CardTitle Icon={LinkIcon}>UNLOCK 기여도</CardTitle>
        {roomThemes.length > 0 && (
          <ContribBlock themes={roomThemes} records={roomRecords} favCount={favCountRoom}
            effectivePlan={effectivePlan} formatLabel={showThemes.length > 0 ? '방탈출' : null} />
        )}
        {showThemes.length > 0 && (
          <View style={roomThemes.length > 0 ? { marginTop: 16, borderTopWidth: 1, borderTopColor: BORDER, paddingTop: 16 } : null}>
            <ContribBlock themes={showThemes} records={showRecords} favCount={favCountShow}
              effectivePlan={effectivePlan} formatLabel={roomThemes.length > 0 ? '체험형' : null} />
          </View>
        )}
      </Card>

      {/* 65차: 오늘 예약 미리보기 */}
      {(() => {
        const todayBookings = records
          .filter(r => r.date === TODAY() && !r.cancelled)
          .sort((a, b) => (a.time || '').localeCompare(b.time || ''));
        return (
          <Card>
            <CardTitle Icon={TodayBookingClipboardIcon}>오늘 예약 ({todayBookings.length}건)</CardTitle>
            {todayBookings.length === 0 ? (
              <Text style={{ color: TEXT_MUTED, fontSize: 13, textAlign: 'center', fontStyle: 'italic', paddingVertical: 8 }}>
                오늘 예약이 없어요.
              </Text>
            ) : (
              <View>
                {todayBookings.slice(0, 5).map(r => {
                  const statusCfg = r.success === true
                    ? { label: '완료', bg: COLORS.greenBg, color: GREEN }
                    : r.success === false
                    ? { label: '실패', bg: COLORS.redBg, color: RED }
                    : { label: '예정', bg: COLORS.goldBg, color: GOLD };
                  return (
                    <View key={r.id} style={ds.timelineRow}>
                      <Text style={ds.timelineTime}>{r.time || '-'}</Text>
                      <View style={ds.timelineDivider} />
                      <View style={{ flex: 1 }}>
                        <Text style={{ color: TEXT, fontSize: 14, fontWeight: '600' }} numberOfLines={1}>{r.productName || '-'}</Text>
                        <IconLabel Icon={PeopleIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }} style={{ marginTop: 2 }}>{r.people}인</IconLabel>
                      </View>
                      <View style={[ds.timelineBadge, { backgroundColor: statusCfg.bg }]}>
                        <Text style={[ds.timelineBadgeText, { color: statusCfg.color }]}>{statusCfg.label}</Text>
                      </View>
                    </View>
                  );
                })}
                {todayBookings.length > 5 && (
                  <Text style={{ color: TEXT_MUTED, fontSize: 12, textAlign: 'center', marginTop: 8 }}>
                    +{todayBookings.length - 5}건 더 있어요 → 예약 탭에서 확인
                  </Text>
                )}
              </View>
            )}
          </Card>
        );
      })()}
    </ScrollView>
  );
}

// ─── 58차: 통계 탭 — 원래 홈 탭에 있던 상세 통계를 분리 ────────
function StatsTab({ records, store, storeId, scopeBranchIdx = null }) {
  const [selectedMonth, setSelectedMonth] = useState(THIS_M());
  const [downloadingInvoice, setDownloadingInvoice] = useState(false);
  const dailyChartScrollRef = useRef(null); // 78차 39차: 일별 매출 차트 오늘 위치로 자동 스크롤

  // 78차 39차: PICK 무제한 등록 — 무료 슬롯 초과분 요금을 정산 요약에도 반영
  // 78차 43차: "오늘 기준 활성" 개수를 선택한 달(최근 12개월, 인보이스 다운로드 포함)에도
  // 그대로 썼던 버그 — 과거 달을 고르면 그 달의 실제 PICK 추가요금이 아니라 오늘 시점
  // 활성 개수가 표시/PDF에 찍히고 있었음. selectedMonth와 겹치는 기간으로 판정.
  const [paidPickSlotCount, setPaidPickSlotCount] = useState(0);
  useEffect(() => {
    if (!storeId) return;
    // 79차: [버그 수정] scopeBranchIdx 전달 — 매출/테마개수/수수료/구독료는 이미
    // 지점 단위로 스코프되는데 이 값만 매장 전체 기준이라 지점을 골라 봐도 다른
    // 지점의 PICK 추가요금까지 그대로 합산돼 표시/PDF에 찍히고 있었음(fork로 발견).
    getPaidPickSlotCountForMonth(storeId, selectedMonth, scopeBranchIdx).then(setPaidPickSlotCount).catch(() => setPaidPickSlotCount(0));
  }, [storeId, selectedMonth, scopeBranchIdx]);
  const pickAddonFee = getPickAddonFee(paidPickSlotCount);

  // 78차: PREMIUM "UNLOCK 내 위치" 카드의 업계 평균 — getIndustryAverageCF(functions/index.js)
  // 서버 집계 결과. PREMIUM 미만 매장은 카드 자체가 잠겨 있어 호출하지 않는다.
  const [industryAvg, setIndustryAvg] = useState(null);
  // 78차 62차: plan이 지점별로 다를 수 있어 scopeBranchIdx 기준 유효 plan으로 게이트
  const effectivePlan = getEffectivePlan(store, scopeBranchIdx);
  const isPremium = planAtLeast(effectivePlan, 'premium');
  useEffect(() => {
    if (!isPremium) return;
    let cancelled = false;
    httpsCallable(functions, 'getIndustryAverageCF')()
      .then((res) => { if (!cancelled) setIndustryAvg(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isPremium]);

  // 75차: DashboardTab과 동일하게 pending(결제/입금 확인 전) 건 제외 — 통계 탭도 매출을
  // 그대로 노출하는 화면이라 같은 기준을 안 맞추면 두 탭 숫자가 서로 달라질 수 있음
  // 78차 44차: 모집 일괄예약은 참가자별로 문서가 여러 개라 revenueDuplicate:true인
  // 문서(그룹당 첫 참가자를 제외한 나머지)는 매출 집계에서 제외 — 예약 건수 집계
  // (totalReservationCount 등, 별도 배열)에는 영향 없음.
  // 78차 55차: "UNLOCK 내 위치"의 "이번달 예약 건수"가 매출용 thisR.length를 그대로
  // 써서 getIndustryAverageCF의 avgCount(revenueDuplicate 필터 없는 실제 건수)와 기준이
  // 달라 항상 실제보다 적게 비교되던 버그 — 건수 전용 activeAll/thisAll 분리.
  const active    = records.filter(r => !r.cancelled && r.paymentStatus !== 'pending' && r.revenueDuplicate !== true);
  const activeAll = records.filter(r => !r.cancelled && r.paymentStatus !== 'pending');
  const thisR     = active.filter(r => r.date?.startsWith(THIS_M()));
  const thisAll   = activeAll.filter(r => r.date?.startsWith(THIS_M()));
  const prevR     = active.filter(r => r.date?.startsWith(PREV_M()));
  const selR      = active.filter(r => r.date?.startsWith(selectedMonth));
  const selAll    = activeAll.filter(r => r.date?.startsWith(selectedMonth));

  // 80차 후속: "UNLOCK 내 위치"를 방탈출/체험형으로 분리 — 이번달 건수·매출을 형식별로
  // 나누고, 체험형은 "탈출 성공률" 대신 "정원 소진율"(판매좌석÷정원) 계산.
  const isShowR = r => r.bookingFormat === 'show';
  const thisRoomAll = thisAll.filter(r => !isShowR(r)), thisShowAll = thisAll.filter(isShowR);
  const thisRoomR   = thisR.filter(r => !isShowR(r)),   thisShowR   = thisR.filter(isShowR);
  const thisRoomRev = thisRoomR.reduce((s, r) => s + (r.price || 0), 0);
  const thisShowRev = thisShowR.reduce((s, r) => s + (r.price || 0), 0);
  // 체험형 테마 목록(캐파 계산용) + 형식별 테마 보유 여부
  const showThemesForOccupancy = [];
  let hasRoomThemes = false, hasShowThemes = false;
  (store?.branches || []).forEach((b, bi) => {
    if (b.isDeleted === true || (scopeBranchIdx !== null && bi !== scopeBranchIdx)) return;
    (b.themes || []).forEach((t) => {
      if (t.isDeleted === true) return;
      if (t.bookingFormat === 'show') { showThemesForOccupancy.push(t); hasShowThemes = true; }
      else hasRoomThemes = true;
    });
  });
  // 80차 후속: [버그 수정] thisShowAll(revenueDuplicate 포함)을 그대로 합산해서, 모집
  // 그룹예약 참가자들이 전부 같은 people(=totalSlots)을 들고 있는 문서 N개가 그대로
  // 다 더해져 정원 소진율이 참가자 수배로 부풀려지고 있었음(4인 그룹이 1회 예약해도
  // 4×4=16으로 집계되는 식) — thisShowR(revenueDuplicate!==true로 이미 걸러진 배열)로
  // 교체. 캐파도 "예약이 있었던 슬롯만 분모에 잡히는" 기존 방식(빈 회차가 분모에서
  // 아예 빠져 소진율이 부풀려지던 결함) 대신 DashboardTab과 동일하게 테마의 실제
  // 회차 수 기준으로 계산.
  const showFilledSum = calcShowFilled(thisShowR);
  const showCapacitySum = calcShowCapacity(showThemesForOccupancy, new Date().getDate());
  const myOccupancyRate = showCapacitySum > 0 ? Math.round((showFilledSum / showCapacitySum) * 100) : null;

  // 59차: 비교 기준점 카드에서 사용
  const thisRev   = thisR.reduce((s, r) => s + (r.price || 0), 0);

  // 일별 매출 (최근 30일)
  // 78차: toISOString()(UTC)이던 것을 toLocalYMD로 교체 — 자정~오전9시(KST) 사이엔
  // 실제 날짜보다 하루 이른 키가 생겨 그 시간대에 들어온 매출이 엉뚱한 날짜 칸에 잡히던 버그.
  const dailyMap = {};
  for (let i = 29; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    dailyMap[toLocalYMD(d)] = 0;
  }
  active.forEach(r => { if (dailyMap[r.date] !== undefined) dailyMap[r.date] += r.price || 0; });
  const dailyEntries = Object.entries(dailyMap);
  const maxDaily = Math.max(...Object.values(dailyMap), 1);

  // 테마별 누적 매출
  const themeRevMap = {};
  active.forEach(r => {
    const n = r.productName || '기타';
    if (!themeRevMap[n]) themeRevMap[n] = { revenue: 0, count: 0 };
    themeRevMap[n].revenue += r.price || 0;
    themeRevMap[n].count += (Number(r.bulkCount) || 1);
  });
  const themeRevList = Object.entries(themeRevMap).sort((a, b) => b[1].revenue - a[1].revenue);

  // 62차: 어제/오늘, 지난주/이번주 비교 데이터
  // 78차: 전부 toLocalYMD로 교체(같은 이유, 위 dailyMap 주석 참고)
  const YESTERDAY = (() => { const d = new Date(); d.setDate(d.getDate() - 1); return toLocalYMD(d); })();
  const WEEK_START = (() => { const d = new Date(); d.setDate(d.getDate() - d.getDay()); return toLocalYMD(d); })();
  const LAST_WEEK_START = (() => { const d = new Date(); d.setDate(d.getDate() - d.getDay() - 7); return toLocalYMD(d); })();
  const LAST_WEEK_END   = (() => { const d = new Date(); d.setDate(d.getDate() - d.getDay() - 1); return toLocalYMD(d); })();

  const todayR     = active.filter(r => r.date === TODAY());
  const yesterdayR = active.filter(r => r.date === YESTERDAY);
  const thisWeekR  = active.filter(r => r.date >= WEEK_START && r.date <= TODAY());
  const lastWeekR  = active.filter(r => r.date >= LAST_WEEK_START && r.date <= LAST_WEEK_END);

  const todayRev     = todayR.reduce((s, r) => s + (r.price || 0), 0);
  const yesterdayRev = yesterdayR.reduce((s, r) => s + (r.price || 0), 0);
  const thisWeekRev  = thisWeekR.reduce((s, r) => s + (r.price || 0), 0);
  const lastWeekRev  = lastWeekR.reduce((s, r) => s + (r.price || 0), 0);

  const dayDiff  = yesterdayRev > 0 ? Math.round(((todayRev - yesterdayRev) / yesterdayRev) * 100) : null;
  const weekDiff = lastWeekRev  > 0 ? Math.round(((thisWeekRev - lastWeekRev) / lastWeekRev) * 100) : null;

  // 전달 vs 이번달 테마별 비교
  // 78차 36차: 기존엔 이번달/전달 예약 기록에 등장한 테마명만 모아서(allNames) 표를 만들어서,
  // 전달 예약이 하나도 없으면(신규 매장 첫 달 등) 표 자체가 통째로 "데이터가 없어요"로
  // 사라졌음 — 실제 등록된 테마 목록(store.branches, scopeBranchIdx 반영)을 기준으로 삼아
  // 예약 실적이 없어도 테마 자체는 항상 표에 나오게 하고, 전달 실적 여부를 별도로 표시.
  // 78차 47차: 소프트 삭제된 테마는 "항상 표에 나오는 현재 등록 테마" 목록에서 제외
  // (과거 실적이 있으면 아래 recordNames로 여전히 표시됨 — 이력만 보존, 강제 노출은 안 함)
  const scopedThemeNames = (store?.branches || []).flatMap((b, bi) =>
    (b.isDeleted === true || (scopeBranchIdx !== null && bi !== scopeBranchIdx)) ? [] : (b.themes || []).filter(t => t.isDeleted !== true).map(t => t.name)
  );
  const recordNames = [...new Set([...thisR.map(r => r.productName), ...prevR.map(r => r.productName)])];
  const allNames = [...new Set([...scopedThemeNames, ...recordNames])];
  const compareData = allNames.map(name => {
    const currRecords = thisR.filter(r => r.productName === name);
    const prevRecords = prevR.filter(r => r.productName === name);
    const curr = currRecords.reduce((s, r) => s + (r.price || 0), 0);
    const prev = prevRecords.reduce((s, r) => s + (r.price || 0), 0);
    const hasPrevData = prevRecords.length > 0;
    const pct  = hasPrevData && prev > 0 ? Math.round(((curr - prev) / prev) * 100) : null;
    return { name, curr, prev, pct, hasPrevData };
  }).sort((a, b) => b.curr - a.curr);

  // 월 선택 옵션 — 78차 32차: 인보이스 PDF 다운로드가 "최근 1년치까지"를 다뤄야 해서
  // 기존 6개월에서 12개월로 확장
  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - i);
    return toYM(d);
  });

  // 68차: StatsTab/MonthlyReportTab이 각자 revenue*discountRate/100 으로만
  // 계산해 fixed(정액)형 매장 정산액이 항상 잘못 표시되던 버그 — calcStoreFee로 통일
  // 72차: 지점 선택 중이면 해당 지점 테마 개수만 반영(정액제 매장 지점별 수수료 추정치)
  const selRev = selR.reduce((s, r) => s + (r.price || 0), 0);
  // 78차 47차: 지점 스코프일 때 getStoreThemeCount를 안 거쳐 소프트 삭제된 테마도
  // 그대로 세고 있었음(78차46차의 getStoreThemeCount 수정이 이 분기엔 적용 안 됨) — 통일.
  const themeCount = scopeBranchIdx !== null
    ? (store?.branches?.[scopeBranchIdx]?.themes || []).filter(t => t.isDeleted !== true).length
    : getStoreThemeCount(store);
  const fee    = calcStoreFee(store, selRev, themeCount, scopeBranchIdx);
  // 78차 59차: 이 카드가 매출 연동 수수료(calcStoreFee)만 계산하고 플랜 구독료
  // (getPlanFee)는 어디에도 반영을 안 하고 있었음 — 총관리자용 FeeTab/인보이스 PDF는
  // 76차에 이미 고쳤는데 이 매장관리자 화면만 빠져 있었음. 할인율이 100%라 실제로는
  // 0원이어도, "얼마짜리를 몇 % 할인받아 0원이 됐는지"가 안 보이면 마치 플랜 구독료
  // 자체가 집계에서 빠진 것처럼 오해할 수 있어 항상 표시.
  // 78차 62차: scopeBranchIdx가 null("전체")이면 getPlanFee가 지점별 plan/할인율을
  // 각자 반영해 합산한다 — 이전엔 store 최상위 값 하나만 봐서 지점이 몇 곳이든
  // 항상 같은(사실상 지점 1개분) 금액이 나오던 버그.
  const planFee = getPlanFee(store, scopeBranchIdx);
  const planDiscountRate = getPlanDiscountRate(store, scopeBranchIdx);
  const opsAddonFee = getOpsAddonFee(store, scopeBranchIdx);

  // 78차 32차: 인보이스(PDF) 다운로드 — 최근 1년치까지만(invoiceService가 재확인).
  const handleDownloadInvoice = async () => {
    try {
      setDownloadingInvoice(true);
      await generateAndShareInvoice({
        store, month: selectedMonth, revenue: selRev,
        reservationCount: sumReservationCount(selAll), themeCount, paidPickSlotCount, branchIdx: scopeBranchIdx,
      });
    } catch (e) {
      showAlert('다운로드 실패', e.message || '인보이스 생성에 실패했어요.');
    } finally {
      setDownloadingInvoice(false);
    }
  };

  return (
    <ScrollView contentContainerStyle={{ padding: 14 }} showsVerticalScrollIndicator={false}>

      {/* UNLOCK 내 위치 (premium 이상) */}
      <Card>
        <CardTitle Icon={StatsIcon}>UNLOCK 내 위치</CardTitle>
        {isPremium ? (
          <View style={{ gap: 16 }}>
            {/* 80차 후속: 방탈출/체험형을 둘 다 운영하면 소제목으로 분리, 한쪽만 있으면 기존과 동일 */}
            {hasRoomThemes && (
              <View>
                {hasShowThemes && <Text style={contrib.formatLabel}>방탈출</Text>}
                {[
                  { label: '이번달 예약 건수', mine: `${sumReservationCount(thisRoomAll)}건`,
                    avg: industryAvg?.room ? `${industryAvg.room.avgCount}건` : '집계 중', Icon: MonthlyBookingsIcon },
                  { label: '이번달 매출', mine: `${thisRoomRev.toLocaleString()}원`,
                    avg: industryAvg?.room ? `${industryAvg.room.avgRevenue.toLocaleString()}원` : '집계 중', Icon: PriceIcon },
                  // 79차: "이번달 예약 건수"/"이번달 매출"은 이번달(thisRoomAll/thisRoomRev) 기준인데
                  // 성공률만 active(전체 누적)로 계산해서 서버 industryAvg(이번달 기준)와
                  // 비교 시점이 어긋나 있었음(전수 정독으로 발견) — thisRoomR로 통일.
                  // 79차(후속): 위 수정과 별개로 분모 계산 자체가 `!== null`이라 결과 미기록
                  // 예약(success가 undefined인 레코드)까지 잘못 포함시킬 수 있었음 —
                  // HomeScreen.js에서 이미 고친 것과 동일한 유형(전수 정독 재점검으로 발견,
                  // 그때는 스코프만 고치고 이 부분은 놓쳤음). `=== true || === false`로 교체.
                  { label: '탈출 성공률',
                    mine: thisRoomR.filter(r => r.success === true || r.success === false).length > 0
                      ? `${Math.round(thisRoomR.filter(r => r.success === true).length / thisRoomR.filter(r => r.success === true || r.success === false).length * 100)}%`
                      : '-',
                    avg: industryAvg?.room?.avgSuccessRate != null ? `${industryAvg.room.avgSuccessRate}%` : '집계 중', Icon: EscapeSuccessRateIcon },
                ].map(({ label, mine, avg, icon, Icon }) => (
                  <View key={label} style={{ flexDirection: 'row', alignItems: 'center',
                    paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: BORDER }}>
                    {Icon ? <View style={{marginRight:10}}><Icon size={16} color={GOLD} /></View> : <Text style={{ fontSize: 16, marginRight: 10 }}>{icon}</Text>}
                    <View style={{ flex: 1 }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>{label}</Text>
                      <Text style={{ color: GOLD, fontSize: 13, fontWeight: '800', marginTop: 2 }}>{mine}</Text>
                    </View>
                    <View style={{ alignItems: 'flex-end' }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>UNLOCK 평균</Text>
                      <Text style={{ color: TEXT_MUTED, fontSize: 12, fontWeight: '600', marginTop: 2 }}>{avg}</Text>
                    </View>
                  </View>
                ))}
              </View>
            )}
            {hasShowThemes && (
              <View>
                {hasRoomThemes && <Text style={contrib.formatLabel}>체험형</Text>}
                {[
                  { label: '이번달 예약 건수', mine: `${sumReservationCount(thisShowAll)}건`,
                    avg: industryAvg?.show ? `${industryAvg.show.avgCount}건` : '집계 중', Icon: MonthlyBookingsIcon },
                  { label: '이번달 매출', mine: `${thisShowRev.toLocaleString()}원`,
                    avg: industryAvg?.show ? `${industryAvg.show.avgRevenue.toLocaleString()}원` : '집계 중', Icon: PriceIcon },
                  // 80차 후속: 체험형은 탈출 성공/실패 개념이 없어 "정원 소진율"(판매좌석÷정원)로 대체
                  { label: '정원 소진율', mine: myOccupancyRate != null ? `${myOccupancyRate}%` : '-',
                    avg: industryAvg?.show?.avgOccupancyRate != null ? `${industryAvg.show.avgOccupancyRate}%` : '집계 중', Icon: OccupancyGaugeIcon },
                ].map(({ label, mine, avg, icon, Icon }) => (
                  <View key={label} style={{ flexDirection: 'row', alignItems: 'center',
                    paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: BORDER }}>
                    {Icon ? <View style={{marginRight:10}}><Icon size={16} color={GOLD} /></View> : <Text style={{ fontSize: 16, marginRight: 10 }}>{icon}</Text>}
                    <View style={{ flex: 1 }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>{label}</Text>
                      <Text style={{ color: GOLD, fontSize: 13, fontWeight: '800', marginTop: 2 }}>{mine}</Text>
                    </View>
                    <View style={{ alignItems: 'flex-end' }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>UNLOCK 평균</Text>
                      <Text style={{ color: TEXT_MUTED, fontSize: 12, fontWeight: '600', marginTop: 2 }}>{avg}</Text>
                    </View>
                  </View>
                ))}
              </View>
            )}
            <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 4, textAlign: 'center' }}>
              {industryAvg ? `* 활성 매장 ${(industryAvg.room?.sampleSize ?? industryAvg.show?.sampleSize ?? 0)}곳 기준 이번달 평균` : '* 업계 평균 집계 중...'}
            </Text>
          </View>
        ) : (
          // 78차 18차: DashboardTab의 "UNLOCK 기여도" 블러 업셀과 톤 통일 — 기존엔
          // 데이터 없이 안내 문구만 있었는데, 흐리게 처리된 실제 수치 위에 잠금 카드가
          // 앞에 나오는 방식으로 교체(내 수치는 실제값 그대로, 업계 평균만 비교 정보라
          // 블러 처리 대상).
          <View style={contrib.blurWrap}>
            <View style={contrib.blurContent} pointerEvents="none">
              <View style={{ gap: 10 }}>
                {[
                  { label: '이번달 예약 건수', mine: `${sumReservationCount(thisAll)}건`, Icon: MonthlyBookingsIcon },
                  { label: '이번달 매출', mine: `${thisRev.toLocaleString()}원`, Icon: PriceIcon },
                  // 79차: 위 premium 분기와 동일하게 이번달(thisR) 기준 + `=== true||=== false`
                  // 분모(undefined 결과 미기록 예약 제외)로 통일
                  { label: '탈출 성공률',
                    mine: thisR.filter(r => r.success === true || r.success === false).length > 0
                      ? `${Math.round(thisR.filter(r => r.success === true).length / thisR.filter(r => r.success === true || r.success === false).length * 100)}%`
                      : '-', Icon: EscapeSuccessRateIcon },
                ].map(({ label, mine, icon, Icon }) => (
                  <View key={label} style={{ flexDirection: 'row', alignItems: 'center',
                    paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: BORDER }}>
                    {Icon ? <View style={{marginRight:10}}><Icon size={16} color={GOLD} /></View> : <Text style={{ fontSize: 16, marginRight: 10 }}>{icon}</Text>}
                    <View style={{ flex: 1 }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>{label}</Text>
                      <Text style={{ color: GOLD, fontSize: 13, fontWeight: '800', marginTop: 2 }}>{mine}</Text>
                    </View>
                    <View style={{ alignItems: 'flex-end' }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>UNLOCK 평균</Text>
                      <Text style={{ color: TEXT_MUTED, fontSize: 12, fontWeight: '600', marginTop: 2 }}>-</Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
            <View style={contrib.blurOverlay}>
              <PlanLockedIcon size={40} />
              <Text style={contrib.blurTitle}>PREMIUM에서 확인하세요</Text>
              <Text style={contrib.blurDesc}>
                우리 매장이 UNLOCK 전체 매장 중{'\n'}어느 수준인지 비교해드려요
              </Text>
              <View style={contrib.blurBadge}>
                <Text style={contrib.blurBadgeTxt}>예약 건수 · 매출 · 탈출 성공률</Text>
              </View>
              <Text style={contrib.blurFooter}>총괄 관리자에게 플랜 전환을 요청하세요</Text>
            </View>
          </View>
        )}
      </Card>

      {/* 단기 비교 */}
      <Card>
        <CardTitle Icon={MenuReservationIcon}>단기 비교</CardTitle>
        <View style={{ gap: 12 }}>
          {/* 어제 vs 오늘 */}
          <View style={{ backgroundColor: SURFACE2, borderRadius: 10, padding: 12, borderWidth: 1, borderColor: BORDER }}>
            <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 8 }}>어제 vs 오늘</Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <View style={{ alignItems: 'center', flex: 1 }}>
                <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>어제</Text>
                <Text style={{ color: TEXT_SEC, fontSize: 14, fontWeight: '700', marginTop: 2 }}>{yesterdayRev.toLocaleString()}원</Text>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 1 }}>{yesterdayR.length}건</Text>
              </View>
              <View style={{ alignItems: 'center', paddingHorizontal: 10 }}>
                <Text style={{ color: dayDiff === null ? TEXT_MUTED : dayDiff >= 0 ? GREEN : RED, fontSize: 16, fontWeight: '900' }}>
                  {dayDiff === null ? '-' : dayDiff >= 0 ? `▲${dayDiff}%` : `▼${Math.abs(dayDiff)}%`}
                </Text>
              </View>
              <View style={{ alignItems: 'center', flex: 1 }}>
                <Text style={{ color: GOLD, fontSize: 10 }}>오늘</Text>
                <Text style={{ color: GOLD, fontSize: 14, fontWeight: '700', marginTop: 2 }}>{todayRev.toLocaleString()}원</Text>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 1 }}>{todayR.length}건</Text>
              </View>
            </View>
          </View>
          {/* 지난주 vs 이번주 */}
          <View style={{ backgroundColor: SURFACE2, borderRadius: 10, padding: 12, borderWidth: 1, borderColor: BORDER }}>
            <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 8 }}>지난주 vs 이번주</Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <View style={{ alignItems: 'center', flex: 1 }}>
                <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>지난주</Text>
                <Text style={{ color: TEXT_SEC, fontSize: 14, fontWeight: '700', marginTop: 2 }}>{lastWeekRev.toLocaleString()}원</Text>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 1 }}>{lastWeekR.length}건</Text>
              </View>
              <View style={{ alignItems: 'center', paddingHorizontal: 10 }}>
                <Text style={{ color: weekDiff === null ? TEXT_MUTED : weekDiff >= 0 ? GREEN : RED, fontSize: 16, fontWeight: '900' }}>
                  {weekDiff === null ? '-' : weekDiff >= 0 ? `▲${weekDiff}%` : `▼${Math.abs(weekDiff)}%`}
                </Text>
              </View>
              <View style={{ alignItems: 'center', flex: 1 }}>
                <Text style={{ color: GOLD, fontSize: 10 }}>이번주</Text>
                <Text style={{ color: GOLD, fontSize: 14, fontWeight: '700', marginTop: 2 }}>{thisWeekRev.toLocaleString()}원</Text>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 1 }}>{thisWeekR.length}건</Text>
              </View>
            </View>
          </View>
        </View>
      </Card>

      {/* 일별 매출 (최근 30일) — 날짜 가독성 개선 */}
      {/* 78차 39차: 오늘이 항상 스크롤 맨 오른쪽 끝에 있어 매번 끝까지 밀어야 보이던 것 —
          화면 진입 시 자동으로 오른쪽 끝(오늘)으로 스크롤 */}
      <Card>
        <CardTitle>일별 매출 (최근 30일)</CardTitle>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}
          ref={dailyChartScrollRef}
          onContentSizeChange={() => dailyChartScrollRef.current?.scrollToEnd({ animated: false })}
          contentContainerStyle={{ paddingBottom: 4 }}>
          <View style={{ width: Math.max(dailyEntries.length * 22, 300) }}>
            {/* 바차트 */}
            <View style={{ flexDirection: 'row', alignItems: 'flex-end', height: 120,
              borderBottomWidth: 1, borderBottomColor: BORDER, gap: 2, paddingBottom: 2 }}>
              {dailyEntries.map(([date, rev], idx) => {
                const h = Math.max(Math.round((rev / maxDaily) * 110), rev > 0 ? 4 : 2);
                const isToday  = date === TODAY();
                // 78차: toISOString()(UTC)로 어제를 구하면 한국 새벽 0~9시엔 실제보다 하루
                // 이른 날짜가 나와 isToday/isYester 두 배지가 동시에 어긋날 수 있었음 — TODAY()와
                // 같은 로컬 계산(toLocalYMD)으로 통일.
                const isYester = date === (() => { const d = new Date(); d.setDate(d.getDate()-1); return toLocalYMD(d); })();
                return (
                  <View key={date} style={{ flex: 1, height: '100%', justifyContent: 'flex-end',
                    alignItems: 'center', position: 'relative' }}>
                    {/* 금액 레이블 — 매출 있는 날마다 표시 (짧게) */}
                    {rev > 0 && (
                      <Text style={{ fontSize: 6, color: isToday ? GOLD : TEXT_MUTED,
                        marginBottom: 1, textAlign: 'center' }} numberOfLines={1}>
                        {/* 72차: k 표기 제거, 만 단위로 표기법 통일 */}
                        {rev >= 10000 ? `${(rev/10000).toFixed(rev % 10000 === 0 ? 0 : 1)}만` : `${rev}`}
                      </Text>
                    )}
                    <View style={{ width: '80%', borderRadius: 2,
                      height: h,
                      backgroundColor: isToday  ? GOLD
                                     : isYester ? GOLD + '99'
                                     : 'rgba(212,168,67,0.3)',
                    }} />
                  </View>
                );
              })}
            </View>
            {/* 날짜 레이블 — 1일, 7일, 14일, 21일, 28일 + 오늘 표시 */}
            <View style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 2, marginTop: 3 }}>
              {dailyEntries.map(([date]) => {
                const day = Number(date.slice(-2));
                const isToday = date === TODAY();
                const showLabel = isToday || day === 1 || day % 7 === 0;
                return (
                  <View key={date} style={{ flex: 1, alignItems: 'center' }}>
                    {showLabel ? (
                      <Text style={{ fontSize: 7, color: isToday ? GOLD : TEXT_MUTED,
                        fontWeight: isToday ? '800' : '400' }} numberOfLines={1}>
                        {isToday ? '오늘' : `${day}일`}
                      </Text>
                    ) : null}
                  </View>
                );
              })}
            </View>
          </View>
        </ScrollView>
        {/* 범례 */}
        <View style={{ flexDirection: 'row', gap: 12, marginTop: 8, flexWrap: 'wrap' }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
            <View style={{ width: 8, height: 8, borderRadius: 2, backgroundColor: GOLD }} />
            <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>오늘</Text>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
            <View style={{ width: 8, height: 8, borderRadius: 2, backgroundColor: GOLD + '99' }} />
            <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>어제</Text>
          </View>
          <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>
            최고 {Math.max(...Object.values(dailyMap)).toLocaleString()}원 / 좌←과거 · 우→오늘
          </Text>
        </View>
      </Card>

      {/* 64차: 순서 4 — 전달 vs 이번달 테마별 비교 */}
      <Card>
        <CardTitle>{mLabel(PREV_M())} vs {mLabel(THIS_M())} 테마별 비교</CardTitle>
        {compareData.length === 0
          ? <Text style={{ color: TEXT_MUTED, fontStyle: 'italic', textAlign: 'center' }}>데이터가 없어요.</Text>
          : (
            <View>
              <View style={ds.tableHeader}>
                <Text style={[ds.th, { flex: 2 }]}>테마명</Text>
                <Text style={[ds.th, { flex: 1.2 }]}>{mLabel(PREV_M())}</Text>
                <Text style={[ds.th, { flex: 1.2 }]}>{mLabel(THIS_M())}</Text>
                <Text style={[ds.th, { flex: 0.8, textAlign: 'center' }]}>증감</Text>
              </View>
              {compareData.map(({ name, curr, prev, pct, hasPrevData }) => (
                <View key={name} style={ds.tableRow}>
                  <Text style={[ds.td, { flex: 2 }]} numberOfLines={1}>{name}</Text>
                  {/* 78차 36차: "0원"만 보이면 실적이 0원인 건지 전달 데이터 자체가 없는
                      건지 구분이 안 됐음 — 전달 예약 기록이 아예 없는 경우 명시.
                      78차 38차: 문구가 너무 길다는 피드백으로 "-" 축약(옆의 회색·이탤릭
                      스타일이 이미 "데이터 없음"이라는 의미를 전달하고 있어 짧아도 안 헷갈림) */}
                  <Text style={[ds.td, { flex: 1.2 }, !hasPrevData && { color: TEXT_MUTED, fontStyle: 'italic' }]}>
                    {hasPrevData ? `${prev.toLocaleString()}원` : '-'}
                  </Text>
                  <Text style={[ds.td, { flex: 1.2 }]}>{curr.toLocaleString()}원</Text>
                  <View style={{ flex: 0.8, alignItems: 'center' }}>
                    <View style={[ds.diffBadge,
                      pct === null ? ds.diffNew : pct >= 0 ? ds.diffUp : ds.diffDown]}>
                      <Text style={[ds.diffText,
                        { color: pct === null ? TEXT_MUTED : pct >= 0 ? GREEN : RED }]}>
                        {pct === null ? '신규' : pct >= 0 ? `▲${pct}%` : `▼${Math.abs(pct)}%`}
                      </Text>
                    </View>
                  </View>
                </View>
              ))}
            </View>
          )}
      </Card>

      {/* 64차: 순서 5 — 테마별 누적 매출 */}
      <Card>
        <CardTitle>테마별 누적 매출</CardTitle>
        {themeRevList.length === 0
          ? <Text style={{ color: TEXT_MUTED, fontStyle: 'italic', textAlign: 'center' }}>데이터가 없어요.</Text>
          : (
            <View>
              <View style={ds.tableHeader}>
                <Text style={[ds.th, { flex: 2 }]}>테마명</Text>
                <Text style={[ds.th, { flex: 1 }]}>예약</Text>
                <Text style={[ds.th, { flex: 1.5 }]}>매출</Text>
              </View>
              {themeRevList.map(([name, data]) => (
                <View key={name} style={ds.tableRow}>
                  <Text style={[ds.td, { flex: 2 }]} numberOfLines={1}>{name}</Text>
                  <Text style={[ds.td, { flex: 1 }]}>{data.count}건</Text>
                  <Text style={[ds.td, { flex: 1.5, color: GOLD }]}>{data.revenue.toLocaleString()}원</Text>
                </View>
              ))}
            </View>
          )}
      </Card>

      {/* 64차: 순서 6 — 월별 정산 요약. 80차 후속: plan이 아니라 매장관리자 기능
          애드온(opsAddon) 기준으로 게이트 — 노출 등급과 무관하게 이 기능만 별도 구매 */}
      {hasOpsAddon(store, scopeBranchIdx) ? (
        <Card>
          <CardTitle Icon={ReceiptIcon}>월별 정산 요약</CardTitle>
          <ScrollView horizontal showsHorizontalScrollIndicator={false}
            contentContainerStyle={{ gap: 8, paddingBottom: 4 }}>
            {monthOptions.map(m => (
              <TouchableOpacity key={m}
                style={[ds.monthChip, selectedMonth === m && ds.monthChipActive]}
                onPress={() => setSelectedMonth(m)}>
                <Text style={[ds.monthChipText, selectedMonth === m && { color: GOLD, fontWeight: '800' }]}>
                  {m}
                </Text>
              </TouchableOpacity>
            ))}
          </ScrollView>
          <View style={{ marginTop: 14, gap: 10 }}>
            {[
              [MenuReservationIcon, '대상 월',      selectedMonth],
              [null, '총 예약',                            `${selAll.length}건`],
              [null, '총 매출',                            `${selRev.toLocaleString()}원`],
              [null, (scopeBranchIdx != null ? store?.branches?.[scopeBranchIdx]?.feeType : store?.feeType) === 'fixed'
                ? '매출 수수료 (정액)'
                : `매출 수수료 (${(scopeBranchIdx != null ? store?.branches?.[scopeBranchIdx]?.discountRate : store?.discountRate) || 0}%)`,
                `${fee.toLocaleString()}원`],
              [null, `플랜 구독료 (할인 ${planDiscountRate}%)`, `${planFee.toLocaleString()}원`],
              ...(opsAddonFee > 0 ? [[null, '매장관리자 기능 애드온', `${opsAddonFee.toLocaleString()}원`]] : []),
              ...(pickAddonFee > 0 ? [[null, `PICK 추가 요금 (${paidPickSlotCount}개)`, `${pickAddonFee.toLocaleString()}원`]] : []),
              [null, '정산 예정액',                        `${(selRev - fee - planFee - opsAddonFee - pickAddonFee).toLocaleString()}원`],
            ].map(([Icon, label, value]) => (
              <View key={label} style={{ flexDirection: 'row', justifyContent: 'space-between',
                paddingVertical: 6, borderBottomWidth: 1, borderBottomColor: BORDER }}>
                {Icon
                  ? <IconLabel Icon={Icon} size={12} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 13 }}>{label}</IconLabel>
                  : <Text style={{ color: TEXT_MUTED, fontSize: 13 }}>{label}</Text>}
                <Text style={{ color: TEXT, fontSize: 13, fontWeight: '700' }}>{value}</Text>
              </View>
            ))}
          </View>
          <SecondaryButton
            label={downloadingInvoice ? '생성 중...' : '인보이스 다운로드 (PDF)'}
            onPress={handleDownloadInvoice}
            disabled={downloadingInvoice}
            style={{ marginTop: 14 }}
          />
        </Card>
      ) : (
        <Card>
          <CardTitle Icon={ReceiptIcon}>월별 정산 요약</CardTitle>
          <View style={{ alignItems: 'center', paddingVertical: 14, gap: 8 }}>
            <PlanLockedIcon size={40} />
            <Text style={{ color: TEXT, fontSize: 13, fontWeight: '800' }}>매장관리자 기능 애드온이 필요해요</Text>
            <Text style={{ color: TEXT_MUTED, fontSize: 12, textAlign: 'center', lineHeight: 18 }}>
              월별 매출·수수료·정산 예정액을{'\n'}한눈에 확인할 수 있어요{'\n'}(운영팀에 문의하시면 추가하실 수 있어요)
            </Text>
            <View style={{ backgroundColor: GOLD + '15', borderRadius: 8, borderWidth: 1,
              borderColor: GOLD + '40', paddingHorizontal: 14, paddingVertical: 6, marginTop: 4 }}>
              <Text style={{ color: GOLD, fontSize: 11, fontWeight: '700' }}>
                총 매출 · 수수료 · 정산 예정액
              </Text>
            </View>
          </View>
        </Card>
      )}
    </ScrollView>
  );
}

const ds = StyleSheet.create({
  metricHint: { color: TEXT_MUTED, fontSize: 10.5, marginTop: 8, lineHeight: 14 },
  // 77차: design 폴더 매장관리자 콘솔 스펙 — 헤더(매장명+플랜뱃지)
  dashHeader: { marginBottom: 14 },
  dashHeaderLabel: { color: TEXT_MUTED, fontSize: 11, marginBottom: 2 },
  dashHeaderRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 10 },
  dashHeaderName: { color: TEXT, fontSize: 20, fontWeight: '700', flex: 1 },
  statsGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 10, marginBottom: 12 },
  statItem: { flex: 1, minWidth: '45%', backgroundColor: SURFACE2, borderRadius: 16, padding: 15,
    alignItems: 'center', gap: 4, borderWidth: 1, borderColor: BORDER },
  // 77차: 첫 KPI(오늘 매출) 하이라이트 — design 스펙의 "헤드라인 스탯" 카드
  statItemHighlight: { backgroundColor: 'rgba(216,174,82,0.06)', borderColor: 'rgba(216,174,82,0.2)' },
  statValue: { color: GOLD, fontSize: 16, fontWeight: '800' },
  statValueHighlight: { color: COLORS.goldLight },
  statLabel: { color: TEXT_MUTED, fontSize: 11 },
  // 77차: "오늘 예약" 타임라인 행 — time | divider | 테마+인원 | 상태뱃지
  timelineRow: { flexDirection: 'row', alignItems: 'center', gap: 12,
    paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: BORDER },
  timelineTime: { color: COLORS.goldLight, fontSize: 14, fontWeight: '700', width: 46 },
  timelineDivider: { width: 1, height: 28, backgroundColor: BORDER },
  timelineBadge: { borderRadius: 8, paddingVertical: 5, paddingHorizontal: 10 },
  timelineBadgeText: { fontSize: 11, fontWeight: '700' },
  compareBanner: { flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: SURFACE2,
    borderRadius: 8, padding: 12, borderWidth: 1, borderColor: BORDER },
  compareRate: { fontSize: 18, fontWeight: '900' },
  chart: { flexDirection: 'row', alignItems: 'flex-end', height: 100,
    borderBottomWidth: 1, borderBottomColor: BORDER, gap: 2 },
  barWrap: { flex: 1, height: '100%', justifyContent: 'flex-end', alignItems: 'center', position: 'relative' },
  bar: { width: '100%', borderRadius: 2, minHeight: 2 },
  todayLabel: { position: 'absolute', bottom: -16, fontSize: 8, color: GOLD },
  tableHeader: { flexDirection: 'row', paddingVertical: 6, borderBottomWidth: 1, borderBottomColor: BORDER, marginBottom: 2 },
  th: { color: GOLD, fontSize: 11, fontWeight: '700' },
  tableRow: { flexDirection: 'row', paddingVertical: 9, borderBottomWidth: 1, borderBottomColor: 'rgba(255,255,255,0.04)', alignItems: 'center' },
  td: { color: TEXT_SEC, fontSize: 12 },
  diffBadge: { borderRadius: 4, paddingHorizontal: 6, paddingVertical: 2 },
  diffUp:   { backgroundColor: COLORS.greenBg },
  diffDown: { backgroundColor: COLORS.redBg },
  diffNew:  { backgroundColor: 'rgba(255,255,255,0.06)' },
  diffText: { fontSize: 11, fontWeight: '700' },
  monthChip: { paddingHorizontal: 14, paddingVertical: 7, borderRadius: 20,
    borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  monthChipActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
  monthChipText: { color: TEXT_MUTED, fontSize: 12 },
});

// 55차: UNLOCK 기여도 카드 StyleSheet
const contrib = StyleSheet.create({
  // 80차 후속: 매장이 방탈출/체험형을 둘 다 운영할 때만 보이는 소제목
  formatLabel:        { color: GOLD, fontSize: 12, fontWeight: '800', marginBottom: 8 },
  item:               { flex: 1, backgroundColor: SURFACE2, borderRadius: 10, padding: 12,
                        alignItems: 'center', gap: 3, borderWidth: 1, borderColor: BORDER },
  value:              { fontSize: 16, fontWeight: '900' },
  label:              { color: TEXT_SEC, fontSize: 11, fontWeight: '700' },
  note:               { color: TEXT_MUTED, fontSize: 9, textAlign: 'center', lineHeight: 13 },
  comingSoonRow:      { flexDirection: 'row', gap: 10 },
  comingSoonItem:     { flex: 1, backgroundColor: SURFACE2, borderRadius: 10, padding: 12,
                        alignItems: 'center', gap: 4, borderWidth: 1,
                        borderColor: BORDER, borderStyle: 'dashed', opacity: 0.7 },
  comingSoonLabel:    { color: TEXT_MUTED, fontSize: 12, fontWeight: '700' },
  comingSoonBadge:    { backgroundColor: GOLD + '18', borderRadius: 6, borderWidth: 1,
                        borderColor: GOLD + '40', paddingHorizontal: 8, paddingVertical: 2 },
  comingSoonBadgeText:{ color: GOLD, fontSize: 9, fontWeight: '700' },
  hint:               { color: TEXT_MUTED, fontSize: 11, lineHeight: 16, marginTop: 10,
                        paddingTop: 10, borderTopWidth: 1, borderTopColor: BORDER },
  // 59차: 블러 업셀 스타일 (locked 방식 → 블러 오버레이 방식으로 교체)
  // 78차 18차: blurOverlay가 absolute라 부모 높이에 기여하지 않고, 실제 높이는
  // 아래 블러 처리된 가짜 데이터(blurContent)가 결정하는데, 오버레이 안내 문구(아이콘+
  // 제목+설명+배지+안내)가 그보다 더 크면 overflow:hidden에 잘려 보이던 버그 —
  // 오버레이 내용이 항상 들어갈 만큼 최소 높이 확보.
  blurWrap:           { position: 'relative', overflow: 'hidden', borderRadius: 8, minHeight: 210 },
  blurContent:        { opacity: 0.18 },
  blurOverlay:        { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        alignItems: 'center', justifyContent: 'center', gap: 6,
                        backgroundColor: BG + 'CC', borderRadius: 8, padding: 16 },
  blurTitle:          { color: TEXT, fontSize: 14, fontWeight: '900', textAlign: 'center' },
  blurDesc:           { color: TEXT_MUTED, fontSize: 12, textAlign: 'center', lineHeight: 18 },
  blurBadge:          { backgroundColor: GOLD + '18', borderRadius: 10, borderWidth: 1,
                        borderColor: GOLD + '40', paddingHorizontal: 12, paddingVertical: 5,
                        marginTop: 2 },
  blurBadgeTxt:       { color: GOLD, fontSize: 10, fontWeight: '700', textAlign: 'center' },
  blurFooter:         { color: TEXT_MUTED, fontSize: 10, marginTop: 4 },
  // 기존 locked 스타일 유지 (삭제 시 참조 에러 방지)
  lockedWrap:         { alignItems: 'center', paddingVertical: 8, gap: 8 },
  lockedTitle:        { color: TEXT, fontSize: 14, fontWeight: '800' },
  lockedDesc:         { color: TEXT_MUTED, fontSize: 12, textAlign: 'center', lineHeight: 18 },
  lockedBadgeRow:     { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center',
                        gap: 6, marginTop: 4 },
  lockedChip:         { backgroundColor: SURFACE2, borderRadius: 14, borderWidth: 1,
                        borderColor: BORDER, paddingHorizontal: 10, paddingVertical: 4 },
  lockedChipTxt:      { color: TEXT_MUTED, fontSize: 11, fontWeight: '600' },
  lockedFooter:       { color: TEXT_MUTED, fontSize: 10, marginTop: 8,
                        paddingTop: 8, borderTopWidth: 1, borderTopColor: BORDER },
});

// ─── 예약관리 ─────────────────────────────────────────────────
// 72차: 상단 상태 필터 탭이 너무 길다는 피드백 — 매장관리자가 실제로 궁금한 건
// "아직 결과를 안 넣은 예약"과 "취소된 예약"이지 성공/실패 자체를 걸러보는 일은
// 드물다고 판단해 5개 → 3개로 축소. 성공/실패 건수는 테마별 미니 배지로 계속 보임.
const STATUS_FILTERS = [
  { key: 'all',       label: '전체' },
  { key: 'pending',   label: '결과입력대기', Icon: HourglassIcon },
  { key: 'cancelled', label: '예약취소', Icon: CancelIcon },
];

// 테마 구분용 색상 팔레트 (51차: 테마 구분 목적의 의도적 다색 — 통일 제외, 보존)
const THEME_COLORS = [
  '#d4a843', '#60A5FA', '#4CAF50', '#ff6b35', '#a78bfa',
  '#34d399', '#f472b6', '#facc15', '#38bdf8', '#fb923c',
];
// 66차: 테마명 해시 기반 고정 색상 — 재시작해도 같은 테마는 같은 색
const getThemeColor = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return THEME_COLORS[hash % THEME_COLORS.length];
};

function ThemeSection({ themeName, themeImage, items, statusFilter, handleResult, openSuccessModal, dateFilter, onCancelByStore }) {
  // 62차: 오늘 날짜 필터일 때만 기본 열림, 나머지는 닫힘으로 시작해 스크롤 부담 감소
  const todayDefault = dateFilter === TODAY();
  const [open, setOpen] = useState(todayDefault);
  const themeColor = getThemeColor(themeName);

  const filtered = items.filter(r => {
    // 80차 후속: [버그 수정] 체험형은 탈출 성공/실패 개념이 없어 결과 입력 버튼 자체가
    // 없는데(success가 영원히 null), "결과입력대기" 필터가 이걸 구분 안 해서 아무리
    // 시간이 지나도 처리할 방법이 없는 체험형 예약이 이 탭에 계속 쌓여 진짜 처리 대기
    // 중인 방탈출 예약을 가리는 문제가 있었음 — 체험형은 이 필터에서 제외.
    if (statusFilter === 'pending')   return r.success === null && !r.cancelled && r.bookingFormat !== 'show';
    if (statusFilter === 'cancelled') return r.cancelled === true;
    return true;
  });

  const total     = items.length;
  const success   = items.filter(r => r.success === true).length;
  const fail      = items.filter(r => r.success === false).length;
  // 80차 후속: [버그 수정] 위 statusFilter==='pending' 필터는 이미 체험형을 제외했는데,
  // 같은 파일 안의 형제 코드인 이 헤더 집계는 놓쳐서 체험형 테마 섹션 헤더에 처리할
  // 게 없는데도 "⏳ N"이 영구히 찍히고 있었음(fork로 발견).
  const pending   = items.filter(r => r.success === null && !r.cancelled && r.bookingFormat !== 'show').length;
  const cancelled = items.filter(r => r.cancelled === true).length;
  const successRate = (success + fail) > 0 ? Math.round((success / (success + fail)) * 100) : null;

  return (
    <View style={[rv.themeSection, { borderLeftColor: themeColor, borderLeftWidth: 4 }]}>
      <TouchableOpacity style={rv.themeHeader} onPress={() => setOpen(v => !v)} activeOpacity={0.7}>

        {/* 테마 이미지 or 색상 플레이스홀더 */}
        {themeImage ? (
          <Image
            source={{ uri: themeImage }}
            style={rv.themeImg}
            resizeMode="cover"
          />
        ) : (
          <View style={[rv.themeImgPlaceholder, { backgroundColor: themeColor + '22', borderColor: themeColor + '55' }]}>
            <MenuEscapeIcon size={22} color={themeColor} />
          </View>
        )}

        <View style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 5, flexWrap: 'wrap' }}>
            <Text style={[rv.themeTitle, { color: themeColor }]} numberOfLines={1}>{themeName}</Text>
            <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>총 {total}건</Text>
            {successRate !== null && (
              <View style={[rv.miniStat, { borderColor: GREEN + '55', marginLeft: 'auto' }]}>
                <Text style={[rv.miniStatTxt, { color: GREEN }]}>성공률 {successRate}%</Text>
              </View>
            )}
          </View>
          <View style={{ flexDirection: 'row', gap: 6, flexWrap: 'wrap' }}>
            {pending   > 0 && <View style={[rv.miniStat, { borderColor: GOLD  + '55' }]}><IconLabel Icon={HourglassIcon} size={11} color={GOLD} textStyle={[rv.miniStatTxt, { color: GOLD     }]}>{pending}</IconLabel></View>}
            {success   > 0 && <View style={[rv.miniStat, { borderColor: GREEN + '55' }]}><IconLabel Icon={EscapeRecordSuccessIcon} size={11} color={GREEN} textStyle={[rv.miniStatTxt, { color: GREEN    }]}>{success}</IconLabel></View>}
            {fail      > 0 && <View style={[rv.miniStat, { borderColor: RED   + '55' }]}><IconLabel Icon={EscapeRecordFailIcon} size={11} color={RED} textStyle={[rv.miniStatTxt, { color: RED      }]}>{fail}</IconLabel></View>}
            {cancelled > 0 && <View style={[rv.miniStat, { borderColor: '#555'       }]}><IconLabel Icon={ReservationCancelIcon} size={11} color={TEXT_MUTED} textStyle={[rv.miniStatTxt, { color: TEXT_MUTED }]}>{cancelled}</IconLabel></View>}
          </View>
        </View>
        <Text style={{ color: themeColor, fontSize: 20, marginLeft: 4 }}>{open ? '▲' : '▼'}</Text>
      </TouchableOpacity>

      {open && (
        <View style={{ paddingHorizontal: 12, paddingBottom: 12 }}>
          {filtered.length === 0 ? (
            <View style={{ alignItems: 'center', paddingVertical: 16, gap: 8 }}>
              <EmptyReservationsIcon size={64} />
              <Text style={{ color: TEXT_MUTED, fontSize: 13, textAlign: 'center', fontStyle: 'italic' }}>
                해당하는 예약이 없어요.
              </Text>
            </View>
          ) : (() => {
              // 로컬 시간 기준 현재 시각 문자열
              const nowStr = (() => {
                const n = new Date();
                return n.getFullYear() + '-'
                  + String(n.getMonth() + 1).padStart(2, '0') + '-'
                  + String(n.getDate()).padStart(2, '0') + ' '
                  + String(n.getHours()).padStart(2, '0') + ':'
                  + String(n.getMinutes()).padStart(2, '0');
              })();
              return [...filtered]
                .sort((a, b) => {
                  const da = (a.date || '') + ' ' + (a.time || '');
                  const db = (b.date || '') + ' ' + (b.time || '');
                  return da.localeCompare(db);
                })
                .map(r => {
                  const rStr = (r.date || '') + ' ' + (r.time || '');
                  const isPastSlot = rStr < nowStr && !r.cancelled;
                  return (
                    <View key={r.id} style={[rv.item, r.cancelled && rv.itemCancelled, isPastSlot && { opacity: 0.45 }]}>
                      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                          <IconLabel Icon={MenuReservationIcon} size={12} color={TEXT} textStyle={{ color: TEXT, fontSize: 13, fontWeight: '700' }}>{r.date}</IconLabel>
                          <IconLabel Icon={MenuPointsIcon} size={12} color={TEXT} textStyle={{ color: TEXT, fontSize: 13, fontWeight: '700' }}>{r.time}</IconLabel>
                          {/* 80차 후속: [기능 추가] 모집 그룹예약은 참가자 수만큼 카드가 따로
                              생기는데 구분 표시가 전혀 없어, 매장관리자가 "같은 시간에 팀이
                              여러 개"로 착각하기 쉬웠음(fork로 발견) — 그룹임을 알리는 배지
                              추가(결과 입력은 이제 자동으로 그룹 전체에 반영되긴 하지만,
                              애초에 여러 장으로 보이는 이유 자체를 알 수 있게). */}
                          {r.recruitId && (
                            <View style={[rv.badge, { borderColor: PURPLE + '55' }]}>
                              <IconLabel Icon={PeopleIcon} size={11} color={PURPLE} textStyle={[rv.badgeText, { color: PURPLE }]}>그룹예약</IconLabel>
                            </View>
                          )}
                        </View>
                        <View style={{ flexDirection: 'row', gap: 4, flexWrap: 'wrap' }}>
                          {r.success === true  && <View style={rv.badge}><IconLabel Icon={EscapeRecordSuccessIcon} size={11} color={GREEN} textStyle={[rv.badgeText, { color: GREEN }]}>성공</IconLabel></View>}
                          {r.success === false && <View style={rv.badge}><IconLabel Icon={EscapeRecordFailIcon} size={11} color={RED} textStyle={[rv.badgeText, { color: RED   }]}>실패</IconLabel></View>}
                          {/* 80차 후속: [버그 수정] 체험형은 결과입력 버튼 자체가 없는데(바로 위
                              "🟢 성공/🔴 실패" 버튼은 이미 bookingFormat!=='show'로 숨겨져 있음)
                              이 뱃지만 형식 구분이 없어 "버튼은 없는데 미완료 뱃지만 영구히 떠
                              있는" 모순이 있었음(fork로 발견) */}
                          {r.success === null && !r.cancelled && r.bookingFormat !== 'show' && <View style={rv.badge}><Text style={[rv.badgeText, { color: GOLD }]}>⏳ 미완료</Text></View>}
                          {r.cancelled        && <View style={rv.badge}><IconLabel Icon={ReservationCancelIcon} size={11} color={TEXT_MUTED} textStyle={[rv.badgeText, { color: TEXT_MUTED }]}>취소</IconLabel></View>}
                          {r.reviewed         && <View style={rv.badge}><IconLabel Icon={MenuReviewIcon} size={11} color={PURPLE} textStyle={[rv.badgeText, { color: PURPLE }]}>리뷰</IconLabel></View>}
                        </View>
                      </View>

                      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10, marginBottom: 8 }}>
                        <IconLabel Icon={PeopleIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }}>{r.people}</IconLabel>
                        <IconLabel Icon={PriceIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }}>{(r.price || 0).toLocaleString()}원</IconLabel>
                        {r.customerPhone ? (
                          <IconLabel Icon={PhoneIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }}>{r.customerPhone}</IconLabel>
                        ) : null}
                        {r.escapeTime && r.success === true && (
                          <Text style={{ color: GOLD, fontSize: 12, fontWeight: '700' }}>⏱ {r.escapeTime}</Text>
                        )}
                        {r.hintCount != null && r.success != null && (
                          <IconLabel Icon={HintUsageIcon} size={12} color={ORANGE} textStyle={{ color: ORANGE, fontSize: 12, fontWeight: '700' }}>힌트 {r.hintCount}회</IconLabel>
                        )}
                      </View>

                      {!r.cancelled && (
                        <View style={{ flexDirection: 'row', gap: 6, flexWrap: 'wrap' }}>
                          {/* 80차: 체험형 공연(정원제)은 탈출 성공/실패 개념 자체가 없어 숨김 */}
                          {r.bookingFormat !== 'show' && (
                            <>
                              <Btn label="🟢 성공" variant="ghost"
                                style={r.success === true ? { borderColor: GREEN } : {}}
                                onPress={() => { if (r.success !== true) openSuccessModal(r); }} />
                              <Btn label="🔴 실패" variant="ghost"
                                style={r.success === false ? { borderColor: RED } : {}}
                                onPress={() => handleResult(r.id, false)} />
                              {(r.success === true || r.success === false) && (
                                <Btn label="초기화" variant="ghost" onPress={() => handleResult(r.id, null)} />
                              )}
                            </>
                          )}
                          {/* 63차: 점주 예약 취소 버튼 */}
                          <Btn label="취소" variant="danger"
                            onPress={() => onCancelByStore?.(r.id)} />
                        </View>
                      )}
                    </View>
                  );
                });
            })()
          }
        </View>
      )}
    </View>
  );
}

function ReservationsTab({ records, setRecords, store }) {
  const TODAY_STR = TODAY();
  const [statusFilter,  setStatusFilter]  = useState('all');
  const [dateFilter,    setDateFilter]    = useState(TODAY_STR);
  const [showCalendar,  setShowCalendar]  = useState(false);

  // 탈출결과 입력 모달
  const [resultModal,   setResultModal]   = useState(null);
  const [escapeTime,    setEscapeTime]    = useState('');
  const [hintCount,     setHintCount]     = useState('');
  const [saving,        setSaving]        = useState(false);

  const openSuccessModal = (r) => {
    setEscapeTime(r.escapeTime ? r.escapeTime.replace('분','').trim() : '');
    setHintCount(r.hintCount != null ? String(r.hintCount) : '');
    setResultModal({ id: r.id });
  };

  // 80차 후속: [버그 수정, 중간 심각도 — fork로 발견] 모집 그룹예약은 참가자 수만큼
  // 독립된 예약 카드로 보여서(recruitId 표시 자체가 없음), 매장관리자가 그 중 한 장에만
  // 성공/실패를 입력하고 나머지를 그대로 두면(같은 팀이 함께 겪은 하나의 결과인데 카드별
  // 개별 입력을 요구하는 UI라 자연스럽게 발생하는 실수) 나머지 참가자들은 영영
  // success:null로 남아 본인 탈출기록이 미확정 상태가 되고, 테마 성공률 집계도 어긋남
  // — 그룹예약이 지금까지 실제로 동작한 적이 없어 발견된 적 없던 사각지대. 한 카드에
  // 결과를 입력하면 같은 recruitId를 공유하는 나머지 카드(이미 화면에 로드돼 있음)에도
  // 동일한 결과를 함께 반영 — 그룹의 탈출 성공/실패는 원래 하나로 귀결되는 값이라 이게
  // 맞는 시맨틱(개별 카드마다 다른 결과를 남길 이유가 없음).
  const handleResult = useCallback(async (id, success, extra = {}) => {
    const data = { success, ...extra };
    const target = records.find(r => r.id === id);
    const siblingIds = target?.recruitId
      ? records.filter(r => r.recruitId === target.recruitId && r.id !== id).map(r => r.id)
      : [];
    // 80차 후속: [버그 수정, 낮은~중간 심각도 — fork로 발견] Promise.all은 하나라도
    // 실패하면 즉시 reject해서, 이미 서버에 정상 반영된 나머지 형제 문서까지 로컬
    // 화면(setRecords)엔 반영 안 된 채로 "실패"로만 뜨고 있었음(데이터 손상은 아니고
    // 화면 새로고침 전까진 서버-화면 상태가 어긋나는 정도) — allSettled로 바꿔 실제로
    // 성공한 것만 화면에 반영하고, 일부라도 실패했으면 그 사실을 안내.
    const results = await Promise.allSettled([id, ...siblingIds].map(rid => updateReservationResult(rid, data)));
    const targetIds = [id, ...siblingIds];
    const succeededIds = targetIds.filter((_, i) => results[i].status === 'fulfilled');
    if (succeededIds.length > 0) {
      setRecords(prev => prev.map(r => succeededIds.includes(r.id) ? { ...r, ...data } : r));
    }
    if (succeededIds.length < targetIds.length) {
      showAlert('오류', succeededIds.length > 0
        ? '일부 예약만 업데이트됐어요. 나머지는 다시 시도해주세요.'
        : '업데이트에 실패했어요.');
    }
  }, [setRecords, records]);

  // 63차: 점주 예약 취소
  // 72차: cancelledBy:'store' 전달 — 이걸 안 넘기면 점주가 취소해도 고객이 취소한 것과
  // 구분이 안 돼 onReservationCancelled CF가 매장에 불필요한 알림을 또 보내게 된다.
  // 79차: [버그 수정, 심각] 이 화면이 지금까지 고객 자기취소용 클라이언트 함수
  // cancelReservation()을 그대로 재사용하고 있었음(63차부터) — 그런데 그 함수가
  // 포인트 환불을 위해 부르는 refundPointsForChange CF는 "본인 예약만"(resData.uid===
  // auth.uid) 검증을 하는데, 매장관리자가 호출하면 auth.uid가 고객이 아니라 항상
  // 이 검증에 걸려 환불이 조용히 실패하고 있었음(예약/도메인 재정독 fork로 발견) —
  // 이번 세션에 "매장 취소 시 포인트 환불도 고쳤다"고 검증한 CF cancelReservationByStore
  // 는 정작 이 화면에서 한 번도 호출된 적이 없는 죽은 코드였음. 그 CF로 교체 —
  // Admin SDK 인라인 트랜잭션이라 권한 문제 없이 정확히 환불되고, 고객에게 취소
  // 알림(reservation_cancelled_by_store)까지 부수로 보내짐(기존엔 알림도 안 갔음).
  const handleCancelByStore = useCallback((id) => {
    showAlert(
      '예약 취소',
      '이 예약을 취소하시겠습니까?\n취소 후에는 되돌릴 수 없습니다.',
      [
        { text: '닫기', style: 'cancel' },
        { text: '취소 처리', style: 'destructive', onPress: async () => {
          try {
            // 80차: 체험형 공연(정원제)은 정원 감소가 서버 트랜잭션에서만 이뤄져야 해서
            // cancelShowReservationCF 경유 — 방탈출 전세는 기존 cancelReservationByStore 그대로.
            // 80차 후속: [버그 수정] 방탈출 모집 그룹예약도 참가자 전원이 reservationSlots
            // 잠금 하나를 공유하게 됐으므로, 그 중 하나만 cancelReservationByStore로
            // 취소하면(잠금은 안 건드림) 그룹은 아직 확정 상태인데 잠금만 남는 게 아니라
            // 오히려 잠금이 영영 안 풀리는 문제가 생김 — recruitId가 있으면 그룹 전체를
            // 한 번에 취소하는 cancelRoomRecruitReservationCF(참가자 알림 포함) 경유.
            // show도 CF가 내부적으로 형제 문서를 함께 취소하는데 로컬 상태는 클릭한 것
            // 하나만 갱신하던 것 — recruitId 공유 문서 전부 갱신하도록 같이 정리.
            const target = records.find(r => r.id === id);
            if (target?.bookingFormat === 'show') {
              await cancelShowReservation(id);
            } else if (target?.recruitId) {
              await cancelBulkRoomReservation(target.recruitId);
            } else {
              await cancelReservationByStore(id);
            }
            setRecords(prev => prev.map(r =>
              (r.id === id || (target?.recruitId && r.recruitId === target.recruitId))
                ? { ...r, cancelled: true } : r));
            showAlert('완료', '예약이 취소되었습니다.');
          } catch (e) {
            showAlert('오류', e?.message || '취소 처리 중 오류가 발생했어요.');
          }
        }},
      ]
    );
  }, [setRecords, records]);

  const handleSaveSuccess = async () => {
    if (!resultModal) return;
    const timeValid = !escapeTime || /^\d{1,3}$/.test(escapeTime.trim());
    if (!timeValid) {
      showAlert('형식 오류', '탈출 시간은 분 단위 숫자로 입력해주세요.\n예) 42');
      return;
    }
    setSaving(true);
    try {
      const extra = {};
      if (escapeTime) extra.escapeTime = `${escapeTime.trim()}분`;
      if (hintCount !== '') extra.hintCount = parseInt(hintCount) || 0;
      await handleResult(resultModal.id, true, extra);
      setResultModal(null);
    } finally { setSaving(false); }
  };

  const markedDates = (() => {
    const map = {};
    records.forEach(r => {
      if (!r.date || r.cancelled === true) return;
      if (!map[r.date]) map[r.date] = { dots: [] };
      // 80차 후속: [버그 수정] GOLD는 "결과 대기 중"이라는 의미인데 체험형은 결과 자체가
      // 없어 항상 GOLD로 찍혀 매일 "처리할 게 남았다"는 신호처럼 보였음 — 체험형은
      // 중립색(BLUE, 다른 화면의 "체험형" 배지와 같은 톤)으로 구분.
      const color = r.bookingFormat === 'show' ? BLUE
        : r.success === true ? GREEN : r.success === false ? RED : GOLD;
      if (map[r.date].dots.length < 3) map[r.date].dots.push({ color });
    });
    if (dateFilter && dateFilter !== 'all') {
      map[dateFilter] = {
        ...(map[dateFilter] || {}),
        selected: true,
        selectedColor: GOLD,
        selectedTextColor: ON_GOLD,
      };
    }
    return map;
  })();

  const dateFiltered = records.filter(r => {
    if (dateFilter === 'all') return true;
    return r.date === dateFilter;
  });

  const themeGroups = dateFiltered.reduce((acc, r) => {
    const key = r.productName || r.themeName || '알 수 없는 테마';
    if (!acc[key]) acc[key] = [];
    acc[key].push(r);
    return acc;
  }, {});

  // store 데이터에서 테마명 → imageUrl 매핑
  const themeImageMap = {};
  (store?.branches || []).forEach(b => {
    (b.themes || []).forEach(t => {
      if (t.name && t.imageUrl) themeImageMap[t.name] = t.imageUrl;
    });
  });

  const calendarTheme = {
    backgroundColor: 'transparent', calendarBackground: 'transparent',
    textSectionTitleColor: TEXT_MUTED,
    selectedDayBackgroundColor: GOLD, selectedDayTextColor: ON_GOLD,
    todayTextColor: GOLD, dayTextColor: TEXT,
    textDisabledColor: 'rgba(255,255,255,0.15)',
    dotColor: GOLD, selectedDotColor: ON_GOLD,
    arrowColor: GOLD, monthTextColor: TEXT,
    textDayFontWeight: '500', textMonthFontWeight: '800',
    textDayHeaderFontWeight: '600',
    textDayFontSize: 13, textMonthFontSize: 14, textDayHeaderFontSize: 11,
  };

  const dateLabel = dateFilter === 'all'
    ? '전체 날짜'
    : dateFilter === TODAY_STR
      ? `오늘 (${TODAY_STR})`
      : dateFilter;

  return (
    <View style={{ flex: 1 }}>
      <View style={{ backgroundColor: SURFACE, borderBottomWidth: 1, borderBottomColor: BORDER, paddingBottom: 8 }}>
        {/* 상태 필터 — 한 줄 꽉 차게 */}
        <View style={{ flexDirection: 'row', paddingHorizontal: 12, paddingTop: 8, paddingBottom: 4, gap: 5 }}>
          {STATUS_FILTERS.map(f => (
            <TouchableOpacity key={f.key}
              style={[rv.filterBtn, { flex: 1 }, statusFilter === f.key && rv.filterBtnActive]}
              onPress={() => setStatusFilter(f.key)}>
              {f.Icon
                ? <IconLabel Icon={f.Icon} size={13} color={statusFilter === f.key ? undefined : TEXT_MUTED} style={{ justifyContent: 'center' }}
                    textStyle={[rv.filterText, statusFilter === f.key && rv.filterTextActive]}>
                    {f.label}
                  </IconLabel>
                : <Text style={[rv.filterText, statusFilter === f.key && rv.filterTextActive]}>{f.label}</Text>}
            </TouchableOpacity>
          ))}
        </View>

        <View style={{ paddingHorizontal: 12, paddingTop: 6, flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <TouchableOpacity
            style={[rv.calDateBtn, { flex: 1 }]}
            onPress={() => setShowCalendar(v => !v)}
            activeOpacity={0.75}>
            <MenuReservationIcon size={15} color={GOLD} />
            <Text style={rv.calDateLabel}>{dateLabel}</Text>
            <Text style={{ color: GOLD, fontSize: 14 }}>{showCalendar ? '▲' : '▼'}</Text>
          </TouchableOpacity>
          {dateFilter !== 'all' && (
            <TextButton
              label="전체 보기"
              onPress={() => { setDateFilter('all'); setShowCalendar(false); }}
              style={rv.calAllBtn}
              textStyle={{ color: TEXT_MUTED, fontSize: 12 }}
            />
          )}
        </View>

        {showCalendar && (
          <View style={rv.calendarPanel}>
            <Calendar
              theme={calendarTheme}
              current={dateFilter !== 'all' ? dateFilter : TODAY_STR}
              onDayPress={day => {
                setDateFilter(day.dateString);
                setShowCalendar(false);
              }}
              markedDates={markedDates}
              markingType="multi-dot"
              enableSwipeMonths
              hideExtraDays
            />
            <View style={{ flexDirection: 'row', gap: 14, paddingHorizontal: 16, paddingBottom: 12 }}>
              {[
                { color: GOLD,  label: '미완료' },
                { color: GREEN, label: '성공' },
                { color: RED,   label: '실패' },
              ].map(({ color, label }) => (
                <View key={label} style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                  <View style={{ width: 7, height: 7, borderRadius: 4, backgroundColor: color }} />
                  <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>{label}</Text>
                </View>
              ))}
            </View>
          </View>
        )}
      </View>

      <View style={{ paddingHorizontal: 14, paddingTop: 10, paddingBottom: 4,
        flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>
          {dateLabel} · {Object.keys(themeGroups).length}개 테마 · {dateFiltered.length}건
        </Text>
      </View>

      <ScrollView contentContainerStyle={{ padding: 12 }}>
        {Object.keys(themeGroups).length === 0 ? (
          <View style={{ alignItems: 'center', paddingVertical: 60 }}>
            <EmptyReservationsIcon size={64} />
            <Text style={{ color: TEXT_MUTED, fontSize: 14, marginTop: 8 }}>해당하는 예약이 없어요.</Text>
          </View>
        ) : (
          Object.entries(themeGroups)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .map(([themeName, items]) => (
              <ThemeSection
                key={themeName}
                themeName={themeName}
                themeImage={themeImageMap[themeName] || null}
                items={items}
                statusFilter={statusFilter}
                handleResult={handleResult}
                openSuccessModal={openSuccessModal}
                dateFilter={dateFilter}
                onCancelByStore={handleCancelByStore}
              />
            ))
        )}
      </ScrollView>

      {/* 탈출결과 입력 모달 */}
      <Modal
        visible={!!resultModal}
        transparent
        animationType="fade"
        onRequestClose={() => setResultModal(null)}>
        <View style={rv.modalOverlay}>
          <View style={rv.modalBox}>
            <IconLabel Icon={EscapeSuccessIcon} size={15} color={TEXT} textStyle={rv.modalTitle}>탈출 성공 결과 입력</IconLabel>
            <Text style={rv.modalSub}>시간과 힌트 수를 입력해주세요 (선택)</Text>

            <Text style={rv.modalLabel}>⏱ 탈출 시간 (분)</Text>
            <TextInput
              style={rv.modalInput}
              placeholder="예) 42"
              placeholderTextColor={TEXT_MUTED}
              value={escapeTime}
              onChangeText={setEscapeTime}
              keyboardType="number-pad"
              maxLength={3}
            />

            <IconLabel Icon={HintUsageIcon} size={13} color={TEXT_MUTED} textStyle={rv.modalLabel}>힌트 사용 횟수</IconLabel>
            <TextInput
              style={rv.modalInput}
              placeholder="예) 2"
              placeholderTextColor={TEXT_MUTED}
              value={hintCount}
              onChangeText={setHintCount}
              keyboardType="number-pad"
              maxLength={2}
            />

            <View style={{ flexDirection: 'row', gap: 10, marginTop: 4 }}>
              <GradientButton
                label={saving ? '저장 중...' : '저장'}
                Icon={saving ? undefined : CheckmarkIcon}
                onPress={handleSaveSuccess}
                disabled={saving}
                style={rv.modalBtn}
              />
              <SecondaryButton label="취소" onPress={() => setResultModal(null)} style={rv.modalBtn} />
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const rv = StyleSheet.create({
  filterBtn:       { paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16,
                     borderWidth: 1, borderColor: 'transparent', backgroundColor: SURFACE2,
                     alignItems: 'center', justifyContent: 'center' },
  filterBtnActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
  filterText:      { color: TEXT_MUTED, fontSize: 12, textAlign: 'center' },
  filterTextActive:{ color: GOLD, fontWeight: '700', textAlign: 'center' },
  calDateBtn:      { flexDirection: 'row', alignItems: 'center', gap: 8,
                     backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
                     borderRadius: 10, paddingHorizontal: 12, paddingVertical: 9 },
  calDateLabel:    { color: TEXT, fontSize: 13, fontWeight: '700', flex: 1 },
  calAllBtn:       { paddingHorizontal: 12, paddingVertical: 9, borderRadius: 10,
                     borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  calendarPanel:   { backgroundColor: SURFACE2, borderTopWidth: 1, borderTopColor: BORDER, marginTop: 8 },
  searchInput:     { backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
                     borderRadius: 8, paddingHorizontal: 12, height: 40, color: TEXT, fontSize: 13 },
  themeImg:            { width: 64, height: 64, borderRadius: 8, marginRight: 12,
                         borderWidth: 1, borderColor: BORDER },
  themeImgPlaceholder: { width: 64, height: 64, borderRadius: 8, marginRight: 12,
                         borderWidth: 1, alignItems: 'center', justifyContent: 'center' },
  themeSection:    { backgroundColor: SURFACE, borderRadius: 14, borderWidth: 1,
                     borderColor: BORDER, marginBottom: 12, overflow: 'hidden' },
  themeHeader:     { flexDirection: 'row', alignItems: 'center', padding: 14,
                     borderBottomWidth: 1, borderBottomColor: BORDER, backgroundColor: SURFACE2 },
  themeTitle:      { fontSize: 14, fontWeight: '800', flex: 1 },
  miniStat:        { borderRadius: 6, borderWidth: 1, paddingHorizontal: 7, paddingVertical: 2 },
  miniStatTxt:     { fontSize: 11, fontWeight: '700' },
  item:            { backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1,
                     borderColor: BORDER, padding: 12, marginBottom: 8 },
  itemCancelled:   { opacity: 0.45 },
  badge:           { backgroundColor: BG, borderRadius: 4, paddingHorizontal: 6, paddingVertical: 2 },
  badgeText:       { fontSize: 11, fontWeight: '700' },
  // 모달
  modalOverlay:        { flex: 1, backgroundColor: 'rgba(0,0,0,0.75)', justifyContent: 'center',
                         alignItems: 'center', padding: 24 },
  modalBox:            { width: '100%', backgroundColor: SURFACE, borderRadius: 18,
                         borderWidth: 1, borderColor: BORDER, padding: 22, gap: 12 },
  modalTitle:          { color: TEXT, fontSize: 16, fontWeight: '900' },
  modalSub:            { color: TEXT_MUTED, fontSize: 12, marginTop: -4 },
  modalLabel:          { color: TEXT_SEC, fontSize: 12, fontWeight: '700', marginBottom: 2 },
  modalInput:          { backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
                         borderRadius: 10, paddingHorizontal: 14, height: 44, color: TEXT, fontSize: 14 },
  modalBtn:            { flex: 1 },
});

// ─── 예약현황 캘린더 탭 ──────────────────────────────────────
function CalendarTab({ records, store, onAddReservation }) {
  // ⚠️ 렌더 시점마다 오늘 날짜를 새로 계산 (모듈 상수 사용 금지)
  const getLocalToday = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return { str: `${y}-${m}-${d}`, year: now.getFullYear(), month: now.getMonth() };
  };
  const localToday = getLocalToday();

  const [year,   setYear]   = useState(localToday.year);
  const [month,  setMonth]  = useState(localToday.month);
  const [selDay, setSelDay] = useState(null);

  const MONTH_NAMES = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];
  const DAY_NAMES   = ['일','월','화','수','목','금','토'];

  const changeMonth = (delta) => {
    let m = month + delta, y = year;
    if (m < 0)  { m = 11; y--; }
    if (m > 11) { m = 0;  y++; }
    setMonth(m); setYear(y); setSelDay(null);
  };

  const daysInMonth  = new Date(year, month + 1, 0).getDate();
  const firstDOW     = new Date(year, month, 1).getDay();
  const todayStr = localToday.str;
  const monthPfx = `${year}-${String(month + 1).padStart(2, '0')}`;

  const dayMap = {};
  records.forEach(r => {
    if (!r.date || !r.date.startsWith(monthPfx) || r.cancelled === true) return;
    if (!dayMap[r.date]) dayMap[r.date] = { total: 0, success: 0, fail: 0, pending: 0 };
    dayMap[r.date].total++;
    if (r.success === true)  dayMap[r.date].success++;
    if (r.success === false) dayMap[r.date].fail++;
    if (r.success === null)  dayMap[r.date].pending++;
  });

  const cells = [];
  for (let i = 0; i < firstDOW; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const selectedKey  = selDay ? `${monthPfx}-${String(selDay).padStart(2,'0')}` : null;
  const selectedList = selectedKey
    ? records.filter(r => r.date === selectedKey && r.cancelled !== true)
    : [];

  // store 데이터에서 테마명 → imageUrl 매핑 (ReservationsTab과 동일)
  const themeImageMap = {};
  (store?.branches || []).forEach(b => {
    (b.themes || []).forEach(t => {
      if (t.name && t.imageUrl) themeImageMap[t.name] = t.imageUrl;
    });
  });

  return (
    <ScrollView contentContainerStyle={{ padding: 14 }} showsVerticalScrollIndicator={false}>
      {/* 달력 헤더 */}
      <View style={ctab.header}>
        <TouchableOpacity onPress={() => changeMonth(-1)} style={ctab.arrow}>
          <Text style={ctab.arrowTxt}>‹</Text>
        </TouchableOpacity>
        <Text style={ctab.title}>{year}년 {MONTH_NAMES[month]}</Text>
        <TouchableOpacity onPress={() => changeMonth(1)} style={ctab.arrow}>
          <Text style={ctab.arrowTxt}>›</Text>
        </TouchableOpacity>
      </View>

      {/* 요일 */}
      <View style={ctab.weekRow}>
        {DAY_NAMES.map((d, i) => (
          <Text key={d} style={[ctab.weekDay, i===0&&{color:RED}, i===6&&{color:BLUE}]}>{d}</Text>
        ))}
      </View>

      {/* 그리드 */}
      <View style={ctab.grid}>
        {cells.map((d, idx) => {
          if (d === null) return <View key={`e${idx}`} style={ctab.cell} />;
          const dateKey  = `${monthPfx}-${String(d).padStart(2,'0')}`;
          const data     = dayMap[dateKey];
          const isToday  = dateKey === todayStr;
          const isSel    = d === selDay;
          const isPast   = dateKey < todayStr;  // 오늘 미포함 과거
          const isSun    = idx % 7 === 0;
          const isSat    = idx % 7 === 6;

          // 날짜 숫자 색상: 선택 > 오늘 > 요일 > 기본
          const numColor = isSel    ? ON_GOLD
                         : isToday ? GOLD
                         : isSun   ? RED
                         : isSat   ? BLUE
                         : TEXT;

          return (
            <TouchableOpacity
              key={d}
              style={[
                ctab.cell,
                isSel   && ctab.cellSel,
                isToday && !isSel && ctab.cellToday,
                // 과거 날짜는 전체 opacity로 처리 (버블 포함)
                isPast  && !isSel && { opacity: 0.3 },
              ]}
              onPress={() => setSelDay(isSel ? null : d)}
              activeOpacity={isPast ? 0.5 : 0.7}>
              <Text style={[
                ctab.cellTxt,
                { color: numColor },
                isSel   && { fontWeight: '900' },
                isToday && { fontWeight: '800' },
              ]}>{d}</Text>
              {/* 예약 있는 날 버블 표시 (과거는 흐리게) */}
              {data ? (
                <View style={[
                  ctab.countBubble,
                  isSel   && ctab.countBubbleSel,
                ]}>
                  <Text style={[ctab.countTxt, isSel && ctab.countTxtSel]}>{data.total}</Text>
                </View>
              ) : (
                <View style={ctab.countPlaceholder} />
              )}
            </TouchableOpacity>
          );
        })}
      </View>

      {/* 범례 */}
      <View style={{ flexDirection: 'row', gap: 12, marginTop: 8, paddingHorizontal: 4 }}>
        <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>숫자 = 예약 건수</Text>
        <Text style={{ color: GOLD, fontSize: 10 }}>● 오늘</Text>
        <Text style={{ color: TEXT_MUTED, fontSize: 10 }}>선택한 날짜의 상세 목록 아래 표시</Text>
      </View>

      {/* 선택 날짜 목록 — 테마별 묶음 */}
      {selDay && (() => {
        // 테마별로 그룹핑 후 시간순 정렬
        const themeGroups = {};
        [...selectedList]
          .sort((a, b) => (a.time || '').localeCompare(b.time || ''))
          .forEach(r => {
            const key = r.productName || r.themeName || '테마 정보 없음';
            if (!themeGroups[key]) themeGroups[key] = [];
            themeGroups[key].push(r);
          });
        const themeKeys = Object.keys(themeGroups);
        return (
          <View style={{ marginTop: 16, borderTopWidth: 1, borderTopColor: BORDER, paddingTop: 14 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <Text style={{ color: GOLD, fontSize: 14, fontWeight: '800' }}>
                {month + 1}월 {selDay}일 예약 ({selectedList.length}건 · {themeKeys.length}개 테마)
              </Text>
              {/* 78차: 외부채널(전화/카카오 등) 예약을 이 날짜로 바로 수동입력하러 가는 단축
                  버튼 — 기존엔 상단 탭에서 "수동입력"을 따로 눌러 들어간 뒤 날짜를 처음부터
                  다시 골라야 했음. 날짜가 이미 선택돼 있으니 그대로 넘겨서 탭 수를 줄임. */}
              {onAddReservation && (
                <SecondaryButton
                  label="+ 예약 추가"
                  onPress={() => onAddReservation(`${monthPfx}-${String(selDay).padStart(2, '0')}`)}
                  style={{ paddingVertical: 6, paddingHorizontal: 10 }}
                  textStyle={{ fontSize: 12 }}
                />
              )}
            </View>
            {selectedList.length === 0 ? (
              <Text style={{ color: TEXT_MUTED, fontSize: 13, textAlign: 'center', paddingVertical: 20 }}>
                이 날 예약이 없어요.
              </Text>
            ) : (
              themeKeys.map(themeName => {
                const themeColor = getThemeColor(themeName);
                const themeImage = themeImageMap[themeName] || null;
                const items = themeGroups[themeName];
                // 성공률 계산
                // 79차: 여기도 동일한 `!== null` 분모 버그(결과 미기록 예약이 undefined라
                // 잘못 포함됨) — HomeScreen.js/위 UNLOCK 기여도 카드와 동일하게 수정.
                const finished = items.filter(r => r.success === true || r.success === false);
                const succeeded = items.filter(r => r.success === true);
                const successRate = finished.length
                  ? Math.round((succeeded.length / finished.length) * 100)
                  : null;
                return (
                  <View key={themeName} style={[ctab.themeBlock, { borderLeftColor: themeColor }]}>
                    {/* 테마 헤더 — 이미지 + 이름 + 성공률 */}
                    <View style={ctab.themeBlockHeader}>
                      {themeImage ? (
                        <Image
                          source={{ uri: themeImage }}
                          style={ctab.themeBlockImg}
                          resizeMode="cover"
                        />
                      ) : (
                        <View style={[ctab.themeBlockImgPlaceholder, { backgroundColor: themeColor + '25' }]}>
                          <MenuEscapeIcon size={22} color={themeColor} />
                        </View>
                      )}
                      <View style={{ flex: 1 }}>
                        <Text style={[ctab.themeBlockTitle, { color: themeColor }]} numberOfLines={1}>
                          {themeName}
                        </Text>
                        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 2 }}>
                          <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>
                            총 {items.length}건
                          </Text>
                          {successRate !== null && (
                            <View style={[ctab.miniSuccessBadge, {
                              backgroundColor: successRate >= 50 ? GREEN + '20' : RED + '20',
                              borderColor: successRate >= 50 ? GREEN + '50' : RED + '50',
                            }]}>
                              <Text style={{ color: successRate >= 50 ? GREEN : RED, fontSize: 10, fontWeight: '700' }}>
                                성공률 {successRate}%
                              </Text>
                            </View>
                          )}
                        </View>
                      </View>
                    </View>
                    {items.map(r => (
                      <View key={r.id} style={ctab.item}>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                          <IconLabel Icon={MenuPointsIcon} size={12} color={GOLD} textStyle={{ color: GOLD, fontSize: 13, fontWeight: '700' }}>{r.time || '-'}</IconLabel>
                          <View style={{ flexDirection: 'row', gap: 4 }}>
                            {/* 80차 후속: 체험형 공연은 탈출 성공/실패 개념이 없어 "미완료" 표시도 안 함 */}
                            {r.bookingFormat !== 'show' && r.success === true  && <IconLabel Icon={EscapeRecordSuccessIcon} size={11} color={GREEN} textStyle={{ color: GREEN, fontSize: 11 }}>성공</IconLabel>}
                            {r.bookingFormat !== 'show' && r.success === false && <IconLabel Icon={EscapeRecordFailIcon} size={11} color={RED} textStyle={{ color: RED,   fontSize: 11 }}>실패</IconLabel>}
                            {r.bookingFormat !== 'show' && r.success === null  && <Text style={{ color: GOLD,  fontSize: 11 }}>⏳ 미완료</Text>}
                          </View>
                        </View>
                        <View style={{ flexDirection: 'row', gap: 12, marginTop: 6 }}>
                          <IconLabel Icon={PeopleIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }}>{r.people}명</IconLabel>
                          <IconLabel Icon={PriceIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }}>{(r.price||0).toLocaleString()}원</IconLabel>
                          {r.escapeTime && <Text style={{ color: GOLD, fontSize: 12 }}>⏱ {r.escapeTime}</Text>}
                        </View>
                      </View>
                    ))}
                  </View>
                );
              })
            )}
          </View>
        );
      })()}
    </ScrollView>
  );
}

const ctab = StyleSheet.create({
  header:     { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 },
  arrow:      { padding: 8 },
  arrowTxt:   { color: GOLD, fontSize: 26, fontWeight: 'bold' },
  title:      { color: TEXT, fontSize: 16, fontWeight: '800' },
  weekRow:    { flexDirection: 'row', marginBottom: 4, borderBottomWidth: 1, borderBottomColor: BORDER, paddingBottom: 6 },
  weekDay:    { flex: 1, textAlign: 'center', color: TEXT_MUTED, fontSize: 11, fontWeight: '700' },
  grid:            { flexDirection: 'row', flexWrap: 'wrap' },
  cell:            { width: '14.28%', height: 52, alignItems: 'center', justifyContent: 'center',
                     borderRadius: 8, paddingVertical: 2 },
  cellSel:         { backgroundColor: GOLD },
  cellToday:       { borderWidth: 1.5, borderColor: GOLD },
  cellTxt:         { color: TEXT, fontSize: 13, lineHeight: 18 },
  countBubble:     { backgroundColor: GOLD + '25', borderRadius: 6, paddingHorizontal: 5, paddingVertical: 1,
                     marginTop: 2, borderWidth: 1, borderColor: GOLD + '40' },
  countPlaceholder:{ height: 14, marginTop: 2 },
  countTxt:        { color: GOLD, fontSize: 9, fontWeight: '800' },
  countBubbleSel:  { backgroundColor: 'rgba(0,0,0,0.25)', borderColor: 'rgba(0,0,0,0.15)' },
  countTxtSel:     { color: ON_GOLD },
  item:            { backgroundColor: SURFACE2, borderRadius: 10, padding: 12, marginBottom: 6,
                     borderWidth: 1, borderColor: BORDER },
  themeBlock:      { borderLeftWidth: 3, borderLeftColor: GOLD, marginBottom: 14,
                     paddingLeft: 10 },
  themeBlockHeader:{ flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 10 },
  themeBlockImg:   { width: 52, height: 52, borderRadius: 8, borderWidth: 1, borderColor: BORDER },
  themeBlockImgPlaceholder: { width: 52, height: 52, borderRadius: 8, borderWidth: 1,
                     borderColor: BORDER, alignItems: 'center', justifyContent: 'center' },
  themeBlockTitle: { fontSize: 13, fontWeight: '800', marginBottom: 0 },
  miniSuccessBadge:{ borderRadius: 6, borderWidth: 1, paddingHorizontal: 7, paddingVertical: 2 },
});

// ─── 운영 시간 설정 ───────────────────────────────────────────
const generateSlots = (start, end, interval, blocked = []) => {
  // 78차: 준비시간에 마이너스를 허용하면서 duration+prepMinutes가 0 이하가 될 수 있게
  // 됨 — 여기서 안 막으면 아래 for문의 t += interval이 무한루프(interval<=0)가 되어
  // 화면이 그대로 멈춤. 이 함수가 실제로 슬롯을 도는 단일 지점이라 여기서만 막으면 됨.
  interval = Math.max(1, Number(interval) || 1);
  const slots = [];
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const startMin = sh * 60 + sm;
  let endMin   = eh * 60 + em;
  // 78차 44차: 자정을 넘기는 영업시간(예: 22:00~02:00) 지원 — 종료시각이 시작시각보다
  // 이르거나 같으면 다음날로 넘어간 것으로 보고 24시간을 더해 계산(그렇지 않으면
  // endMin<startMin이라 아래 for문이 한 번도 안 돌아 예약 가능 시간이 통째로 0개가 됨).
  // 슬롯 라벨을 만들 때만 %1440으로 실제 시각(00:00~23:xx)으로 되돌리고, blocked 구간도
  // 같은 startMin 기준으로 정규화해서 자정을 넘는 차단시간도 정확히 비교되게 함.
  if (endMin <= startMin) endMin += 24 * 60;
  const norm = (min) => (min < startMin ? min + 24 * 60 : min);
  for (let t = startMin; t < endMin; t += interval) {
    const wrapped = t % (24 * 60);
    const h = String(Math.floor(wrapped / 60)).padStart(2, '0');
    const m = String(wrapped % 60).padStart(2, '0');
    const ts = `${h}:${m}`;
    const isBlocked = blocked.some(b => {
      const [bsh, bsm] = b.start.split(':').map(Number);
      const [beh, bem] = b.end.split(':').map(Number);
      const bStart = norm(bsh * 60 + bsm);
      const bEnd   = norm(beh * 60 + bem);
      return t >= bStart && t < bEnd;
    });
    if (!isBlocked) slots.push(ts);
  }
  return slots;
};

// 62차: onChangeDetected — 변경 발생 시 SettingsComboTab에 알림, onSaved — 저장 완료 시 알림
function ScheduleTab({ store, setStore, onChangeDetected, onSaved, scopeBranchIdx = null }) {
  // 78차 57차: 78차 50차에서 시작시간을 매장 공통으로 합쳤었으나, 실제로는 같은 매장
  // 안에서도 테마(방)마다 첫 회차 시작시간이 다르다는 게 확인돼 되돌림 — 시작시간은
  // 다시 테마별(비워두면 매장 공통 시작시간을 기본값으로 사용), 종료시간만 매장 공통
  // 유지(보통 방마다 마감시간은 같음). 그리고 "간격(분)"을 직접 입력하던 것을 "준비시간"
  // (회차 사이 청소/세팅 시간) 입력으로 대체 — 실제 간격 = 플레이시간(duration) +
  // 준비시간(prepMinutes)이라, 관리자가 직접 덧셈할 필요 없이 이 두 값만 넣으면 됨.
  const buildLocalBranches = (branches) =>
    (branches || []).map(b => ({
      ...b,
      themes: (b.themes || []).map(t => {
        const prepMinutes = t.prepMinutes ?? 0;
        const intervalMinutes = Number(t.duration || 60) + Number(prepMinutes || 0);
        // 78차: normalizeTimeStr — 엑셀 시간서식 오염(소수값)이 store.startTime/endTime에
        // 남아있으면 이 화면을 열자마자 예약 가능 시간이 통째로 비어 보이는 사고로
        // 이어졌음(실사용 중 발견) — 방어.
        const themeStart = normalizeTimeStr(t.startTime) || normalizeTimeStr(store?.startTime) || '09:00';
        return {
          ...t,
          scheduleType:         t.scheduleType         || 'auto',
          startTime:            t.startTime            || '', // 비어있으면 매장 공통 시작시간 사용
          prepMinutes,
          intervalMinutes,
          blockedSlots:         t.blockedSlots          || [],
          blockedDates:         t.blockedDates          || [],
          blockedWeekdays:      t.blockedWeekdays       || [],   // 60차: 반복 요일 차단 (0=일~6=토)
          holidayOverrides:     t.holidayOverrides      || [],   // 78차 62차: 공휴일 자동차단 중 개별 예외 처리한 날짜
          reservationWindowDays:t.reservationWindowDays ?? null, // 60차: 예약 오픈 기간(일수, null=무제한)
          // 78차 56차: 화면을 열자마자 "생성된 예약 시간"이 빈 채로 보이던 버그 —
          // Firestore에 이미 저장된 availableTimes가 있으면 그대로 쓰고, 없으면(테마
          // 등록 직후 등) 지금 값(이 테마 시작시간 또는 매장 공통 시작시간 + 플레이시간
          // +준비시간) 기준으로 미리 계산해 보여줌. 실제 저장은 "저장" 버튼을 눌러야 반영.
          availableTimes: (t.availableTimes && t.availableTimes.length > 0)
            ? t.availableTimes
            : generateSlots(themeStart, normalizeTimeStr(store?.endTime) || '22:00', intervalMinutes, t.blockedSlots || []),
          paymentType:          t.paymentType           || 'external',
          reservationUrl:       t.reservationUrl        || '',
        };
      }),
    }));

  const [localBranches, setLocalBranches] = useState(() => buildLocalBranches(store?.branches));
  // 80차: 매장 홍보 링크(unlockapp.co.kr/t/{storeSlug}/{themeSlug})용 매장 별명 —
  // 한글 매장명은 자동 로마자 변환이 지저분해서(일관성 없음) 직접 입력받음, 선택사항.
  const [localStoreSlug, setLocalStoreSlug] = useState(store?.slug || '');
  const [localHours, setLocalHours] = useState({
    startTime: normalizeTimeStr(store?.startTime) || '09:00',
    endTime:   normalizeTimeStr(store?.endTime)   || '22:00',
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');
  // 62차: 미저장 변경 감지
  const [hasChanges, setHasChanges] = useState(false);

  // 78차 57차: 테마별 예약 간격/시작시간 계산 단일 소스 — 간격 = 플레이시간(duration) +
  // 준비시간(prepMinutes), 시작시간은 테마 자체 값이 있으면 그걸, 없으면 매장 공통값.
  const computeThemeSchedule = (t, hours) => {
    const prepMinutes = t.prepMinutes ?? 0;
    const interval = Math.max(1, Number(t.duration || 60) + Number(prepMinutes || 0));
    const start = t.startTime || hours.startTime;
    return { ...t, prepMinutes, intervalMinutes: interval,
      availableTimes: generateSlots(start, hours.endTime, interval, t.blockedSlots || []) };
  };

  // 78차 50차: 매장 공통 시간이 바뀌면 모든 지점/테마의 availableTimes를 그 즉시 재계산
  const recomputeAllSlots = (branches, hours) => branches.map(b => ({
    ...b,
    themes: b.themes.map(t => computeThemeSchedule(t, hours)),
  }));

  const updateHours = (field, value) => {
    const nextHours = { ...localHours, [field]: value };
    setLocalHours(nextHours);
    markChanged(prev => recomputeAllSlots(prev, nextHours));
  };

  // 62차: 탭 전환 시 미저장 경고 — SettingsComboTab에서 view 변경 시 Alert
  const guardedSave = async () => {
    setSaving(true); setMsg('');
    try {
      const normalizedSlug = localStoreSlug.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
      // 80차: 매장 별명(slug)은 여러 매장이 겹치면 홍보 링크가 엉뚱한 매장으로 연결될
      // 수 있어 저장 전 중복만 가볍게 확인(테마 별명은 이 매장 안에서만 쓰이므로 생략).
      if (normalizedSlug) {
        const { collection: fsCol, query: fsQuery, where: fsWhere, getDocs } = await import('firebase/firestore');
        const dupSnap = await getDocs(fsQuery(fsCol(db, 'stores'), fsWhere('slug', '==', normalizedSlug)));
        if (dupSnap.docs.some(d => d.id !== store.id)) {
          setMsg('❌ 이미 다른 매장이 쓰는 별명이에요. 다른 값으로 바꿔주세요.');
          setSaving(false);
          return;
        }
      }
      const { doc: fsDoc, updateDoc } = await import('firebase/firestore');
      await updateDoc(fsDoc(db, 'stores', store.id), {
        branches: localBranches,
        startTime: localHours.startTime,
        endTime: localHours.endTime,
        slug: normalizedSlug || null,
      });
      invalidateStoreCache();
      // 78차 36차: 실제 버그 발견 — 여기서 setStore를 React식 함수형 업데이터(prev => ...)로
      // 불렀는데, 이 setStore(부모 StoreAdminScreen에서 내려주는 콜백)는 함수형 업데이트를
      // 지원하지 않고 넘어온 값을 그대로 store로 저장함 — 즉 store 자체가 "함수"로
      // 덮어써져서 store.branches가 undefined가 되고, 화면은 "등록된 지점 정보가 없어요"로
      // 빠짐(운영시간 저장 직후 매장이 통째로 사라진 것처럼 보이던 신고의 실제 원인).
      // BulkThemeImportTab의 setStore 호출(정상 동작 중이던 코드)과 동일하게 일반 객체로 수정.
      setLocalStoreSlug(normalizedSlug);
      setStore({ ...store, branches: localBranches, startTime: localHours.startTime, endTime: localHours.endTime, slug: normalizedSlug || null });
      setMsg('✅ 저장되었어요!');
      setHasChanges(false);
      onSaved?.();
    } catch (e) {
      setMsg('❌ 저장 실패: ' + e.message);
    } finally { setSaving(false); }
  };

  useEffect(() => {
    if (store?.branches?.length) {
      setLocalBranches(buildLocalBranches(store.branches));
      setLocalHours({ startTime: normalizeTimeStr(store?.startTime) || '09:00', endTime: normalizeTimeStr(store?.endTime) || '22:00' });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store?.id]);

  // 62차: 변경 발생 시 hasChanges 함께 세트
  const markChanged = (updater) => { setLocalBranches(updater); setHasChanges(true); onChangeDetected?.(); };

  const update = (bi, ti, field, value) => {
    markChanged(prev => prev.map((b, bIdx) => {
      if (bIdx !== bi) return b;
      return {
        ...b,
        themes: b.themes.map((t, tIdx) => tIdx !== ti ? t : computeThemeSchedule({ ...t, [field]: value }, localHours)),
      };
    }));
  };

  // 79차: [버그 수정] 이 세 함수가 markChanged 대신 setLocalBranches를 직접 호출하고
  // 있어서 hasChanges/onChangeDetected가 세팅되지 않았음(전수 정독으로 발견) — 매장
  // 설정에서 "PICK 테마"/"리뷰 답글" 등 다른 콤보탭으로 전환하면 ScheduleTab이
  // unmount되는데, 이 화면이 그 전환을 막으려고 쓰는 "저장 안 한 변경사항이 있어요"
  // 확인창이 hasChanges를 보고 판단하다 보니 예약 불가 시간대를 추가/수정/삭제해도
  // 경고 없이 그대로 전환되어 방금 만든 변경사항이 저장 안 된 채 조용히 사라졌음.
  const addBlocked = (bi, ti) => {
    markChanged(prev => prev.map((b, bIdx) => {
      if (bIdx !== bi) return b;
      return {
        ...b,
        themes: b.themes.map((t, tIdx) => {
          if (tIdx !== ti) return t;
          const blocked = [...(t.blockedSlots || []), { start: '12:00', end: '13:00' }];
          return computeThemeSchedule({ ...t, blockedSlots: blocked }, localHours);
        }),
      };
    }));
  };

  const updateBlocked = (bi, ti, si, field, value) => {
    markChanged(prev => prev.map((b, bIdx) => {
      if (bIdx !== bi) return b;
      return {
        ...b,
        themes: b.themes.map((t, tIdx) => {
          if (tIdx !== ti) return t;
          const blocked = t.blockedSlots.map((s, sIdx) => sIdx === si ? { ...s, [field]: value } : s);
          return computeThemeSchedule({ ...t, blockedSlots: blocked }, localHours);
        }),
      };
    }));
  };

  const removeBlocked = (bi, ti, si) => {
    markChanged(prev => prev.map((b, bIdx) => {
      if (bIdx !== bi) return b;
      return {
        ...b,
        themes: b.themes.map((t, tIdx) => {
          if (tIdx !== ti) return t;
          const blocked = t.blockedSlots.filter((_, sIdx) => sIdx !== si);
          return computeThemeSchedule({ ...t, blockedSlots: blocked }, localHours);
        }),
      };
    }));
  };

  const handleSave = async () => {
    if (!store?.id) return;
    if (!localBranches.length) {
      setMsg('❌ 저장할 지점 정보가 없습니다. 화면을 새로고침해주세요.');
      return;
    }
    await guardedSave();
  };

  if (!store?.branches?.length) return (
    <ScrollView contentContainerStyle={{ padding: 14 }}>
      <Card><Text style={{ color: TEXT_MUTED, textAlign: 'center', fontStyle: 'italic' }}>
        등록된 지점 정보가 없어요. 총괄 관리자에게 문의해주세요.
      </Text></Card>
    </ScrollView>
  );

  return (
    <View style={{ flex: 1 }}>
      <ScrollView contentContainerStyle={{ padding: 14, paddingBottom: 80 }} showsVerticalScrollIndicator={false}>
        {/* 저장 버튼 + 안내문구 한 줄 */}
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <Text style={{ color: TEXT_MUTED, fontSize: 12, flex: 1, marginRight: 10 }}>
            {msg
              ? <Text style={{ color: msg.startsWith('✅') ? GREEN : RED }}>{msg}</Text>
              : '시작/종료 시간과 간격을 설정하면 예약 가능 시간이 자동 생성됩니다.'}
          </Text>
          <Btn label={saving ? '저장 중...' : '💾 저장'} onPress={handleSave} disabled={saving} style={{ paddingHorizontal: 20 }} />
        </View>

        {/* 78차 50차: 시작/종료 시간 — 매장 전체 공통 설정(기본값)
            78차 57차: 종료시간은 그대로 공통이지만, 시작시간은 테마마다 다를 수 있어
            각 테마 카드에서 개별적으로 덮어쓸 수 있게 되돌림 — 여기 값은 "기본값" 역할. */}
        {/* 80차: 홍보 링크(unlockapp.co.kr/t/{매장별명}/{테마별명})용 매장 별명 —
            비워두면 링크가 자동 생성된 긴 코드로 나감(그래도 정상 동작). */}
        <Card>
          <CardTitle Icon={LinkIcon}>홍보 링크 매장 별명 (선택)</CardTitle>
          <TextInput
            style={sc.input}
            value={localStoreSlug}
            onChangeText={v => { setLocalStoreSlug(v); setHasChanges(true); onChangeDetected?.(); }}
            placeholder="예: solver (영문 소문자·숫자·하이픈만)"
            placeholderTextColor={TEXT_MUTED}
            autoCapitalize="none"
          />
          <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 8 }}>
            정하면 홍보 링크가 unlockapp.co.kr/t/{localStoreSlug || '매장별명'}/테마별명 형태로 짧아져요(테마별 별명은 아래 각 테마 카드에서). 비워두면 자동 생성된 링크를 그대로 써도 돼요.
          </Text>
        </Card>

        <Card>
          <CardTitle Icon={ClockIcon}>매장 운영시간 (기본값)</CardTitle>
          <View style={{ flexDirection: 'row', gap: 10 }}>
            <View style={{ flex: 1 }}>
              <Text style={sc.inputLabel}>시작 시간</Text>
              <TextInput
                style={sc.input}
                value={localHours.startTime}
                onChangeText={v => updateHours('startTime', v)}
                placeholder="09:00"
                placeholderTextColor={TEXT_MUTED}
              />
            </View>
            <View style={{ flex: 1 }}>
              <Text style={sc.inputLabel}>종료 시간</Text>
              <TextInput
                style={sc.input}
                value={localHours.endTime}
                onChangeText={v => updateHours('endTime', v)}
                placeholder="22:00"
                placeholderTextColor={TEXT_MUTED}
              />
            </View>
          </View>
          <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 8 }}>
            종료 시간은 모든 지점·테마에 공통 적용돼요. 시작 시간은 테마별로 다르면 각 테마 카드에서 따로 지정할 수 있어요(비워두면 여기 값을 사용).
          </Text>
        </Card>

        {/* 72차: 지점 선택 중이면 해당 인덱스만 렌더 — localBranches 자체는 전체를 유지해야
            저장 시 다른 지점 데이터를 덮어쓰지 않는다(update()/handleSave가 bi로 참조). */}
        {localBranches.map((branch, bi) => (
          (branch.isDeleted === true || (scopeBranchIdx !== null && bi !== scopeBranchIdx)) ? null : (
            <BranchSection key={bi} branch={branch} bi={bi} store={store} localHours={localHours}
              update={update} addBlocked={addBlocked} updateBlocked={updateBlocked}
              removeBlocked={removeBlocked} setLocalBranches={setLocalBranches} markChanged={markChanged} />
          )
        ))}
      </ScrollView>

      {/* 66차: 하단 고정 저장 버튼 — 스크롤 내려도 항상 접근 가능 */}
      {hasChanges && (
        <View style={{ position: 'absolute', bottom: 0, left: 0, right: 0,
          backgroundColor: SURFACE, borderTopWidth: 1, borderTopColor: BORDER,
          paddingHorizontal: 16, paddingVertical: 12,
          flexDirection: 'row', alignItems: 'center', gap: 12 }}>
          <Text style={{ color: GOLD, fontSize: 12, flex: 1 }}>● 저장하지 않은 변경사항이 있어요</Text>
          <Btn label={saving ? '저장 중...' : '💾 저장'} onPress={handleSave} disabled={saving} style={{ paddingHorizontal: 20 }} />
        </View>
      )}
    </View>
  );
}

// 65차: 브랜치별 접기/펼치기 섹션 컴포넌트
// 72차: 예약불가 시간/날짜/요일 설정을 각각 접고 펼 수 있게 하는 공통 래퍼
function CollapsibleBlock({ title, Icon, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <View style={{ marginTop: 8 }}>
      {/* 78차 38차: "화살표 누르기 불편" 신고 — 세로 패딩이 전혀 없어 실제 탭 영역이
          텍스트 줄 높이(약 16px)만큼밖에 안 됐음. 패딩+hitSlop으로 탭 영역 확대. */}
      <TouchableOpacity
        style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 12 }}
        hitSlop={{ top: 8, bottom: 8, left: 4, right: 4 }}
        onPress={() => setOpen(v => !v)} activeOpacity={0.7}>
        {Icon
          ? <IconLabel Icon={Icon} size={12} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12, fontWeight: '700' }}>{title}</IconLabel>
          : <Text style={{ color: TEXT_MUTED, fontSize: 12, fontWeight: '700' }}>{title}</Text>}
        <Text style={{ color: GOLD, fontSize: 16 }}>{open ? '▲' : '▼'}</Text>
      </TouchableOpacity>
      {open && <View style={{ marginTop: 4 }}>{children}</View>}
    </View>
  );
}

// 79차: [버그 수정] 이 컴포넌트는 markChanged를 이미 props로 받고 있었는데, 내부의
// 예약 불가 날짜/공휴일 예외/반복요일 차단/외부 예약 URL/예약 오픈 기간 편집 핸들러
// 7곳이 전부 markChanged 대신 setLocalBranches를 직접 호출하고 있었음(전수 정독으로
// 발견) — 이 화면이 다른 콤보탭(PICK 테마/리뷰 답글)으로 전환될 때 "저장 안 한
// 변경사항이 있어요" 경고를 hasChanges로 판단하는데, 위 7곳을 편집해도 hasChanges가
// 안 세팅돼 경고 없이 그대로 전환→ScheduleTab이 unmount되며 방금 만든 변경사항이
// 조용히 사라졌음. 전부 markChanged 호출로 교체(위 addBlocked/updateBlocked/
// removeBlocked도 같은 이유로 함께 수정).
function BranchSection({ branch, bi, store, localHours, update, addBlocked, updateBlocked, removeBlocked, setLocalBranches, markChanged }) {
  const [open, setOpen] = useState(true);
  // 78차: 예약 오픈 기간을 프리셋 칩(7/14/30/60일)에서 "N일 N시 이후부터" 지정형
  // 슬라이딩 선택으로 교체 — 이 브랜치의 몇 번째 테마 모달이 열려있는지만 기억
  const [windowPickerFor, setWindowPickerFor] = useState(null); // theme index(ti) | null
  return (
    <>
    <View style={{ marginBottom: 8 }}>
      {/* 브랜치 헤더 — 탭하면 접기/펼치기 */}
      <TouchableOpacity
        style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1, borderColor: BORDER,
          paddingHorizontal: 14, paddingVertical: 12, marginBottom: open ? 8 : 0 }}
        onPress={() => setOpen(v => !v)}
        activeOpacity={0.75}>
        <IconLabel Icon={MenuStoreIcon} size={13} color={GOLD} textStyle={{ color: GOLD, fontSize: 14, fontWeight: '800' }}>{branch.branchName}</IconLabel>
        <Text style={{ color: GOLD, fontSize: 18 }}>{open ? '▲' : '▼'}</Text>
      </TouchableOpacity>

      {/* 78차 47차: 소프트 삭제된 테마는 매장관리자 본인의 운영시간 설정 화면에서도 숨김
          (ti는 원본 인덱스 그대로 유지 — update(bi,ti,...)가 localBranches[bi].themes[ti]를
          참조하므로 필터된 배열의 새 인덱스를 쓰면 안 됨) */}
      {open && (branch.themes || []).map((theme, ti) => theme.isDeleted ? null : (
        <Card key={ti}>
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <IconLabel Icon={MenuEscapeIcon} size={13} color={TEXT} textStyle={{ color: TEXT, fontWeight: '700' }} style={{ flex: 1 }}>{theme.name}</IconLabel>
            {/* 80차: 매장이 자기 SNS(인스타 프로필 등)에 걸어둘 수 있는 홍보용 공개
                웹페이지 링크 — functions/index.js의 themeShareCF 참고. 매장·테마 별명이
                둘 다 저장돼 있으면 사람이 읽을 수 있는 짧은 링크, 아니면 기존 productId
                링크로 폴백(store.slug는 위 카드에서 이미 "저장"된 값만 반영 — 방금 입력만
                하고 아직 저장 안 한 별명은 저장 후에 적용됨, 다른 필드와 동일한 관행). */}
            <TouchableOpacity
              onPress={() => {
                const url = (store.slug && theme.slug)
                  ? `https://unlockapp.co.kr/t/${store.slug}/${theme.slug}`
                  : `https://unlockapp.co.kr/t/${store.id}_${bi}_${ti}`;
                // 80차 후속: url을 message 안에만 넣으면 웹(navigator.share)/iOS가 링크로
                // 인식 못 해 일반 텍스트 아이콘만 뜸 — url 필드도 함께 전달.
                Share.share({ message: `[${theme.name}] UNLOCK에서 확인해보세요!\n${url}`, url, title: `${theme.name} 홍보 링크` }).catch(() => {});
              }}
              style={{ paddingHorizontal: 10, paddingVertical: 5, borderRadius: 8,
                backgroundColor: 'rgba(216,174,82,0.12)', borderWidth: 1, borderColor: BORDER }}>
              <Text style={{ color: GOLD, fontSize: 11, fontWeight: '700' }}>🔗 홍보 링크</Text>
            </TouchableOpacity>
          </View>

          <View style={{ marginBottom: 12 }}>
            <Text style={sc.inputLabel}>홍보 링크 테마 별명 (선택)</Text>
            <TextInput
              style={sc.input}
              value={theme.slug || ''}
              onChangeText={v => update(bi, ti, 'slug', v.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
              placeholder="예: luciddream (영문 소문자·숫자·하이픈만)"
              placeholderTextColor={TEXT_MUTED}
              autoCapitalize="none"
            />
          </View>

              {/* 78차 57차: 종료시간은 위쪽 "매장 운영시간" 카드(매장 공통)를 그대로 쓰고,
                  시작시간은 이 테마만 다르면 여기서 덮어쓸 수 있음(비워두면 매장 공통 사용).
                  "간격(분)" 직접 입력은 없애고 실제 운영 방식대로 플레이시간+준비시간을
                  각각 입력하면 간격을 자동으로 계산해 보여줌. */}
              <View style={{ flexDirection: 'row', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                <View style={{ flex: 1, minWidth: 110 }}>
                  <Text style={sc.inputLabel}>시작 시간</Text>
                  <TextInput
                    style={sc.input}
                    value={theme.startTime}
                    onChangeText={v => update(bi, ti, 'startTime', v)}
                    placeholder={localHours.startTime}
                    placeholderTextColor={TEXT_MUTED}
                  />
                </View>
                {/* 78차 63차: 플레이시간이 지금까지 읽기 전용 텍스트("예약 간격 = 플레이시간
                    N분...")로만 보여서, 일괄등록 때 잘못 입력해도 여기서 고칠 방법이 없었음 —
                    준비시간과 같은 방식으로 직접 수정 가능하게 함(바꾸면 예약 간격/생성된
                    예약 시간이 즉시 재계산됨, computeThemeSchedule). */}
                <View style={{ flex: 1, minWidth: 90 }}>
                  <Text style={sc.inputLabel}>플레이시간(분)</Text>
                  <TextInput
                    style={sc.input}
                    value={String(theme.duration ?? 60)}
                    onChangeText={v => update(bi, ti, 'duration', v)}
                    keyboardType="number-pad"
                    placeholder="60"
                    placeholderTextColor={TEXT_MUTED}
                  />
                </View>
                <View style={{ flex: 1, minWidth: 90 }}>
                  {/* 78차: 회전율이 플레이시간보다 짧은 매장(여러 방을 동시 운영해 진행 90분인데
                      60분 주기로 손님을 받는 경우 등)을 위해 마이너스 준비시간 허용,
                      -60~+60분을 스크롤로 고르는 공용 필드로 교체(직접 타이핑 대신). */}
                  <MinutesPickerField
                    label="준비시간(분)"
                    value={theme.prepMinutes ?? 0}
                    onChange={v => update(bi, ti, 'prepMinutes', v)}
                  />
                </View>
              </View>
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 4 }}>
                시작 시간을 비우면 매장 공통 시간을 사용해요.
              </Text>
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 12 }}>
                예약 간격 = 플레이시간 {theme.duration || 60}분 {(theme.prepMinutes ?? 0) < 0 ? '-' : '+'} 준비시간 {Math.abs(theme.prepMinutes ?? 0)}분 = {theme.intervalMinutes}분
              </Text>

              <IconLabel Icon={MenuReservationIcon} size={13} color={TEXT_MUTED} textStyle={sc.inputLabel}>생성된 예약 시간 ({theme.availableTimes?.length || 0}개)</IconLabel>
              {theme.availableTimes?.length > 0 ? (
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
                  {theme.availableTimes.map(t => (
                    <View key={t} style={sc.timeChip}>
                      <Text style={sc.timeChipText}>{t}</Text>
                    </View>
                  ))}
                </View>
              ) : (
                <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 6, fontStyle: 'italic' }}>
                  시간을 설정하면 자동 생성됩니다.
                </Text>
              )}

              {/* ── 60차: 예약 오픈 기간 설정 — 78차: 프리셋 칩 대신 "N일 N시 이후부터"
                  지정형 슬라이딩 선택으로 교체 ────────────────────── */}
              <View style={{ marginTop: 16 }}>
                <IconLabel Icon={CalendarCheckIcon} size={12} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 12 }} style={{ marginBottom: 8 }}>
                  예약 오픈 기간
                </IconLabel>
                <TouchableOpacity style={sc.windowSummaryBtn} onPress={() => setWindowPickerFor(ti)}>
                  <Text style={sc.windowSummaryTxt}>
                    {theme.reservationWindowDays == null
                      ? '무제한 (제한 없이 모든 날짜 예약 가능)'
                      : `${theme.reservationWindowDays}일 후 ${theme.reservationWindowOpenTime || '00:00'}부터 예약 가능 →`}
                  </Text>
                </TouchableOpacity>
              </View>

              <CollapsibleBlock title="예약 불가 시간대" Icon={NoEntryIcon}>
                <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 8 }}>
                  <Btn label="+ 추가" variant="ghost" onPress={() => addBlocked(bi, ti)} style={{ paddingVertical: 5 }} />
                </View>
                {(theme.blockedSlots || []).map((slot, si) => (
                  <View key={si} style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                    <TextInput style={[sc.input, { flex: 1 }]} value={slot.start}
                      onChangeText={v => updateBlocked(bi, ti, si, 'start', v)}
                      placeholder="HH:MM" placeholderTextColor={TEXT_MUTED} />
                    <Text style={{ color: TEXT_MUTED }}>~</Text>
                    <TextInput style={[sc.input, { flex: 1 }]} value={slot.end}
                      onChangeText={v => updateBlocked(bi, ti, si, 'end', v)}
                      placeholder="HH:MM" placeholderTextColor={TEXT_MUTED} />
                    <DangerButton
                      label="✕"
                      accessibilityLabel="차단 시간 삭제"
                      onPress={() => removeBlocked(bi, ti, si)}
                      style={{ paddingHorizontal: 8, paddingVertical: 6 }}
                      textStyle={{ fontSize: 12 }}
                    />
                  </View>
                ))}
                {(theme.blockedSlots || []).length === 0 && (
                  <Text style={{ color: TEXT_MUTED, fontSize: 12, fontStyle: 'italic' }}>등록된 예약 불가 시간대가 없어요.</Text>
                )}
              </CollapsibleBlock>

              <CollapsibleBlock title="예약 불가 날짜" Icon={NoEntryIcon}>
                <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 8 }}>
                  <Btn
                    label="+ 날짜 추가"
                    variant="ghost"
                    style={{ paddingVertical: 5 }}
                    onPress={() => {
                      const today = TODAY();
                      const newDates = [...(theme.blockedDates || [])];
                      if (!newDates.includes(today)) newDates.push(today);
                      newDates.sort();
                      markChanged(prev => prev.map((b, bIdx) => {
                        if (bIdx !== bi) return b;
                        return { ...b, themes: b.themes.map((t, tIdx) =>
                          tIdx !== ti ? t : { ...t, blockedDates: newDates }
                        )};
                      }));
                    }}
                  />
                </View>
                <View style={sc.blockedCalWrap}>
                  <Calendar
                    theme={{
                      backgroundColor: 'transparent', calendarBackground: 'transparent',
                      textSectionTitleColor: TEXT_MUTED,
                      selectedDayBackgroundColor: RED + 'cc',
                      selectedDayTextColor: '#fff',
                      todayTextColor: GOLD, dayTextColor: TEXT,
                      textDisabledColor: 'rgba(255,255,255,0.15)',
                      arrowColor: GOLD, monthTextColor: TEXT,
                      textDayFontWeight: '500', textMonthFontWeight: '800',
                      textDayHeaderFontWeight: '600',
                      textDayFontSize: 13, textMonthFontSize: 13, textDayHeaderFontSize: 11,
                    }}
                    minDate={TODAY()}
                    // 78차 62차: 공휴일 자동 차단이 켜져 있으면 그 날짜들도 이 달력에 함께
                    // 표시(주황색, 수동 차단은 빨강) — 지금까지 "켜짐" 토글만 있고 실제
                    // 어느 날짜가 막히는지 이 달력엔 안 보이던 문제.
                    markedDates={{
                      ...(theme.blockHolidays !== false
                        ? Array.from(KOREAN_HOLIDAYS).reduce((acc, d) => {
                            if (d < TODAY()) return acc;
                            if ((theme.holidayOverrides || []).includes(d)) return acc; // 예외 처리된 날은 마크 안 함
                            acc[d] = { selected: true, selectedColor: ORANGE + 'cc', selectedTextColor: '#fff' };
                            return acc;
                          }, {})
                        : {}),
                      ...(theme.blockedDates || []).reduce((acc, d) => {
                        acc[d] = { selected: true, selectedColor: RED + 'cc', selectedTextColor: '#fff' };
                        return acc;
                      }, {}),
                    }}
                    onDayPress={day => {
                      const d = day.dateString;
                      // 공휴일 자동 차단이 켜져 있고 이 날짜가 공휴일이면 blockedDates가 아니라
                      // holidayOverrides를 토글(그 날만 개별적으로 예약 허용/재차단).
                      if (theme.blockHolidays !== false && KOREAN_HOLIDAYS.has(d)) {
                        const overrides = theme.holidayOverrides || [];
                        const updated = overrides.includes(d)
                          ? overrides.filter(x => x !== d)
                          : [...overrides, d].sort();
                        markChanged(prev => prev.map((b, bIdx) => {
                          if (bIdx !== bi) return b;
                          return { ...b, themes: b.themes.map((t, tIdx) =>
                            tIdx !== ti ? t : { ...t, holidayOverrides: updated }
                          )};
                        }));
                        return;
                      }
                      const current = theme.blockedDates || [];
                      const updated = current.includes(d)
                        ? current.filter(x => x !== d)
                        : [...current, d].sort();
                      markChanged(prev => prev.map((b, bIdx) => {
                        if (bIdx !== bi) return b;
                        return { ...b, themes: b.themes.map((t, tIdx) =>
                          tIdx !== ti ? t : { ...t, blockedDates: updated }
                        )};
                      }));
                    }}
                    enableSwipeMonths
                    hideExtraDays
                  />
                </View>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 6 }}>
                  🔴 수동 차단 날짜 · 🟠 공휴일 자동 차단(탭하면 그 날만 예약 허용/재차단)
                </Text>
                {(theme.blockedDates || []).length > 0 ? (
                  (() => {
                    // 78차: UTC 기준 계산(한국 새벽 0~9시엔 실제 날짜보다 하루 이르게 나옴)이던
                    // 것을 CalendarTab의 getLocalToday()와 동일한 로컬 계산(TODAY())으로 통일
                    const todayStr = TODAY();
                    // 오늘 이후(오늘 포함)만 칩으로 표시 — 과거는 Firestore에 남아있지만 칩은 숨김
                    const futureDates = (theme.blockedDates || []).filter(d => d >= todayStr);
                    return futureDates.length > 0 ? (
                      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                        {futureDates.map(d => (
                          <View key={d} style={sc.blockedDateChip}>
                            <Text style={sc.blockedDateText}>{d}</Text>
                            <TouchableOpacity
                              onPress={() => {
                                const updated = (theme.blockedDates || []).filter(x => x !== d);
                                markChanged(prev => prev.map((b, bIdx) => {
                                  if (bIdx !== bi) return b;
                                  return { ...b, themes: b.themes.map((t, tIdx) =>
                                    tIdx !== ti ? t : { ...t, blockedDates: updated }
                                  )};
                                }));
                              }}>
                              <View style={{ marginLeft: 4 }}><CancelIcon size={11} color={RED} /></View>
                            </TouchableOpacity>
                          </View>
                        ))}
                      </View>
                    ) : (
                      <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 6, fontStyle: 'italic' }}>
                        지정된 예약 불가 날짜가 없어요. (과거 날짜는 캘린더에만 표시됩니다.)
                      </Text>
                    );
                  })()
                ) : (
                  <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 6, fontStyle: 'italic' }}>
                    날짜를 탭하면 예약 불가 처리됩니다. 다시 탭하면 해제돼요.
                  </Text>
                )}
              </CollapsibleBlock>

              <CollapsibleBlock title="매주 반복 예약 불가 요일" Icon={RefreshIcon}>
                <View style={{ flexDirection: 'row', gap: 6 }}>
                  {['일','월','화','수','목','금','토'].map((label, dow) => {
                    const isBlocked = (theme.blockedWeekdays || []).includes(dow);
                    return (
                      <TouchableOpacity
                        key={dow}
                        style={[
                          sc.dowChip,
                          isBlocked && sc.dowChipActive,
                          dow === 0 && isBlocked && { borderColor: RED + '88', backgroundColor: RED + '20' },
                          dow === 6 && isBlocked && { borderColor: BLUE + '88', backgroundColor: BLUE + '20' },
                        ]}
                        onPress={() => {
                          const current = theme.blockedWeekdays || [];
                          const updated = current.includes(dow)
                            ? current.filter(d => d !== dow)
                            : [...current, dow].sort((a, b) => a - b);
                          markChanged(prev => prev.map((b, bIdx) => {
                            if (bIdx !== bi) return b;
                            return { ...b, themes: b.themes.map((t, tIdx) =>
                              tIdx !== ti ? t : { ...t, blockedWeekdays: updated }
                            )};
                          }));
                        }}
                      >
                        <Text style={[
                          sc.dowChipTxt,
                          isBlocked && { fontWeight: '800' },
                          dow === 0 && { color: isBlocked ? RED : RED + '99' },
                          dow === 6 && { color: isBlocked ? BLUE : BLUE + '99' },
                        ]}>{label}</Text>
                      </TouchableOpacity>
                    );
                  })}
                </View>
                {(theme.blockedWeekdays || []).length > 0 && (
                  <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 6 }}>
                    매주 {(theme.blockedWeekdays || []).map(d => ['일','월','화','수','목','금','토'][d]).join(', ')}요일은 예약 불가로 자동 처리됩니다.
                  </Text>
                )}
              </CollapsibleBlock>

              {/* 78차 48차: 공휴일 자동 차단 — 별도 설정 없이도 기본 ON(theme.blockHolidays
                  가 명시적으로 false가 아닌 이상 차단), 매장이 공휴일에도 정상 영업하면
                  이 토글로 해제 가능. 실제 날짜 목록은 constants/index.js의 KOREAN_HOLIDAYS. */}
              <CollapsibleBlock title="공휴일 자동 차단" Icon={CalendarCheckIcon}>
                <TouchableOpacity
                  style={[sc.dowChip, { width: '100%', paddingHorizontal: 12 },
                    theme.blockHolidays !== false && sc.dowChipActive]}
                  onPress={() => {
                    const next = theme.blockHolidays === false; // 꺼져있으면 다시 켜기
                    markChanged(prev => prev.map((b, bIdx) => {
                      if (bIdx !== bi) return b;
                      return { ...b, themes: b.themes.map((t, tIdx) =>
                        tIdx !== ti ? t : { ...t, blockHolidays: next }
                      )};
                    }));
                  }}
                >
                  <Text style={[sc.dowChipTxt, theme.blockHolidays !== false && { fontWeight: '800' }]}>
                    {theme.blockHolidays !== false ? '켜짐 — 공휴일은 예약 불가로 자동 처리' : '꺼짐 — 공휴일에도 정상 예약 가능'}
                  </Text>
                </TouchableOpacity>
                {/* 78차 56차: "공휴일이 언제인지 모르겠다" — 어떤 날짜가 실제로 차단
                    대상인지 확인할 방법이 전혀 없었음, 오늘 이후 목록을 바로 보여줌 */}
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 8 }}>
                  {(() => {
                    const today = TODAY();
                    const overrides = theme.holidayOverrides || [];
                    // 78차 62차: 개별로 예외 처리(정상 영업)한 날짜는 "적용되는" 목록에서 제외
                    const upcoming = Array.from(KOREAN_HOLIDAYS).filter(d => d >= today && !overrides.includes(d)).sort().slice(0, 10);
                    return upcoming.length > 0
                      ? `적용되는 공휴일(다가오는 순): ${upcoming.join(', ')}`
                      : '올해 남은 공휴일이 없어요.';
                  })()}
                </Text>
                {(theme.holidayOverrides || []).filter(d => d >= TODAY()).length > 0 && (
                  <Text style={{ color: ORANGE, fontSize: 10, marginTop: 4 }}>
                    예외 처리(정상 영업)된 날짜: {(theme.holidayOverrides || []).filter(d => d >= TODAY()).sort().join(', ')}
                  </Text>
                )}
              </CollapsibleBlock>

              {/* ── 외부 예약 URL (39차: 결제방식 토글 제거, 현장결제 고정) ─ */}
              <View style={{ marginTop: 16 }}>
                <IconLabel Icon={LinkIcon} size={12} color={TEXT_MUTED} textStyle={sc.inputLabel}>외부 예약 URL (선택)</IconLabel>
                <TextInput
                  style={sc.input}
                  value={theme.reservationUrl}
                  onChangeText={v => markChanged(prev => prev.map((b, bIdx) => {
                    if (bIdx !== bi) return b;
                    return { ...b, themes: b.themes.map((t, tIdx) =>
                      tIdx !== ti ? t : { ...t, reservationUrl: v }
                    )};
                  }))}
                  placeholder={store?.reservationUrl ? `비워두면 매장 공통 URL 사용: ${store.reservationUrl}` : 'https://... (입력 시 예약 완료 후 이동)'}
                  placeholderTextColor={TEXT_MUTED}
                  autoCapitalize="none"
                  keyboardType="url"
                />
              </View>

            </Card>
        ))}
      </View>

      {/* 78차: 예약 오픈 기간 — "N일 N시 이후부터" 지정형 슬라이딩 선택 모달 */}
      {windowPickerFor != null && branch.themes?.[windowPickerFor] && (
        <WindowDaysPickerModal
          theme={branch.themes[windowPickerFor]}
          onClose={() => setWindowPickerFor(null)}
          onChange={(patch) => {
            markChanged(prev => prev.map((b, bIdx) => {
              if (bIdx !== bi) return b;
              return { ...b, themes: b.themes.map((t, tIdx) =>
                tIdx !== windowPickerFor ? t : { ...t, ...patch }
              )};
            }));
          }}
        />
      )}
    </>
    );
}

// 78차: 예약 오픈 기간 지정 모달 — "N일 N시 이후부터"를 프리셋 칩 대신 스크롤 휠로
// 직접 고름(ManualReservationTab의 ScrollPicker와 동일한 컴포넌트 재사용).
function WindowDaysPickerModal({ theme, onClose, onChange }) {
  const [unlimited, setUnlimited] = useState(theme.reservationWindowDays == null);
  const [days, setDays] = useState(theme.reservationWindowDays ?? 7);
  const [hour, setHour] = useState(Number((theme.reservationWindowOpenTime || '00:00').split(':')[0]) || 0);

  const dayItems  = Array.from({ length: 181 }, (_, i) => ({ value: i, label: `${i}일` }));
  const hourItems = Array.from({ length: 24 }, (_, i) => ({ value: i, label: `${String(i).padStart(2, '0')}시` }));

  const handleConfirm = () => {
    if (unlimited) {
      onChange({ reservationWindowDays: null, reservationWindowOpenTime: null });
    } else {
      onChange({ reservationWindowDays: days, reservationWindowOpenTime: `${String(hour).padStart(2, '0')}:00` });
    }
    onClose();
  };

  return (
    <Modal visible transparent animationType="slide" onRequestClose={onClose}>
      <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.75)', justifyContent: 'flex-end' }}>
        <View style={{ backgroundColor: SURFACE, borderTopLeftRadius: 16, borderTopRightRadius: 16, overflow: 'hidden' }}>
          <AppHeader isModal centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>예약 오픈 기간</Text>} />
          <View style={{ padding: 16 }}>
            <TouchableOpacity
              style={[sc.windowChip, unlimited && sc.windowChipActive, { alignSelf: 'flex-start', marginBottom: 14 }]}
              onPress={() => setUnlimited(v => !v)}>
              {unlimited
                ? <IconLabel Icon={CheckmarkIcon} size={12} color={GOLD} textStyle={[sc.windowChipTxt, sc.windowChipTxtActive]}>무제한</IconLabel>
                : <Text style={sc.windowChipTxt}>무제한으로 전환</Text>}
            </TouchableOpacity>
            {/* 78차: "무제한 상태에서 뭘 눌러야 바꿀 수 있는지 모르겠다"는 피드백 —
                버튼 자체가 곧 토글이라는 걸 문구로 명시 */}
            {unlimited && (
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 14, marginTop: -8 }}>
                지금은 모든 날짜가 예약 가능합니다. 기간을 지정하려면 위 버튼을 눌러주세요.
              </Text>
            )}

            {!unlimited && (
              <>
                <View style={{ flexDirection: 'row', gap: 10, marginBottom: 10 }}>
                  <ScrollPicker items={dayItems} selectedValue={days} onSelect={setDays} label="일 후부터" itemHeight={40} />
                  <ScrollPicker items={hourItems} selectedValue={hour} onSelect={setHour} label="시부터" itemHeight={40} />
                </View>
                <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 14 }}>
                  오늘로부터 {days}일 후 {String(hour).padStart(2, '0')}:00부터 그 날짜의 예약이 열립니다(그 전까지는 하루 이전 날짜까지만 예약 가능).
                </Text>
              </>
            )}

            <GradientButton label="선택 완료" onPress={handleConfirm} />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const sc = StyleSheet.create({
  inputLabel: { color: TEXT_MUTED, fontSize: 11, marginBottom: 4 },
  input: { backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
    borderRadius: 8, paddingHorizontal: 10, height: 40, color: TEXT, fontSize: 13 },
  timeChip: { backgroundColor: GOLD + '18', borderRadius: 6, borderWidth: 1,
    borderColor: GOLD + '44', paddingHorizontal: 10, paddingVertical: 4 },
  timeChipText: { color: GOLD, fontSize: 12, fontWeight: '600' },
  blockedCalWrap: { backgroundColor: SURFACE2, borderRadius: 12, borderWidth: 1,
    borderColor: BORDER, overflow: 'hidden', marginBottom: 4 },
  blockedDateChip: { flexDirection: 'row', alignItems: 'center',
    backgroundColor: COLORS.redBg, borderRadius: 6, borderWidth: 1,
    borderColor: RED + '4D', paddingHorizontal: 8, paddingVertical: 4 },
  blockedDateText: { color: RED, fontSize: 12, fontWeight: '600' },
  // 60차: 반복 요일 차단 칩
  dowChip:        { flex: 1, alignItems: 'center', paddingVertical: 8, borderRadius: 8,
                    borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  dowChipActive:  { borderColor: GOLD + '88', backgroundColor: GOLD + '20' },
  dowChipTxt:     { color: TEXT_MUTED, fontSize: 12 },
  // 60차: 예약 오픈 기간 칩
  windowChip:        { paddingHorizontal: 14, paddingVertical: 7, borderRadius: 16,
                       borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  windowChipActive:  { borderColor: GOLD, backgroundColor: GOLD + '18' },
  windowChipTxt:     { color: TEXT_MUTED, fontSize: 12 },
  windowChipTxtActive:{ color: GOLD, fontWeight: '700', fontSize: 12 },
  // 78차: 예약 오픈 기간 요약 버튼(탭하면 지정형 슬라이딩 선택 모달이 열림)
  windowSummaryBtn:  { backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
                       borderRadius: 10, paddingHorizontal: 14, paddingVertical: 12 },
  windowSummaryTxt:  { color: TEXT, fontSize: 13, fontWeight: '600' },
});

// ─── 🌟 PICK 테마 관리 (70차: "이벤트" 명칭 → "PICK 테마"로 변경) ──────
// "이벤트"라는 단어가 할인코드를 반드시 제공해야 할 것 같은 인상을 줘서
// BOOST 플랜의 매장 자체 노출 기능을 "PICK 테마"로 재명명. 데이터 구조(Firestore
// 'events' 컬렉션, type 값들)는 하위 호환을 위해 그대로 유지하고 화면 문구만 변경.
// 72차: 배너/쿠폰형 자유입력 폼 → 매장이 등록한 테마 중 하나를 고르는 방식으로 단순화.
// PICK 테마는 원래 "우리 매장이 미는 테마를 노출"하는 기능인데 기존 폼(제목 자유입력·
// 종류·쿠폰코드·할인율)은 일반 배너 광고 도구에 가까웠음 — productId를 직접 선택하게
// 하면 테마조회 화면에서 PICK 배지로 연결(72차 BookingScreen 작업)도 가능해짐.
// type/imageUrl/badgeColor/couponCode/discountRate는 어디에서도 실제로 읽지 않는
// 필드였음(고객용 StoreEventCard/NoticeDetailView는 title·description·기간·storeName만 사용).
// 78차 16차: 자유입력 "설명" 삭제 — 매장마다 문구가 제각각이라 고객 화면에 배지로
// 보여주기 어려웠음. 대신 고정 태그 중 하나를 고르는 "특이사항"(highlight)으로 대체.
const EMPTY_FORM = {
  productId: null, branchIdx: null, branchName: '', themeIdx: null, themeName: '',
  highlights: [], startDate: '', endDate: '', autoRenew: false,
};

// 70차: 날짜 입력을 텍스트 직접입력 → 캘린더 탭 선택으로 변경.
// (기존 TextInput 자유 입력 방식은 "2026.06.15" 등 형식이 어긋나면 문자열 비교가 깨져
//  분명 기간 내인데도 "종료됨"으로 잘못 표시되는 원인이었음 — 캘린더 선택은 항상
//  YYYY-MM-DD로 저장되므로 이 문제가 원천 차단됨)
// 75차: PICK 테마 노출 기간 상한 — 계약이 아무리 길어도 PICK 한 건은 최대 이 일수까지만
// (스토어가 한 번 등록해두고 방치하지 않고 주기적으로 갱신하도록 유도)
const PICK_MAX_DAYS = 90;
function addDaysStr(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

function EventDateField({ label, value, onSelect, minDate, maxDate }) {
  const [open, setOpen] = useState(false);
  // 78차 56차: 이 컴포넌트의 유일한 실제 사용처(PICK 테마 등록 폼)가 가로 2열이 아니라
  // 세로로 혼자 놓이는 형태인데 flex:1(=flexBasis:0%)이 남아있어서, 높이가 정해지지
  // 않은 ScrollView 안에서 웹 환경이 이 박스를 0 높이로 접어버리는 문제가 있었음 —
  // 그 아래 안내 문구들이 이 박스가 있어야 할 자리로 끌어올려져 서로 겹쳐 보이던 원인
  // (달력을 펼치면 실제 콘텐츠(330px)가 생겨 갑자기 정상 높이를 되찾으면서 아래 버튼들이
  // 크게 밀리는 것도 같은 문제). flex:1 대신 100% 너비로 교체.
  return (
    <View style={{ width: '100%' }}>
      <Text style={ev.label}>{label}</Text>
      <TouchableOpacity style={ev.dateBtn} onPress={() => setOpen(v => !v)} activeOpacity={0.75}>
        <MenuReservationIcon size={13} color={TEXT_MUTED} />
        <Text style={[ev.dateBtnText, !value && { color: TEXT_MUTED }]} numberOfLines={1}>
          {value || '날짜 선택'}
        </Text>
        <Text style={{ color: GOLD, fontSize: 12 }}>{open ? '▲' : '▼'}</Text>
      </TouchableOpacity>
      {open && (
        <View style={ev.dateCalWrap}>
          <Calendar
            theme={{
              backgroundColor: 'transparent', calendarBackground: 'transparent',
              textSectionTitleColor: TEXT_MUTED,
              selectedDayBackgroundColor: GOLD, selectedDayTextColor: ON_GOLD,
              todayTextColor: GOLD, dayTextColor: TEXT,
              textDisabledColor: 'rgba(255,255,255,0.15)',
              arrowColor: GOLD, monthTextColor: TEXT,
              textDayFontWeight: '500', textMonthFontWeight: '800',
              textDayFontSize: 13, textMonthFontSize: 13,
            }}
            minDate={minDate}
            maxDate={maxDate}
            current={value || minDate}
            markedDates={value ? { [value]: { selected: true, selectedColor: GOLD, selectedTextColor: ON_GOLD } } : {}}
            onDayPress={day => { onSelect(day.dateString); setOpen(false); }}
            hideExtraDays
          />
        </View>
      )}
    </View>
  );
}

// 69차: store prop 추가 — handleSave 내부에서 store 변수가 스코프에 없어
//       ReferenceError가 나던 것을 try/catch가 조용히 삼키고 있었음(즐겨찾기 알림 미발송 원인).
// 69차: BOOST 플랜 전용 기능으로 게이트 추가.
// 70차: "이벤트" → "PICK 테마" 명칭 변경.
// 70차: 등록/수정 폼을 FlatList의 ListHeaderComponent(인라인 함수) 안에 두면
//       글자를 한 자 칠 때마다 폼 전체가 새로운 컴포넌트로 취급되어 리마운트되면서
//       TextInput 포커스(키보드)가 매번 사라지는 문제가 있었음 — 폼을 FlatList 밖의
//       독립 Modal로 분리해 근본적으로 해결. 부수 효과로 "수정" 눌렀을 때 폼이
//       목록 스크롤 위치와 무관하게 항상 화면 중앙에 뜨게 되어 위치 혼동 문제도 해결.
function EventsTab({ storeId, store, scopeBranchIdx = null }) {
  const [events,    setEvents]    = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [showForm,  setShowForm]  = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form,      setForm]      = useState(EMPTY_FORM);
  const [saving,    setSaving]    = useState(false);
  const [msg,       setMsg]       = useState('');
  // 78차 58차: 특이사항 직접입력(5자 이내) 배지용 입력창 상태
  const [customHighlight, setCustomHighlight] = useState('');

  const isPickEligible = planAtLeast(getEffectivePlan(store, scopeBranchIdx), 'premium');
  const todayStr = TODAY();
  const branches = store?.branches || [];
  const multiBranch = branches.length > 1;
  // 78차 67차: "전체"(scopeBranchIdx==null) 보기의 isPickEligible은 getEffectivePlan이
  // 지점들 중 가장 높은 등급 하나만 premium이어도 true를 반환해서, 실제로는 STANDARD인
  // 지점의 테마까지 등록/노출 가능했던 버그(고객용 getActivePickStoreEvents는 이미
  // 지점별로 정확히 걸러지고 있었음 — 관리자 화면만 어긋나 있었음). 지점별 plan을
  // 다시 확인해 premium 아닌 지점의 PICK은 "전체" 보기에서도 제외.
  const visibleEvents = scopeBranchIdx !== null
    ? events.filter(e => e.branchIdx === scopeBranchIdx)
    : events.filter(e => e.branchIdx == null || planAtLeast(getBranchPlan(store, e.branchIdx), 'premium'));

  // 72차: PICK 등록 폼에서 고를 수 있는 테마 목록 — productId 위치 인덱스가 정본이므로
  // branches를 자르지 않고 실제 bi/ti로 생성한다. scopeBranchIdx 선택 중이면 그 지점만.
  // 78차 67차: "전체" 보기에서도 premium이 아닌 지점의 테마는 애초에 선택지에서 제외
  // (지금까지는 다른 지점이 premium이면 전부 선택 가능해서 STANDARD 지점 테마도 등록 가능했음).
  const themeOptions = branches.flatMap((b, bi) =>
    (b.isDeleted === true || (scopeBranchIdx !== null && bi !== scopeBranchIdx)) ? [] :
    !planAtLeast(getBranchPlan(store, bi), 'premium') ? [] :
    // 78차 47차: filter를 먼저 하면 ti가 원본 배열 인덱스가 아니라 필터된 배열의
    // 새 인덱스가 되어 productId/themeIdx가 틀어짐 — map으로 원본 ti를 먼저 담아
    // 객체를 만든 뒤에 걸러내야 함(테마 삭제 시 productId 붕괴 버그와 같은 유형).
    (b.themes || []).map((t, ti) => t.isDeleted ? null : ({
      productId: `${storeId}_${bi}_${ti}`,
      branchIdx: bi, branchName: b.branchName,
      themeIdx: ti, themeName: t.name,
      bookingFormat: t.bookingFormat || 'room', // 80차 후속: 특이사항 태그를 형식별로 분리하기 위해 필요
    })).filter(Boolean)
  );

  const load = useCallback(async () => {
    // 69차: BOOST 미만 매장은 불필요한 Firestore 읽기를 피하기 위해 조회 자체를 생략
    if (!storeId || !isPickEligible) { setLoading(false); return; }
    setLoading(true);
    try {
      const snap = await getDocs(
        query(collection(db, 'events'), where('storeId', '==', storeId))
      );
      setEvents(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { /* 무음 처리 */ }
    finally { setLoading(false); }
  }, [storeId, isPickEligible]);

  useEffect(() => { load(); }, [load]);

  const isActive = e => e.startDate <= TODAY() && e.endDate >= TODAY();

  const handleSave = async () => {
    Keyboard.dismiss(); // 78차 18차: 저장 누르면 키보드가 안 내려가던 문제
    if (!form.productId || !form.startDate || !form.endDate) {
      setMsg('❌ 테마, 시작일, 종료일은 필수예요.'); return;
    }
    const spanDays = Math.round((new Date(form.endDate) - new Date(form.startDate)) / 86400000);
    if (spanDays > PICK_MAX_DAYS) {
      setMsg(`❌ PICK 노출 기간은 최대 ${PICK_MAX_DAYS}일까지예요.`); return;
    }
    // 78차 39차: PICK 무제한 등록 — 매장당 무료 1개, 초과분은 1개당 월 2,000원 추가 과금.
    // 신규 등록(수정 아님)이고 이미 무료 슬롯 개수만큼 활성 PICK이 있으면 확인을 거침.
    if (!editingId) {
      const activeCount = events.filter(isActive).length;
      if (activeCount >= PICK_FREE_SLOT_COUNT) {
        showAlert(
          '무료 슬롯 초과',
          `무료로 등록 가능한 PICK 테마는 ${PICK_FREE_SLOT_COUNT}개예요. 이 테마를 추가로 등록하면 월 ${PICK_ADDON_FEE.toLocaleString()}원이 정산에 추가됩니다. 계속할까요?`,
          [
            { text: '취소', style: 'cancel' },
            { text: '등록', onPress: () => saveEvent(true) },
          ],
        );
        return;
      }
    }
    await saveEvent(false);
  };

  const saveEvent = async (isPaidSlot) => {
    setSaving(true); setMsg('');
    try {
      const { doc: fsDoc, addDoc, updateDoc: fsUpdateDoc, serverTimestamp } = await import('firebase/firestore');
      // 72차: title은 더 이상 자유 입력이 아니라 선택한 테마명을 그대로 사용
      const payload = { ...form, title: form.themeName };
      if (editingId) {
        await fsUpdateDoc(fsDoc(db, 'events', editingId), { ...payload, updatedAt: serverTimestamp() });
      } else {
        await addDoc(collection(db, 'events'), { ...payload, storeId, isPaidSlot, createdAt: serverTimestamp() });
        // 신규 PICK 테마 등록 시 즐겨찾기 유저에게 알림 발송
        // 69차: store가 props로 전달되지 않아 참조 오류가 나던 부분 수정
        try {
          const notifyFavoriteEvent = httpsCallable(functions, 'notifyFavoriteEvent');
          await notifyFavoriteEvent({
            storeId,
            storeName: getStoreDisplayName(store),
            eventTitle: payload.title,
            eventType:  'theme_highlight',
          });
        } catch (notifErr) {
          // 알림 실패는 저장에 영향 없음 — 무음 처리
        }
      }
      setMsg('✅ 저장됐어요!');
      setShowForm(false);
      load();
    } catch (e) { setMsg('❌ 저장 실패: ' + e.message); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    showAlert('PICK 테마 삭제', '정말 삭제할까요?', [
      { text: '취소', style: 'cancel' },
      { text: '삭제', style: 'destructive', onPress: async () => {
        try {
          const { doc: fsDoc, deleteDoc } = await import('firebase/firestore');
          await deleteDoc(fsDoc(db, 'events', id));
          load();
        } catch (e) { showAlert('오류', e.message); }
      }},
    ]);
  };

  const openCreate = () => {
    // 72차: 테마가 하나뿐이면(단일 지점·단일 테마) 바로 선택해둔다
    const only = themeOptions.length === 1 ? themeOptions[0] : null;
    // 78차 18차: 시작일 기본값 오늘, 종료일은 항상 시작일+상한(90일)로 자동 계산
    const dates = { startDate: todayStr, endDate: addDaysStr(todayStr, PICK_MAX_DAYS) };
    setForm(only ? { ...EMPTY_FORM, ...only, ...dates } : { ...EMPTY_FORM, ...dates });
    setEditingId(null); setMsg(''); setCustomHighlight(''); setShowForm(true);
  };
  const openEdit = (event) => { setForm({ ...EMPTY_FORM, ...event }); setEditingId(event.id); setMsg(''); setCustomHighlight(''); setShowForm(true); };

  // 69차: BOOST 미만 매장 — 다른 플랜 잠금 카드(PREMIUM/STANDARD)와 동일한 톤의 안내
  if (!isPickEligible) {
    return (
      <ScrollView contentContainerStyle={{ padding: 14 }} showsVerticalScrollIndicator={false}>
        <Card>
          <CardTitle Icon={SpotlightStarIcon}>우리 매장 PICK 테마</CardTitle>
          <View style={{ alignItems: 'center', paddingVertical: 20, gap: 8 }}>
            <PlanLockedIcon size={48} />
            <Text style={{ color: TEXT, fontSize: 14, fontWeight: '800' }}>PREMIUM 플랜에서 이용할 수 있어요</Text>
            <Text style={{ color: TEXT_MUTED, fontSize: 12, textAlign: 'center', lineHeight: 18 }}>
              우리 매장이 추천하는 테마를{'\n'}고객 앱 PICK 탭 최상단에 노출해드려요
            </Text>
            <View style={{ backgroundColor: GOLD + '15', borderRadius: 8, borderWidth: 1,
              borderColor: GOLD + '40', paddingHorizontal: 14, paddingVertical: 6, marginTop: 4 }}>
              <Text style={{ color: GOLD, fontSize: 11, fontWeight: '700' }}>
                총괄 관리자에게 PREMIUM 플랜 전환을 요청하세요
              </Text>
            </View>
          </View>
        </Card>
      </ScrollView>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <FlatList
        data={visibleEvents}
        keyExtractor={i => i.id}
        contentContainerStyle={{ padding: 14 }}
        ListHeaderComponent={
          <View style={{ marginBottom: 12 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconLabel Icon={SpotlightStarIcon} size={14} color={GOLD} textStyle={{ color: GOLD, fontSize: 14, fontWeight: '800' }}>우리 매장 PICK 테마</IconLabel>
              <Btn label="+ 등록" onPress={openCreate} style={{ paddingHorizontal: 20 }} />
            </View>
            {/* 78차 39차: 무료 슬롯 사용 현황 안내 — 초과분부터 유료라는 걸 등록 전에 알 수 있게 */}
            <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 6 }}>
              무료 슬롯 {Math.min(events.filter(isActive).length, PICK_FREE_SLOT_COUNT)}/{PICK_FREE_SLOT_COUNT} 사용 중
              {events.filter(isActive).length > PICK_FREE_SLOT_COUNT
                ? ` · 추가 ${events.filter(isActive).length - PICK_FREE_SLOT_COUNT}개 (월 ${((events.filter(isActive).length - PICK_FREE_SLOT_COUNT) * PICK_ADDON_FEE).toLocaleString()}원)`
                : ''}
            </Text>
          </View>
        }
        ListEmptyComponent={
          loading
            ? <LoadingOverlay inline />
            : (
              <Text style={{ color: TEXT_MUTED, textAlign: 'center', marginTop: 20, fontStyle: 'italic' }}>
                등록된 PICK 테마가 없어요. 첫 테마를 등록해보세요!
              </Text>
            )
        }
        renderItem={({ item: event }) => {
          const active = isActive(event);
          return (
            <View style={[ev.eventItem, active && ev.eventItemActive]}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <View style={{ flex: 1, gap: 4 }}>
                  {/* 78차 38차: title+상태배지+자동갱신+특이사항 배지가 flexWrap 없이 한 줄에
                      다 들어가려 해서, 특이사항 배지가 추가되면 이 행이 넓어지며 우측
                      수정/삭제 버튼 쪽으로 겹쳐 보이던 버그 — flexWrap 추가로 넘치면
                      다음 줄로 내려가게 함 */}
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <Text style={{ color: TEXT, fontWeight: '800', fontSize: 13 }}>{event.title}</Text>
                    <View style={[ev.statusBadge, active ? ev.statusActive : ev.statusInactive]}>
                      <Text style={[ev.statusText, { color: active ? GOLD : TEXT_MUTED }]}>
                        {active ? '🟢 진행중' : '⚪ 종료'}
                      </Text>
                    </View>
                    {event.autoRenew && (
                      <View style={[ev.statusBadge, ev.statusInactive]}>
                        <IconLabel Icon={RefreshIcon} size={11} color={TEXT_MUTED} textStyle={[ev.statusText, { color: TEXT_MUTED }]}>자동 갱신</IconLabel>
                      </View>
                    )}
                    {(event.highlights || []).map(h => (
                      <View key={h} style={[ev.statusBadge, { backgroundColor: GOLD + '18', borderColor: GOLD + '44' }]}>
                        <Text style={[ev.statusText, { color: GOLD }]}>{h}</Text>
                      </View>
                    ))}
                    {event.isPaidSlot && (
                      <View style={[ev.statusBadge, { backgroundColor: COLORS.blue + '18', borderColor: COLORS.blue + '44' }]}>
                        <Text style={[ev.statusText, { color: COLORS.blue }]}>월 {PICK_ADDON_FEE.toLocaleString()}원</Text>
                      </View>
                    )}
                  </View>
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
                    {multiBranch && event.branchName && <MenuStoreIcon size={10} color={TEXT_MUTED} />}
                    <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>
                      {multiBranch && event.branchName ? `${event.branchName} · ` : ''}
                      {event.startDate} ~ {event.endDate}
                    </Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', gap: 6 }}>
                  <Btn label="수정" variant="ghost" style={{ paddingVertical: 5 }}
                    onPress={() => openEdit(event)} />
                  <Btn label="삭제" variant="danger" style={{ paddingVertical: 5 }}
                    onPress={() => handleDelete(event.id)} />
                </View>
              </View>
            </View>
          );
        }}
      />

      {/* 70차: 등록/수정 폼 — FlatList 밖 독립 Modal로 분리 (키보드 사라짐 + 위치 혼동 해결) */}
      <Modal
        visible={showForm}
        transparent
        animationType="fade"
        onRequestClose={() => setShowForm(false)}
      >
        <View style={ev.modalOverlay}>
          <View style={ev.modalBox}>
            <ScrollView showsVerticalScrollIndicator={false} keyboardShouldPersistTaps="handled">
              {editingId
                ? <IconLabel Icon={EditIcon} size={14} color={GOLD} textStyle={ev.modalTitle}>PICK 테마 수정</IconLabel>
                : <Text style={ev.modalTitle}>➕ 새 PICK 테마 등록</Text>}

              {/* 72차: 자유입력 제목 대신 매장이 등록한 테마 중 하나를 고르는 방식 */}
              {/* 78차 38차: 이미 PICK으로 활성 등록된 테마를 또 선택해 중복 등록하는 것을
                  방지 — 수정 중인 이벤트 자신의 테마는 예외(계속 선택 가능). */}
              <Text style={ev.label}>테마 선택 *</Text>
              {/* 78차 56차: 가로 ScrollView에 alignItems가 없어 칩들이 기본 stretch로
                  세로 전체를 채우며 커 보이던 버그 — SettingsComboTab의 동일 패턴과
                  같은 방식(alignItems:'center')으로 수정. */}
              <ScrollView horizontal showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ gap: 6, marginBottom: 4, alignItems: 'center' }}>
                {themeOptions.map(opt => {
                  const alreadyPicked = events.some(e =>
                    e.productId === opt.productId && isActive(e) && e.id !== editingId
                  );
                  return (
                    <TouchableOpacity key={opt.productId}
                      disabled={alreadyPicked}
                      style={[ev.typeChip, form.productId === opt.productId && ev.typeChipActive, alreadyPicked && { opacity: 0.4 }]}
                      onPress={() => setForm(f => ({
                        ...f, ...opt,
                        // 80차 후속: 방탈출/체험형 특이사항 태그 목록이 서로 달라서, 형식이
                        // 바뀌는 테마로 전환하면 이전 선택이 새 목록에 없는 값으로 남지 않게 초기화
                        highlights: f.bookingFormat === opt.bookingFormat ? f.highlights : [],
                      }))}>
                      <Text style={[ev.typeChipText, form.productId === opt.productId && { color: GOLD }]}>
                        {multiBranch ? `${opt.branchName} · ${opt.themeName}` : opt.themeName}{alreadyPicked ? ' (등록됨)' : ''}
                      </Text>
                    </TouchableOpacity>
                  );
                })}
                {themeOptions.length === 0 && (
                  <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>등록된 테마가 없어요.</Text>
                )}
              </ScrollView>
              <Text style={{ color: GOLD, fontSize: 13, fontWeight: '800', marginBottom: 12 }}>
                {form.themeName || '테마를 선택해주세요'}
              </Text>

              <Text style={ev.label}>특이사항 (선택, 최대 {PICK_HIGHLIGHT_MAX}개)</Text>
              <ScrollView horizontal showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ gap: 6, marginBottom: 8, alignItems: 'center' }}>
                {getPickHighlights(form.bookingFormat).map(h => {
                  const picked = form.highlights.includes(h);
                  const full = !picked && form.highlights.length >= PICK_HIGHLIGHT_MAX;
                  return (
                    <TouchableOpacity key={h} disabled={full}
                      style={[ev.typeChip, picked && ev.typeChipActive, full && { opacity: 0.4 }]}
                      onPress={() => setForm(f => ({
                        ...f,
                        highlights: picked ? f.highlights.filter(x => x !== h) : [...f.highlights, h],
                      }))}>
                      <Text style={[ev.typeChipText, picked && { color: GOLD }]}>{h}</Text>
                    </TouchableOpacity>
                  );
                })}
              </ScrollView>
              <View style={{ flexDirection: 'row', gap: 6, marginBottom: 6 }}>
                <TextInput
                  style={[sc.input, { flex: 1, paddingVertical: 8 }]}
                  value={customHighlight}
                  onChangeText={v => setCustomHighlight(v.slice(0, PICK_HIGHLIGHT_CUSTOM_MAX_LEN))}
                  placeholder={`직접 입력 (${PICK_HIGHLIGHT_CUSTOM_MAX_LEN}자 이내)`}
                  placeholderTextColor={TEXT_MUTED}
                  maxLength={PICK_HIGHLIGHT_CUSTOM_MAX_LEN}
                />
                <Btn label="추가" variant="ghost"
                  disabled={!customHighlight.trim() || form.highlights.length >= PICK_HIGHLIGHT_MAX || form.highlights.includes(customHighlight.trim())}
                  onPress={() => {
                    const v = customHighlight.trim();
                    if (!v) return;
                    setForm(f => f.highlights.includes(v) ? f : { ...f, highlights: [...f.highlights, v] });
                    setCustomHighlight('');
                  }} />
              </View>
              {form.highlights.length > 0 && (
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                  {form.highlights.map(h => (
                    <TouchableOpacity key={h}
                      style={[ev.typeChip, ev.typeChipActive, { flexDirection: 'row', alignItems: 'center', gap: 4 }]}
                      onPress={() => setForm(f => ({ ...f, highlights: f.highlights.filter(x => x !== h) }))}>
                      <Text style={[ev.typeChipText, { color: GOLD }]}>{h}</Text>
                      <CancelIcon size={12} color={GOLD} />
                    </TouchableOpacity>
                  ))}
                </View>
              )}

              {/* 78차 18차: 종료일은 더 이상 직접 고르지 않고 시작일 + 최대 상한(90일)로
                  자동 계산 — 시작일을 바꿔도 노출 기간은 항상 최대치를 그대로 사용. */}
              <EventDateField
                label="시작일 *"
                value={form.startDate}
                minDate={undefined}
                onSelect={v => setForm(f => ({ ...f, startDate: v, endDate: addDaysStr(v, PICK_MAX_DAYS) }))}
              />
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 6, marginBottom: 4 }}>
                종료일은 시작일로부터 {PICK_MAX_DAYS}일 후({form.endDate || '-'})로 자동 설정돼요.
              </Text>
              {/* 75차: PICK 테마 노출 기간에 상한(최대 3개월)을 둠 — 기존엔 종료일을 몇 년
                  뒤로도 잡을 수 있어 사실상 무기한 노출이 가능했음 */}
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 10 }}>
                한 번에 최대 {PICK_MAX_DAYS}일(약 3개월)까지 설정할 수 있어요.
              </Text>

              {/* 78차 13차: 재등록 자체엔 제약이 없어 3개월 상한이 재설정 잡무만 만든다는
                  지적으로, 계속 노출을 원하는 매장은 매번 손대지 않도록 자동 갱신 옵션 추가.
                  기간제 프로모션을 원하면 그대로 끄고 종료일을 지정하면 됨. */}
              <TouchableOpacity
                style={{ flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 12 }}
                onPress={() => setForm(f => ({ ...f, autoRenew: !f.autoRenew }))}>
                <View style={[ev.checkbox, form.autoRenew && ev.checkboxActive]}>
                  {form.autoRenew && <CheckmarkIcon size={12} color={ON_GOLD} />}
                </View>
                <View style={{ flex: 1 }}>
                  <Text style={{ color: TEXT, fontSize: 13, fontWeight: '700' }}>자동 갱신</Text>
                  <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>
                    기간이 끝나면 자동으로 {PICK_MAX_DAYS}일 더 연장해요(PREMIUM 플랜 유지 시).
                  </Text>
                </View>
              </TouchableOpacity>

              {msg ? <Text style={{ color: msg.startsWith('✅') ? GREEN : RED, fontSize: 12, marginBottom: 8 }}>{msg}</Text> : null}

              <View style={{ flexDirection: 'row', gap: 8, marginTop: 4 }}>
                <Btn label={saving ? '저장 중...' : '💾 저장'} onPress={handleSave} disabled={saving} style={{ flex: 1 }} />
                <Btn label="취소" variant="ghost" onPress={() => { setShowForm(false); setMsg(''); }} style={{ flex: 1 }} />
              </View>
            </ScrollView>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const ev = StyleSheet.create({
  checkbox: { width: 20, height: 20, borderRadius: 4, borderWidth: 1.5, borderColor: BORDER,
    justifyContent: 'center', alignItems: 'center' },
  checkboxActive: { backgroundColor: GOLD, borderColor: GOLD },
  label: { color: TEXT_MUTED, fontSize: 11, marginBottom: 4 },
  typeChip: { paddingHorizontal: 12, paddingVertical: 7, borderRadius: 16,
    borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  typeChipActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
  typeChipText: { color: TEXT_MUTED, fontSize: 12 },
  eventItem: { backgroundColor: SURFACE, borderRadius: 12, borderWidth: 1,
    borderColor: BORDER, padding: 14, marginBottom: 10 },
  eventItemActive: { borderColor: GOLD + '60' },
  statusBadge: { borderRadius: 10, paddingHorizontal: 8, paddingVertical: 2, borderWidth: 1 },
  statusActive: { backgroundColor: GOLD + '18', borderColor: GOLD + '44' },
  statusInactive: { backgroundColor: SURFACE2, borderColor: BORDER },
  statusText: { fontSize: 10, fontWeight: '700' },
  // 70차: 날짜 캘린더 선택 필드
  dateBtn:      { flexDirection: 'row', alignItems: 'center', gap: 6,
                  backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER,
                  borderRadius: 8, paddingHorizontal: 10, height: 42 },
  dateBtnText:  { color: TEXT, fontSize: 13, fontWeight: '600', flex: 1 },
  // 78차 18차: 달력이 4~6주짜리 달로 넘어갈 때마다 그리드 행 수가 달라져 주변 레이아웃이
  // 같이 밀리던 문제 — 6주 기준으로 항상 들어갈 minHeight 고정.
  dateCalWrap:  { backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1,
                  borderColor: BORDER, overflow: 'hidden', marginTop: 6, minHeight: 330 },
  // 70차: 등록/수정 폼 모달
  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.75)', justifyContent: 'center',
                  alignItems: 'center', padding: 20 },
  modalBox:     { width: '100%', maxHeight: '85%', backgroundColor: SURFACE, borderRadius: 18,
                  borderWidth: 1, borderColor: BORDER, padding: 20 },
  modalTitle:   { color: GOLD, fontSize: 15, fontWeight: '900', marginBottom: 14 },
});

// ── 38차: 예약 콤보탭 — 리스트/달력 뷰 전환 ────────────────────
// 58차: 목록/달력/수동입력 3-way 토글로 통합 — 기존 독립 "수동입력" 탭을 흡수
function BookingComboTab({ records, setRecords, store, storeId, onAdded, scopeBranchIdx = null }) {
  const [view, setView] = useState('list'); // 'list' | 'calendar' | 'manual'
  // 78차: 달력에서 날짜를 고른 채로 "+ 예약 추가"를 누르면 그 날짜를 들고 수동입력으로 이동
  const [manualInitialDate, setManualInitialDate] = useState(null);
  const jumpToManualAdd = (dateStr) => { setManualInitialDate(dateStr); setView('manual'); };
  // 72차: 가벼운 온보딩 배너 — 어떤 테마도 예약 가능 시간(availableTimes)이 생성된 적
  // 없으면(= 운영시간을 아직 한 번도 설정 안 함) 신규 매장으로 간주해 안내만 노출
  const needsScheduleSetup = !(store?.branches || []).some(b =>
    b.isDeleted !== true && (b.themes || []).some(t => t.isDeleted !== true && (t.availableTimes || []).length > 0)
  );
  return (
    <View style={{ flex: 1 }}>
      {needsScheduleSetup && (
        <View style={{ backgroundColor: GOLD + '15', borderBottomWidth: 1, borderBottomColor: GOLD + '40',
          paddingHorizontal: 14, paddingVertical: 10 }}>
          <Text style={{ color: GOLD, fontSize: 12, fontWeight: '700' }}>
            👋 아직 운영시간이 설정되지 않았어요 — 설정 탭에서 시작/종료 시간을 먼저 입력해주세요.
          </Text>
        </View>
      )}
      {/* 78차 40차: 목록/달력/수동입력 풀폭 3등분 탭 → 압축형 한 줄로 교체. 목록이
          압도적으로 자주 보는 뷰라 "3단 탭이 너무 깊다"는 지적을 받아, 목록은 왼쪽에
          현재 위치를 알려주는 라벨(눌러서 돌아가기 겸용)로 축소하고 달력/수동입력은
          오른쪽의 작은 아이콘 버튼 2개로 옮김 — 목록을 볼 때 풀폭 탭 줄 하나가
          통째로 가벼워짐(기능 자체는 그대로, 3-way 토글의 시각적 비중만 줄임). */}
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
        paddingHorizontal: 14, paddingVertical: 9, gap: 8,
        backgroundColor: SURFACE, borderBottomWidth: 1, borderBottomColor: BORDER }}>
        <TouchableOpacity
          onPress={() => setView('list')} disabled={view === 'list'}
          style={{ flexDirection: 'row', alignItems: 'center', gap: 5 }}>
          <MenuReservationIcon size={14} color={view === 'list' ? GOLD : TEXT_MUTED} />
          <Text style={{ color: view === 'list' ? GOLD : TEXT_MUTED, fontSize: 13,
            fontWeight: view === 'list' ? '800' : '600' }}>
            {view === 'list' ? '예약 목록' : '‹ 목록으로'}
          </Text>
        </TouchableOpacity>
        <View style={{ flexDirection: 'row', gap: 6 }}>
          <TouchableOpacity
            style={[combo.iconBtn, view === 'calendar' && combo.iconBtnActive]}
            onPress={() => setView('calendar')}>
            <CalendarCheckIcon size={15} color={view === 'calendar' ? GOLD : TEXT_MUTED} />
          </TouchableOpacity>
          <TouchableOpacity
            style={[combo.iconBtn, view === 'manual' && combo.iconBtnActive]}
            onPress={() => setView('manual')}>
            <EditIcon size={15} color={view === 'manual' ? GOLD : TEXT_MUTED} />
          </TouchableOpacity>
        </View>
      </View>
      {view === 'list' && <ReservationsTab records={records} setRecords={setRecords} store={store} />}
      {view === 'calendar' && <CalendarTab records={records} store={store} onAddReservation={jumpToManualAdd} />}
      {view === 'manual' && <ManualReservationTab store={store} storeId={storeId} onAdded={onAdded} scopeBranchIdx={scopeBranchIdx} initialDate={manualInitialDate} />}
    </View>
  );
}

// ── 71차: 매장 리뷰 답글 탭 (모든 플랜 공통 제공) ────────────
// ReviewCard.js의 ReviewList/ReviewCard가 이미 adminUid prop으로 답변
// 입력·수정·삭제 UI를 갖추고 있어(36차) 그대로 재사용 — 새 UI를 만들지 않음.
function ReviewReplyTab({ storeId, store, scopeBranchIdx = null }) {
  const { user } = useAuth();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setReviews(await getReviewsByStoreId(storeId));
    } finally {
      setLoading(false);
    }
  }, [storeId]);

  useEffect(() => { load(); }, [load]);

  // 72차: 리뷰 문서엔 branchIdx가 저장돼 있지 않으므로 productId를 파싱해 지점을 판별
  // (productId = "storeId_branchIdx_themeIdx" — parseProductId가 정본 파서)
  const visibleReviews = scopeBranchIdx === null
    ? reviews
    : reviews.filter(r => parseProductId(r.productId)?.branchIdx === scopeBranchIdx);

  return (
    <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: 60 }}>
      <ReviewList
        reviews={visibleReviews}
        loading={loading}
        adminUid={user?.uid}
        onReplyChanged={(updated) =>
          setReviews(prev => prev.map(r => (r.id === updated.id ? updated : r)))
        }
        emptyText="아직 등록된 리뷰가 없어요."
        replyTemplate={(review) => getReplyTemplate(store, review)}
      />
    </ScrollView>
  );
}

// ── 38차: 설정 콤보탭 — 운영시간/이벤트 전환
// 69차: 이벤트 탭 복원 — BOOST 플랜 매장의 자체 이벤트 등록/노출 기능(67~68차)이
//       실제로는 이 탭을 통해서만 접근 가능한데 58차에서 진입점 자체가 삭제되어
//       BOOST 플랜을 구매해도 이벤트를 등록할 방법이 없던 상태였음 — 복원.
//       ScheduleTab의 미저장 경고(62차)도 함께 재연결.
// 71차: 리뷰 답글 탭 추가 (모든 플랜 공통, 잠금 없음)
function SettingsComboTab({ store, setStore, storeId, scopeBranchIdx = null, onUnsavedChange, initialView }) {
  const [view, setView] = useState(initialView || 'schedule'); // 'schedule' | 'events' | 'reviews'
  const [hasUnsaved, setHasUnsavedState] = useState(false);
  // 78차 38차: 이 화면 내부 전환 경고와 별개로, 부모(StoreAdminScreen)의 "예약 관리" 등
  // 상위 탭 전환도 같은 미저장 상태를 알아야 해서 setState를 감싸 부모에도 함께 알림.
  const setHasUnsaved = (v) => { setHasUnsavedState(v); onUnsavedChange?.(v); };

  const handleSwitch = (target) => {
    if (view === target) return;
    if (view === 'schedule' && hasUnsaved) {
      showAlert(
        '저장하지 않은 변경사항',
        '운영시간 설정에 저장하지 않은 변경사항이 있어요.\n지금 이동하면 변경사항이 사라집니다. 계속할까요?',
        [
          { text: '취소', style: 'cancel' },
          { text: '이동', style: 'destructive', onPress: () => setView(target) },
        ]
      );
      return;
    }
    setView(target);
  };

  return (
    <View style={{ flex: 1 }}>
      {/* 78차 18차: 4개 버튼을 flex:1로 균등 분배하면 "PICK 테마"/"테마 일괄등록"처럼
          긴 라벨이 버튼 폭보다 커서 두 줄로 줄바꿈되던 문제 — 가로 스크롤 행으로 바꿔
          각 버튼이 라벨 길이만큼 자기 폭을 갖게 함(SuperAdminStoresScreen.js의 tabScroll과
          동일 패턴). numberOfLines={1}도 안전장치로 추가.
          78차 22차: 이 ScrollView에 높이를 안 줘서 flex:1인 부모 안에서 남는 세로 공간을
          그대로 채워버려 버튼이 화면 전체 높이만큼 길쭉해지던 버그 — 높이 고정. */}
      <ScrollView horizontal showsHorizontalScrollIndicator={false}
        style={{ height: 58, flexGrow: 0, backgroundColor: SURFACE, borderBottomWidth: 1, borderBottomColor: BORDER }}
        contentContainerStyle={{ flexDirection: 'row', alignItems: 'center', padding: 10, gap: 6 }}>
        <TouchableOpacity
          style={[combo.viewBtn, view === 'schedule' && combo.viewBtnActive]}
          onPress={() => handleSwitch('schedule')}>
          <IconLabel Icon={ClockIcon} size={13} color={view==='schedule' ? undefined : TEXT_MUTED} style={{justifyContent:'center'}}
            textStyle={[combo.viewBtnTxt, view === 'schedule' && combo.viewBtnTxtActive]} numberOfLines={1}>
            운영시간{hasUnsaved ? ' ●' : ''}
          </IconLabel>
        </TouchableOpacity>
        <TouchableOpacity
          style={[combo.viewBtn, view === 'events' && combo.viewBtnActive]}
          onPress={() => handleSwitch('events')}>
          <IconLabel Icon={SpotlightStarIcon} size={13} color={view==='events' ? undefined : TEXT_MUTED} style={{justifyContent:'center'}}
            textStyle={[combo.viewBtnTxt, view === 'events' && combo.viewBtnTxtActive]} numberOfLines={1}>
            PICK 테마{!planAtLeast(getEffectivePlan(store, scopeBranchIdx), 'premium') ? ' 🔒' : ''}
          </IconLabel>
        </TouchableOpacity>
        <TouchableOpacity
          style={[combo.viewBtn, view === 'reviews' && combo.viewBtnActive]}
          onPress={() => handleSwitch('reviews')}>
          <IconLabel Icon={MenuInquiryIcon} size={13} color={view==='reviews' ? undefined : TEXT_MUTED} style={{justifyContent:'center'}}
            textStyle={[combo.viewBtnTxt, view === 'reviews' && combo.viewBtnTxtActive]} numberOfLines={1}>
            리뷰 답글
          </IconLabel>
        </TouchableOpacity>
      </ScrollView>

      {view === 'schedule' && (
        <ScheduleTab
          store={store}
          setStore={setStore}
          onChangeDetected={() => setHasUnsaved(true)}
          onSaved={() => setHasUnsaved(false)}
          scopeBranchIdx={scopeBranchIdx}
        />
      )}
      {view === 'events' && (
        <EventsTab storeId={storeId} store={store} scopeBranchIdx={scopeBranchIdx} />
      )}
      {view === 'reviews' && (
        <ReviewReplyTab storeId={storeId} store={store} scopeBranchIdx={scopeBranchIdx} />
      )}
    </View>
  );
}

const combo = StyleSheet.create({
  viewBtn:       { paddingHorizontal: 16, paddingVertical: 7, borderRadius: 16,
                   borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2,
                   alignItems: 'center', justifyContent: 'center' },
  viewBtnActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
  viewBtnTxt:    { color: TEXT_MUTED, fontSize: 12, fontWeight: '600', textAlign: 'center' },
  viewBtnTxtActive: { color: GOLD, fontWeight: '800', textAlign: 'center' },
  // 78차 40차: 예약관리 목록/달력/수동입력 압축 전환용 소형 아이콘 버튼
  iconBtn:       { padding: 7, borderRadius: 10, borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2 },
  iconBtnActive: { borderColor: GOLD, backgroundColor: GOLD + '18' },
});

// ─── 수동 예약 입력 탭 (39차 신규) ──────────────────────────
// 외부(전화/카카오 등)로 받은 예약을 관리자가 직접 입력
// ── 스크롤 피커 (날짜/시간/인원 공통) ───────────────────────
function ScrollPicker({ items, selectedValue, onSelect, label, itemHeight = 44 }) {
  const scrollRef = React.useRef(null);
  const selectedIdx = items.findIndex(i => i.value === selectedValue);

  React.useEffect(() => {
    if (scrollRef.current && selectedIdx >= 0) {
      setTimeout(() => {
        try { scrollRef.current?.scrollTo({ y: selectedIdx * itemHeight, animated: false }); } catch (_) {}
      }, 100);
    }
  }, [selectedIdx, itemHeight]);

  return (
    <View style={pk.wrap}>
      <Text style={pk.label}>{label}</Text>
      <View style={pk.pickerBox}>
        <View style={pk.highlightBar} pointerEvents="none" />
        <ScrollView
          ref={scrollRef}
          showsVerticalScrollIndicator={false}
          snapToInterval={itemHeight}
          decelerationRate="fast"
          contentContainerStyle={{ paddingVertical: itemHeight * 2 }}
          onMomentumScrollEnd={e => {
            const idx = Math.round(e.nativeEvent.contentOffset.y / itemHeight);
            const clamped = Math.max(0, Math.min(idx, items.length - 1));
            if (items[clamped]) onSelect(items[clamped].value);
          }}
          nestedScrollEnabled
        >
          {items.map((item) => {
            const isSelected = item.value === selectedValue;
            return (
              <TouchableOpacity
                key={String(item.value)}
                style={[pk.item, { height: itemHeight }, isSelected && pk.itemSelected]}
                onPress={() => onSelect(item.value)}
                activeOpacity={0.7}
              >
                <Text style={[pk.itemText, isSelected && pk.itemTextSelected]}>
                  {item.label}
                </Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>
    </View>
  );
}

const pk = StyleSheet.create({
  wrap:             { flex: 1 },
  label:            { color: TEXT_MUTED, fontSize: 11, marginBottom: 6 },
  pickerBox:        { height: 220, backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1, borderColor: BORDER, overflow: 'hidden', position: 'relative' },
  highlightBar:     { position: 'absolute', top: '50%', left: 0, right: 0, height: 44, marginTop: -22, backgroundColor: GOLD + '15', borderTopWidth: 1, borderBottomWidth: 1, borderColor: GOLD + '40', zIndex: 1 },
  item:             { justifyContent: 'center', alignItems: 'center' },
  itemSelected:     {},
  itemText:         { color: TEXT_MUTED, fontSize: 14 },
  itemTextSelected: { color: GOLD, fontWeight: '800', fontSize: 15 },
});

// ── 날짜/시간 피커 아이템 생성 헬퍼 ─────────────────────────
// 75차: 과거 날짜도 선택 가능하도록 -60일부터 시작 — 기존엔 오늘부터 60일 후까지만
// 골라서, 매장이 예약을 늦게(당일 이후) 수기 입력하려 해도 방법이 없었음. 정산
// (scheduledMonthlySettlement)이 reservations.date 기준으로 그 달 매출을 집계하는데,
// 뒤늦게 입력하려던 예약을 아예 못 넣으면 그 매출이 통째로 정산에서 누락될 수 있음.
function buildDateItems() {
  const items = [];
  const today = new Date();
  for (let i = -60; i < 60; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    const yyyy = d.getFullYear();
    const mm   = String(d.getMonth() + 1).padStart(2, '0');
    const dd   = String(d.getDate()).padStart(2, '0');
    const val  = `${yyyy}-${mm}-${dd}`;
    const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
    const dayName  = dayNames[d.getDay()];
    items.push({ value: val, label: `${mm}/${dd} (${dayName})` });
  }
  return items;
}

// 61차: theme 전체를 받아서 ① availableTimes ② intervalMinutes 기반 생성 ③ 기본값 순으로 처리
// 78차 57차: 시작시간은 테마 자체 값 우선, 없으면 store 공통값 — 간격은 duration+prepMinutes.
function buildTimeItems(theme, store) {
  // ① 운영시간 설정에서 이미 생성된 시간 목록이 있으면 그대로 사용
  if (theme?.availableTimes?.length > 0) {
    return theme.availableTimes.map(t => ({ value: t, label: t }));
  }
  // ② 테마 시작시간(없으면 store 공통) + 테마 duration+prepMinutes로 직접 계산
  const start    = normalizeTimeStr(theme?.startTime) || normalizeTimeStr(store?.startTime) || '09:00';
  const end      = normalizeTimeStr(store?.endTime)   || '22:00';
  // 79차: [버그 수정] 형제 함수 generateSlots()는 이미 Math.max(1,...)로 이 값이 0
  // 이하가 되지 않도록 막아두고 있는데(주석 참고 — 안 막으면 아래 for문이 무한루프),
  // 이 함수는 자체 루프를 별도로 복제해 쓰면서 그 클램프를 안 받고 있었음(StoreAdminScreen.js
  // 전수 재정독 fork로 발견). prepMinutes는 -60~+60까지 입력 가능해 duration과 합이
  // 0 이하인 테마(예: duration:30, prepMinutes:-30)를 운영시간 저장 전(availableTimes
  // 없음) 상태로 수동입력 탭에서 고르면 화면이 그대로 멈출 수 있었음.
  const interval = Math.max(1, Number(theme?.duration || 60) + Number(theme?.prepMinutes || 0));
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const startMin = sh * 60 + sm;
  let endMin   = eh * 60 + em;
  // 78차 44차: 자정을 넘기는 영업시간(예: 22:00~02:00) 지원 — generateSlots와 동일한 처리.
  if (endMin <= startMin) endMin += 24 * 60;
  const items = [];
  for (let t = startMin; t < endMin; t += interval) {
    const wrapped = t % (24 * 60);
    const val = `${String(Math.floor(wrapped / 60)).padStart(2, '0')}:${String(wrapped % 60).padStart(2, '0')}`;
    items.push({ value: val, label: val });
  }
  return items.length > 0 ? items : [{ value: '14:00', label: '14:00' }];
}

// 78차 56차: 인원별 가격표(pricing)가 없는 테마(단일 flatPrice만 있는 경우)는 여기서
// 항상 price:0으로 채워졌는데, handlePeopleSelect가 이 값을 그대로 안 쓰고 pricing을
// 다시 훑어서(항상 빈 배열이라 매번 undefined) 기존 form.price를 유지하는 구조라 —
// 결과적으로 이런 테마는 자동입력도 안 되고, "✏️ 수정" 버튼도 form.price가 이미
// 채워져 있어야만 나타나서 수동으로 가격을 넣을 방법조차 없었음(예약이 항상 0원으로
// 등록됨). 고객 화면(ThemeDetailScreen 등)이 이미 쓰는 것과 동일한 flatPrice 폴백을
// 여기도 추가.
function buildPeopleItems(pricing, flatPrice = 0) {
  if (pricing && pricing.length > 0) {
    return pricing.map(p => ({
      value: String(p.people),
      label: `${p.people}인`,
      price: Number(p.price) || 0,
    }));
  }
  return [2,3,4,5,6].map(n => ({ value: String(n), label: `${n}인`, price: Number(flatPrice) || 0 }));
}

function ManualReservationTab({ store, storeId, onAdded, scopeBranchIdx = null, initialDate = null }) {
  const { user } = useAuth();
  const todayStr = TODAY();
  const EMPTY = {
    // 78차: 달력 탭 "+ 예약 추가"로 넘어온 경우 그 날짜를 기본값으로 미리 채움
    branchName: '', productName: '', date: initialDate || todayStr, time: '14:00',
    people: '2', price: '', customerName: '', customerPhone: '', memo: '',
  };
  const [form,       setForm]       = useState(EMPTY);
  const [saving,     setSaving]     = useState(false);
  const [recentList, setRecentList] = useState([]);
  // 80차 후속: [기능 추가] 간편 일괄 입력 — 건별 상세입력이 번거로워 외부채널 예약을
  // 아예 안 넣게 되면 매출/건수 통계가 실제보다 축소돼 보이는 문제(사용자 문의로 신규
  // 착수). '상세'(기존)/'daily'(하루 총매출만)/'byTheme'(테마별 건수·매출) 3모드.
  const [mode, setMode] = useState('detail');

  // 72차: branches는 절대 자르지 않는다 — handleSave의 branchIdx = branches.findIndex(...)가
  // 실제 위치 인덱스여야 productId("storeId_branchIdx_themeIdx")가 맞게 생성됨.
  // 지점 선택 중일 땐 visibleBranches(칩 렌더용)만 해당 지점 하나로 좁힌다.
  const branches = store?.branches || [];
  // 78차 47차: 소프트 삭제된 지점/테마는 수동입력 선택지에서 제외(branches 자체는
  // 위 주석대로 자르지 않음 — visibleBranches/themes는 선택 UI 전용 파생값).
  const visibleBranches = branches.filter((b, bi) =>
    b.isDeleted !== true && (scopeBranchIdx === null || bi === scopeBranchIdx));
  // 78차 18차: 지점을 특정하지 않은 상태(scopeBranchIdx===null)라도 매장 자체가
  // 단일 지점이면 고를 필요가 없으니 자동 선택 — 기존엔 드롭다운으로 지점을 "선택"한
  // 경우만 자동 채워지고, 애초에 지점이 하나뿐인 매장은 매번 칩을 직접 눌러야 했음.
  useEffect(() => {
    if (scopeBranchIdx !== null && branches[scopeBranchIdx]) {
      setForm(prev => ({ ...prev, branchName: branches[scopeBranchIdx].branchName, productName: '' }));
    } else if (scopeBranchIdx === null && branches.length === 1) {
      setForm(prev => ({ ...prev, branchName: branches[0].branchName, productName: '' }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scopeBranchIdx, branches.length]);
  const selectedTheme = branches
    .find(b => b.branchName === form.branchName)
    ?.themes?.find(t => t.name === form.productName && t.isDeleted !== true) || null;
  // 79차: [버그 수정] .filter()를 먼저 하면 이후 findIndex가 "필터된 배열 안에서의
  // 위치"를 반환해 원본 branches[branchIdx].themes의 실제 위치와 어긋남(전수 정독으로
  // 발견 — EventsTab의 themeOptions가 이미 78차47차에 겪고 map-then-filter(Boolean)
  // 순서로 고친 것과 동일한 함정인데 이 탭만 반영이 안 돼 있었음). 예: 테마가
  // [A(소프트삭제), B, C]이고 관리자가 C를 선택하면, 필터된 배열([B,C])에서 C의
  // 인덱스는 1이지만 원본 배열에서 C의 실제 인덱스는 2 — handleSave가 이 인덱스로
  // productId를 만들면 실제로는 B의 productId로 저장되어 통계/정산이 엉뚱한 테마에
  // 잡히거나, 그 자리의 실제 예약과 슬롯이 꼬여 더블부킹으로 이어질 수 있었음.
  // 원본 인덱스를 __themeIdx로 보존해두고 handleSave가 findIndex 대신 이 값을 쓰도록 함.
  const themes = (branches.find(b => b.branchName === form.branchName)?.themes || [])
    .map((t, ti) => (t.isDeleted === true ? null : { ...t, __themeIdx: ti }))
    .filter(Boolean);

  // 피커 아이템
  const dateItems   = React.useMemo(() => buildDateItems(), []);
  // 61차: selectedTheme 전체 객체 전달 — availableTimes 없을 때 intervalMinutes로 계산
  const timeItems   = React.useMemo(
    () => buildTimeItems(selectedTheme, store),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(selectedTheme), store?.startTime, store?.endTime]
  );
  const peopleItems = React.useMemo(
    () => buildPeopleItems(selectedTheme?.pricing, selectedTheme?.price),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(selectedTheme?.pricing), selectedTheme?.price]
  );

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  // 인원 선택 시 금액 자동 입력 — peopleItems가 이미 pricing/flatPrice 폴백을 반영해
  // 계산해둔 price를 그대로 사용(중복 계산 제거, buildPeopleItems 수정과 짝을 이룸).
  const handlePeopleSelect = (peopleVal) => {
    const matched = peopleItems.find(i => i.value === String(peopleVal));
    setForm(prev => ({
      ...prev,
      people: String(peopleVal),
      price:  matched ? String(matched.price) : prev.price,
    }));
  };

  // 79차: [버그 수정] 테마를 바꿔도 이전 테마에서 자동 입력됐던 금액이 그대로 남아있던
  // 문제(실기기 QA로 발견) — 테마 A(단일가 3만원)에서 3인 선택 후 테마 B(가격표 3인
  // 3만5천원)로 바꿔도 금액이 여전히 3만원으로 남아, 그대로 저장하면 실제 요금과 다른
  // 금액이 통계/정산에 기록될 수 있었음. 테마가 바뀔 때마다 현재 선택된 인원에 맞는
  // 가격으로 다시 채우고, 새 테마에 그 인원수 자체가 없으면(최대인원이 더 적은 테마로
  // 바뀐 경우) 목록의 첫 인원으로 안전하게 재설정.
  useEffect(() => {
    if (!form.productName || peopleItems.length === 0) return;
    const matched = peopleItems.find(i => i.value === form.people);
    if (matched) {
      setForm(prev => ({ ...prev, price: String(matched.price) }));
    } else {
      setForm(prev => ({ ...prev, people: peopleItems[0].value, price: String(peopleItems[0].price) }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.productName, form.branchName]);

  const handleSave = async () => {
    if (!form.date || !form.time || !form.productName || !form.branchName) {
      showAlert('입력 오류', '지점, 테마, 날짜, 시간은 필수입니다.');
      return;
    }
    setSaving(true);
    try {
      // productId: storeId_branchIdx_themeIdx 포맷으로 생성 (ThemeDetailScreen/getBookedTimes 호환)
      // 79차: themes.findIndex(필터된 배열 기준 인덱스) 대신 위에서 보존해둔 원본
      // 인덱스(__themeIdx)를 사용 — 소프트삭제된 테마가 앞에 있어도 정확한 테마를 가리킴.
      const branchIdx = branches.findIndex(b => b.branchName === form.branchName);
      const themeIdx  = themes.find(t => t.name === form.productName)?.__themeIdx ?? -1;
      const productId = (branchIdx >= 0 && themeIdx >= 0)
        ? `${storeId}_${branchIdx}_${themeIdx}`
        : null;

      // 80차: 체험형 공연(정원제) 테마는 정원 검증/증감이 서버 트랜잭션에서만 이뤄져야
      // 해서 CF 경유 — 방탈출 전세 테마는 기존 addManualReservation 그대로.
      const id = selectedTheme?.bookingFormat === 'show'
        ? await reserveShowSlot({
            productId,
            productName:   form.productName,
            storeId,
            branchName:    form.branchName,
            date:          form.date,
            time:          form.time,
            people:        form.people ? Number(form.people) : null,
            isManual:      true,
            customerName:  form.customerName,
            customerPhone: form.customerPhone,
            memo:          form.memo,
          })
        : await addManualReservation({
            storeId,
            branchName:    form.branchName,
            productId,
            productName:   form.productName,
            date:          form.date,
            time:          form.time,
            people:        form.people ? Number(form.people) : null,
            price:         form.price  ? Number(form.price)  : 0,
            customerName:  form.customerName,
            customerPhone: form.customerPhone,
            memo:          form.memo,
            createdByUid:  user?.uid,
          });
      setRecentList(prev => [{
        id, ...form, createdAt: new Date().toISOString(),
      }, ...prev.slice(0, 9)]);
      setForm(EMPTY);
      if (onAdded) onAdded();

      // 75차: 이 예약의 달(month)에 대한 정산(billings)이 이미 생성돼 있으면, 이번
      // 수동입력 매출이 그 정산에는 소급 반영되지 않는다는 걸 안내만 함(자동 재계산은
      // 하지 않음 — 이미 확인/발송된 정산서를 코드가 조용히 바꾸는 게 더 위험하다는 판단).
      const month = form.date.slice(0, 7);
      let billingExists = false;
      try {
        const billingSnap = await getDocs(query(
          collection(db, 'billings'), where('storeId', '==', storeId), where('month', '==', month)
        ));
        billingExists = !billingSnap.empty;
      } catch (_) {}

      if (billingExists) {
        showAlert(
          '완료 (정산 반영 안내)',
          `수동 예약이 등록됐어요.\n\n다만 ${month} 정산서가 이미 생성돼 있어 이 매출은 자동으로 반영되지 않아요. 총괄 관리자에게 알려 정산 금액 조정을 요청해주세요.`
        );
      } else {
        showAlert('완료', '수동 예약이 등록됐어요.');
      }
    } catch (e) {
      if (e.message === 'SLOT_TAKEN') {
        showAlert('예약 마감', '이미 다른 예약이 있는 시간대예요.\n다른 시간을 선택해주세요.');
      } else if (e.message === 'SLOT_FULL') {
        showAlert('정원 초과', '선택한 시간대의 정원이 가득 찼어요.\n인원 또는 시간을 다시 선택해주세요.');
      } else {
        showAlert('오류', `저장 중 오류가 발생했어요.\n(${e.code || e.message})`);
      }
    } finally { setSaving(false); }
  };

  return (
    <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: 60 }}>
      {/* 80차 후속: 상세/간편(하루 총매출)/간편(테마별) 3모드 스위치 */}
      <View style={{ flexDirection: 'row', gap: 8, marginBottom: 14 }}>
        {[
          { key: 'detail', label: '상세 입력' },
          { key: 'daily', label: '간편(하루 총매출)' },
          { key: 'byTheme', label: '간편(테마별)' },
        ].map(m => (
          <TouchableOpacity key={m.key} style={[mr.modeChip, mode === m.key && mr.modeChipActive]} onPress={() => setMode(m.key)}>
            <Text style={[mr.modeChipTxt, mode === m.key && mr.modeChipTxtActive]} numberOfLines={1}>{m.label}</Text>
          </TouchableOpacity>
        ))}
      </View>

      {mode === 'daily' && (
        <QuickDailyTotalCard storeId={storeId} visibleBranches={visibleBranches} user={user}
          onSaved={(entry) => { setRecentList(prev => [entry, ...prev.slice(0, 9)]); if (onAdded) onAdded(); }} />
      )}
      {mode === 'byTheme' && (
        <QuickByThemeCard storeId={storeId} visibleBranches={visibleBranches} branches={branches} user={user}
          onSaved={(entries) => { setRecentList(prev => [...entries, ...prev].slice(0, 10)); if (onAdded) onAdded(); }} />
      )}

      {mode === 'detail' && (
      <Card>
        <CardTitle Icon={EditIcon}>외부 예약 직접 입력</CardTitle>
        <Text style={{ color: TEXT_MUTED, fontSize: 12, marginBottom: 14, lineHeight: 18 }}>
          {'전화·카카오 등으로 받은 예약을 앱에 기록합니다.\n고객에게는 보이지 않으며 관리 통계에만 반영됩니다.'}
        </Text>

        {/* 지점 선택 */}
        <Text style={sc.inputLabel}>지점 *</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 10 }}>
          <View style={{ flexDirection: 'row', gap: 8 }}>
            {visibleBranches.map(b => (
              <TouchableOpacity
                key={b.branchName}
                style={[mr.chip, form.branchName === b.branchName && mr.chipActive]}
                onPress={() => { set('branchName', b.branchName); set('productName', ''); }}>
                <Text style={[mr.chipTxt, form.branchName === b.branchName && mr.chipTxtActive]}>
                  {b.branchName}
                </Text>
              </TouchableOpacity>
            ))}
            {visibleBranches.length === 0 && (
              <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>설정에서 지점을 먼저 추가해주세요.</Text>
            )}
          </View>
        </ScrollView>

        {/* 테마 선택 */}
        <Text style={sc.inputLabel}>테마 *</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 10 }}>
          <View style={{ flexDirection: 'row', gap: 8 }}>
            {themes.map(t => (
              <TouchableOpacity
                key={t.name}
                style={[mr.chip, form.productName === t.name && mr.chipActive]}
                onPress={() => set('productName', t.name)}>
                <Text style={[mr.chipTxt, form.productName === t.name && mr.chipTxtActive]}>
                  {t.name}
                </Text>
              </TouchableOpacity>
            ))}
            {form.branchName && themes.length === 0 && (
              <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>등록된 테마가 없습니다.</Text>
            )}
            {/* 61차: 직접 입력 옵션 제거 — 등록된 테마만 선택 가능 */}
          </View>
        </ScrollView>

        {/* 80차 후속: [기능 추가] 19금 테마는 서버 나이검증이 수동입력(isManual)엔 적용되지
            않음(매장관리자가 현장에서 이미 확인했다고 간주) — 자동으로 되는 줄 오해하지
            않도록 안내(fork로 발견된 UX 갭). */}
        {selectedTheme?.isAdultOnly && (
          <Text style={{ color: COLORS.danger, fontSize: 12, marginBottom: 10 }}>
            🔞 19금 테마입니다. 자동 나이 검증이 적용되지 않으니 현장에서 신분증을 직접 확인해주세요.
          </Text>
        )}

        {/* 62차: 날짜 — 달력 선택으로 교체 */}
        <Text style={[sc.inputLabel, { marginBottom: 6 }]}>날짜 *</Text>
        <View style={sc.blockedCalWrap}>
          <Calendar
            theme={{
              backgroundColor: 'transparent', calendarBackground: 'transparent',
              textSectionTitleColor: TEXT_MUTED,
              selectedDayBackgroundColor: GOLD, selectedDayTextColor: ON_GOLD,
              todayTextColor: GOLD, dayTextColor: TEXT,
              textDisabledColor: 'rgba(255,255,255,0.15)',
              arrowColor: GOLD, monthTextColor: TEXT,
              textDayFontWeight: '500', textMonthFontWeight: '800',
              textDayFontSize: 13, textMonthFontSize: 13,
            }}
            minDate={TODAY()}
            markedDates={form.date ? { [form.date]: { selected: true, selectedColor: GOLD, selectedTextColor: ON_GOLD } } : {}}
            onDayPress={day => set('date', day.dateString)}
            hideExtraDays
          />
        </View>

        {/* 시간 / 인원 — 스크롤 피커 */}
        <View style={{ flexDirection: 'row', gap: 10, marginBottom: 10, marginTop: 10 }}>
          <ScrollPicker
            items={timeItems}
            selectedValue={form.time}
            onSelect={v => set('time', v)}
            label="시간 *"
          />
          <ScrollPicker
            items={peopleItems}
            selectedValue={form.people}
            onSelect={handlePeopleSelect}
            label="인원 *"
          />
        </View>

        {/* 62차: 금액 — 자동입력 후 읽기전용. 의도적 수정 필요 시 수정 버튼으로만 가능 */}
        <View style={{ marginBottom: 10 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <Text style={sc.inputLabel}>금액 (원)</Text>
            {/* 80차 후속: 체험형은 서버(reserveShowSlotCF)가 항상 인원수 기준으로 가격을
                재계산해서 여기서 수정해도 반영이 안 됨 — 오해 방지를 위해 버튼 자체를 숨김 */}
            {form.price && selectedTheme?.bookingFormat !== 'show' ? (
              <TextButton
                label="✏️ 수정"
                onPress={() => showAlert(
                  '금액 수정',
                  '금액을 직접 수정하시겠습니까?\n(협의 할인 등 예외적인 경우에만 사용하세요)',
                  [
                    { text: '취소', style: 'cancel' },
                    { text: '수정', onPress: () => Alert.prompt('금액 입력', '', [
                      { text: '취소' },
                      { text: '확인', onPress: v => { if (v && !isNaN(Number(v))) set('price', String(Number(v))); } }
                    ], 'plain-text', form.price, 'numeric') },
                  ]
                )}
                textStyle={{ color: TEXT_MUTED, fontSize: 10 }}
              />
            ) : null}
          </View>
          <View style={[sc.input, { justifyContent: 'center', backgroundColor: SURFACE2 + '88' }]}>
            <Text style={{ color: form.price ? GOLD : TEXT_MUTED, fontSize: 14, fontWeight: form.price ? '700' : '400' }}>
              {form.price ? `${Number(form.price).toLocaleString()}원` : '인원 선택 시 자동 입력'}
            </Text>
          </View>
        </View>

        {/* 고객 정보 */}
        <Text style={sc.inputLabel}>고객 이름</Text>
        <TextInput
          style={[sc.input, { marginBottom: 10 }]}
          value={form.customerName}
          onChangeText={v => set('customerName', v)}
          placeholder="홍길동"
          placeholderTextColor={TEXT_MUTED}
        />
        <Text style={sc.inputLabel}>고객 연락처</Text>
        <TextInput
          style={[sc.input, { marginBottom: 10 }]}
          value={form.customerPhone}
          onChangeText={v => set('customerPhone', v)}
          placeholder="010-0000-0000"
          placeholderTextColor={TEXT_MUTED}
          keyboardType="phone-pad"
        />
        <Text style={sc.inputLabel}>메모</Text>
        <TextInput
          style={[sc.input, { height: 70, textAlignVertical: 'top', paddingTop: 10, marginBottom: 14 }]}
          value={form.memo}
          onChangeText={v => set('memo', v)}
          placeholder="특이사항, 요청사항 등"
          placeholderTextColor={TEXT_MUTED}
          multiline
        />

        <Btn label={saving ? '저장 중...' : '✅ 예약 등록'} onPress={handleSave} disabled={saving} />
      </Card>
      )}

      {/* 최근 입력 내역 — 모드 무관하게 항상 표시 */}
      {recentList.length > 0 && (
        <Card>
          <CardTitle Icon={MenuPointsIcon}>이번 세션 입력 내역</CardTitle>
          {recentList.map((r, i) => (
            <View key={r.id || i} style={[mr.recentRow, i > 0 && { borderTopWidth: 1, borderTopColor: BORDER, paddingTop: 10, marginTop: 10 }]}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text style={{ color: TEXT, fontWeight: '700', fontSize: 13 }}>{r.productName}</Text>
                <Text style={{ color: GOLD, fontSize: 12, fontWeight: '600' }}>{r.date} {r.time}</Text>
              </View>
              {r.customerName ? <IconLabel Icon={PersonIcon} size={11} color={TEXT_SEC} textStyle={{ color: TEXT_SEC, fontSize: 12 }} style={{ marginTop: 2 }}>{r.customerName} {r.customerPhone}</IconLabel> : null}
              {r.memo ? <IconLabel Icon={EditIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 11 }} style={{ marginTop: 2 }}>{r.memo}</IconLabel> : null}
            </View>
          ))}
        </Card>
      )}
    </ScrollView>
  );
}

const mr = StyleSheet.create({
  chip:        { paddingHorizontal: 14, paddingVertical: 8, borderRadius: 20, borderWidth: 1,
                 borderColor: BORDER, backgroundColor: SURFACE2 },
  chipActive:  { borderColor: GOLD, backgroundColor: GOLD + '18' },
  chipTxt:     { color: TEXT_MUTED, fontSize: 12, fontWeight: '600' },
  chipTxtActive: { color: GOLD, fontWeight: '700' },
  recentRow:   {},
  // 80차 후속: 상세/간편 모드 스위치
  modeChip:      { flex: 1, paddingVertical: 9, borderRadius: 10, borderWidth: 1,
                   borderColor: BORDER, backgroundColor: SURFACE2, alignItems: 'center' },
  modeChipActive:{ borderColor: GOLD, backgroundColor: GOLD + '18' },
  modeChipTxt:   { color: TEXT_MUTED, fontSize: 11, fontWeight: '700' },
  modeChipTxtActive: { color: GOLD },
  themeRow:      { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 8,
                   borderBottomWidth: 1, borderBottomColor: BORDER },
  themeRowName:  { flex: 1, color: TEXT, fontSize: 13, fontWeight: '600' },
  themeRowInput: { width: 72, backgroundColor: SURFACE2, borderRadius: 8, borderWidth: 1,
                   borderColor: BORDER, color: TEXT, fontSize: 13, textAlign: 'center', paddingVertical: 6 },
});

// 80차 후속: [기능 추가] 간편 일괄 입력 — 하루 총매출만. 지점/날짜만 고르고 건수·매출을
// 한 번에 입력 — 테마별 상세 없이도 "이 앱에 예약이 하나도 안 잡힌다"는 오해를 막는 게
// 목적이라, 정확도보다 입력 속도를 우선(ManualReservationTab의 mr.chip 스타일 재사용).
function QuickDailyTotalCard({ storeId, visibleBranches, user, onSaved }) {
  const [branchName, setBranchName] = useState(visibleBranches[0]?.branchName || '');
  const [date, setDate] = useState(TODAY());
  const [count, setCount] = useState('');
  const [revenue, setRevenue] = useState('');
  const [saving, setSaving] = useState(false);
  // 80차 후속: [기능 추가] 이 기능이 "덮어쓰기"가 아니라 "항상 추가"라는 걸 사용자가
  // 헷갈릴 수 있어서 — 저장 전에 그 지점·날짜에 이미 입력된 내역을 보여줌.
  const [existing, setExisting] = useState(null);

  useEffect(() => {
    if (!branchName && visibleBranches[0]) setBranchName(visibleBranches[0].branchName);
  }, [visibleBranches, branchName]);

  useEffect(() => {
    if (!storeId || !branchName || !date) { setExisting(null); return; }
    let cancelled = false;
    getManualBulkLogSummary({ storeId, branchName, date })
      .then(r => { if (!cancelled) setExisting(r); })
      .catch(() => { if (!cancelled) setExisting(null); });
    return () => { cancelled = true; };
  }, [storeId, branchName, date]);

  const handleSave = async () => {
    const c = Number(count), r = Number(revenue);
    // 80차 후속: [버그 수정, fork로 발견] 정수 검증이 없어 "12.5건" 같은 소수 건수가
    // 그대로 저장돼 KPI 표시가 어색해질 수 있었음.
    if (!Number.isInteger(c) || c <= 0 || !Number.isInteger(r) || r <= 0) {
      showAlert('입력 오류', '건수와 매출은 0보다 큰 정수로 입력해주세요.');
      return;
    }
    setSaving(true);
    try {
      const id = await addManualDailyTotal({
        storeId, branchName, date, totalCount: c, totalRevenue: r, createdByUid: user?.uid,
      });
      setCount(''); setRevenue('');
      // 80차 후속: 저장 즉시 "이미 입력된 내역" 표시도 갱신(재쿼리 대신 로컬 누적으로 충분)
      setExisting(prev => ({ count: (prev?.count || 0) + c, revenue: (prev?.revenue || 0) + r, byTheme: prev?.byTheme || {} }));
      showAlert('완료', `${date} 매출 ${r.toLocaleString()}원(${c}건)이 기록됐어요.`);
      onSaved({ id, productName: '일괄입력(전체)', date, time: '-', customerName: '', customerPhone: '',
        memo: `총 ${c}건 · ${r.toLocaleString()}원`, createdAt: new Date().toISOString() });
    } catch (e) {
      showAlert('오류', `저장 중 오류가 발생했어요.\n(${e.code || e.message})`);
    } finally { setSaving(false); }
  };

  return (
    <Card>
      <CardTitle Icon={EditIcon}>간편 일괄 입력 (하루 총매출)</CardTitle>
      <Text style={{ color: TEXT_MUTED, fontSize: 12, marginBottom: 14, lineHeight: 18 }}>
        {'테마·시간 구분 없이 하루 총 건수와 매출만 빠르게 기록해요.\n정확한 테마별 통계가 필요하면 "간편(테마별)"을 이용하세요.'}
      </Text>

      {visibleBranches.length > 1 && (
        <>
          <Text style={sc.inputLabel}>지점 *</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 10 }}>
            <View style={{ flexDirection: 'row', gap: 8 }}>
              {visibleBranches.map(b => (
                <TouchableOpacity key={b.branchName} style={[mr.chip, branchName === b.branchName && mr.chipActive]}
                  onPress={() => setBranchName(b.branchName)}>
                  <Text style={[mr.chipTxt, branchName === b.branchName && mr.chipTxtActive]}>{b.branchName}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>
        </>
      )}

      <Text style={sc.inputLabel}>날짜 *</Text>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 14 }}>
        <View style={{ flexDirection: 'row', gap: 8 }}>
          {/* 80차 후속: buildDateItems()는 -60~+59일 범위를 과거순으로 반환 — 간편입력은
              미래 매출을 기록할 일이 없으므로 오늘 이하만, 최근순으로 보이게 필터+역순 */}
          {buildDateItems().filter(d => d.value <= TODAY()).slice(-10).reverse().map(d => (
            <TouchableOpacity key={d.value} style={[mr.chip, date === d.value && mr.chipActive]} onPress={() => setDate(d.value)}>
              <Text style={[mr.chipTxt, date === d.value && mr.chipTxtActive]}>{d.label}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>

      {/* 80차 후속: [기능 추가] 이 화면은 "덮어쓰기"가 아니라 "추가"라는 걸 미리 보여줘서
          같은 날 실수로 두 번 입력해 중복 합산되는 걸 사전에 알아챌 수 있게 함 */}
      {existing && existing.count > 0 && (
        <View style={{ backgroundColor: SURFACE2, borderRadius: 10, padding: 10, marginBottom: 14 }}>
          <Text style={{ color: TEXT_SEC, fontSize: 12 }}>
            {`${date}에 이미 입력된 내역: ${existing.count}건 · ${existing.revenue.toLocaleString()}원`}
          </Text>
          <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 2 }}>
            아래 입력값은 덮어쓰지 않고 이 내역에 더해져요.
          </Text>
        </View>
      )}

      <View style={{ flexDirection: 'row', gap: 10, marginBottom: 14 }}>
        <View style={{ flex: 1 }}>
          <Text style={sc.inputLabel}>총 건수 *</Text>
          <TextInput style={sc.input} value={count} onChangeText={setCount} placeholder="예: 12"
            placeholderTextColor={TEXT_MUTED} keyboardType="number-pad" />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={sc.inputLabel}>총 매출 (원) *</Text>
          <TextInput style={sc.input} value={revenue} onChangeText={setRevenue} placeholder="예: 360000"
            placeholderTextColor={TEXT_MUTED} keyboardType="number-pad" />
        </View>
      </View>

      <Btn label={saving ? '저장 중...' : '✅ 기록하기'} onPress={handleSave} disabled={saving || !branchName} />
    </Card>
  );
}

// 80차 후속: [기능 추가] 간편 일괄 입력 — 테마별. 위 하루-총매출 모드보다 정밀하게,
// 테마마다 오늘 건수·매출을 따로 기록(시간대 구분은 여전히 없음). 등록된 테마 개수만큼
// 인풋 행이 생기므로 테마가 아주 많은 매장은 다소 길어질 수 있으나, 이미 입력값이 있는
// 행만 저장 대상(addManualByTheme의 count/revenue 없는 항목 스킵)이라 일부만 채워도 됨.
function QuickByThemeCard({ storeId, visibleBranches, branches, user, onSaved }) {
  const [branchName, setBranchName] = useState(visibleBranches[0]?.branchName || '');
  const [date, setDate] = useState(TODAY());
  const [rows, setRows] = useState({}); // { [themeName]: { count, revenue } }
  const [saving, setSaving] = useState(false);
  // 80차 후속: [기능 추가] 테마별로 그 지점·날짜에 이미 입력된 내역(productId 기준)
  const [existingByTheme, setExistingByTheme] = useState({});

  useEffect(() => {
    if (!branchName && visibleBranches[0]) setBranchName(visibleBranches[0].branchName);
  }, [visibleBranches, branchName]);

  useEffect(() => {
    if (!storeId || !branchName || !date) { setExistingByTheme({}); return; }
    let cancelled = false;
    getManualBulkLogSummary({ storeId, branchName, date })
      .then(r => { if (!cancelled) setExistingByTheme(r.byTheme || {}); })
      .catch(() => { if (!cancelled) setExistingByTheme({}); });
    return () => { cancelled = true; };
  }, [storeId, branchName, date]);

  // 80차 후속: [버그 수정, fork로 발견] rows가 테마 "이름"을 키로 쓰는데 지점을 바꿔도
  // 안 지워져서, 다지점 매장에서 같은 이름의 테마가 있으면 이전 지점에 입력했던
  // 건수·매출이 새 지점의 행에 그대로 남아있다가 그대로 저장될 수 있었음 — 지점이
  // 바뀌면 항상 입력값을 비운다(초기 마운트 시 ''→첫 지점 전환도 이 effect를 타지만
  // rows가 이미 빈 상태라 무해함).
  useEffect(() => { setRows({}); }, [branchName]);

  const branchIdx = branches.findIndex(b => b.branchName === branchName);
  const allThemesInBranch = (branches[branchIdx]?.themes || [])
    .map((t, ti) => (t.isDeleted === true ? null : { ...t, __themeIdx: ti }))
    .filter(Boolean);
  // 80차 후속: firestore.rules의 reservations.create가 bookingFormat:'show'인 클라이언트발
  // 문서를 전면 차단(체험형은 정원 검증이 반드시 CF를 거쳐야 해서) — 간편 일괄 입력은
  // 이 경로로 직접 addDoc하므로 체험형 테마는 목록에서 제외하고 안내만.
  const themes = allThemesInBranch.filter(t => (t.bookingFormat || 'room') !== 'show');
  const hasShowThemes = themes.length !== allThemesInBranch.length;

  const setRow = (name, field, val) => setRows(prev => ({ ...prev, [name]: { ...prev[name], [field]: val } }));

  const handleSave = async () => {
    // 80차 후속: [버그 수정, fork로 발견] 정수 검증 없이 소수 건수도 통과되던 것 수정.
    const entries = themes
      .filter(t => Number.isInteger(Number(rows[t.name]?.count)) && Number(rows[t.name]?.count) > 0
        && Number.isInteger(Number(rows[t.name]?.revenue)) && Number(rows[t.name]?.revenue) > 0)
      .map(t => ({
        productId: `${storeId}_${branchIdx}_${t.__themeIdx}`,
        productName: t.name,
        count: Number(rows[t.name].count),
        revenue: Number(rows[t.name].revenue),
        bookingFormat: t.bookingFormat || 'room',
      }));
    if (entries.length === 0) {
      showAlert('입력 오류', '건수·매출을 입력한 테마가 하나도 없어요.');
      return;
    }
    setSaving(true);
    try {
      await addManualByTheme({ storeId, branchName, date, entries, createdByUid: user?.uid });
      setRows({});
      // 80차 후속: 저장 즉시 테마별 "이미 입력된 내역" 로컬 누적 갱신
      setExistingByTheme(prev => {
        const next = { ...prev };
        entries.forEach(e => {
          const cur = next[e.productId] || { count: 0, revenue: 0 };
          next[e.productId] = { count: cur.count + e.count, revenue: cur.revenue + e.revenue };
        });
        return next;
      });
      const totalRev = entries.reduce((s, e) => s + e.revenue, 0);
      const totalCnt = entries.reduce((s, e) => s + e.count, 0);
      showAlert('완료', `${date} · 테마 ${entries.length}개, 총 ${totalCnt}건 · ${totalRev.toLocaleString()}원이 기록됐어요.`);
      onSaved(entries.map((e, i) => ({
        id: `${Date.now()}_${i}`, productName: e.productName, date, time: '-', customerName: '', customerPhone: '',
        memo: `${e.count}건 · ${e.revenue.toLocaleString()}원`, createdAt: new Date().toISOString(),
      })));
    } catch (e) {
      showAlert('오류', `저장 중 오류가 발생했어요.\n(${e.code || e.message})`);
    } finally { setSaving(false); }
  };

  return (
    <Card>
      <CardTitle Icon={EditIcon}>간편 일괄 입력 (테마별)</CardTitle>
      <Text style={{ color: TEXT_MUTED, fontSize: 12, marginBottom: 14, lineHeight: 18 }}>
        {'테마마다 오늘 건수·매출을 따로 기록해요. 값을 안 채운 테마는 저장에서 빠져요.'}
      </Text>

      {visibleBranches.length > 1 && (
        <>
          <Text style={sc.inputLabel}>지점 *</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 10 }}>
            <View style={{ flexDirection: 'row', gap: 8 }}>
              {visibleBranches.map(b => (
                <TouchableOpacity key={b.branchName} style={[mr.chip, branchName === b.branchName && mr.chipActive]}
                  onPress={() => setBranchName(b.branchName)}>
                  <Text style={[mr.chipTxt, branchName === b.branchName && mr.chipTxtActive]}>{b.branchName}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>
        </>
      )}

      <Text style={sc.inputLabel}>날짜 *</Text>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 14 }}>
        <View style={{ flexDirection: 'row', gap: 8 }}>
          {/* 80차 후속: buildDateItems()는 -60~+59일 범위를 과거순으로 반환 — 간편입력은
              미래 매출을 기록할 일이 없으므로 오늘 이하만, 최근순으로 보이게 필터+역순 */}
          {buildDateItems().filter(d => d.value <= TODAY()).slice(-10).reverse().map(d => (
            <TouchableOpacity key={d.value} style={[mr.chip, date === d.value && mr.chipActive]} onPress={() => setDate(d.value)}>
              <Text style={[mr.chipTxt, date === d.value && mr.chipTxtActive]}>{d.label}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>

      <Text style={sc.inputLabel}>테마별 건수 · 매출</Text>
      {hasShowThemes && (
        <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 4, marginBottom: 4 }}>
          체험형 테마는 아직 간편 입력을 지원하지 않아요 — 상세 입력을 이용해주세요.
        </Text>
      )}
      {themes.length === 0 ? (
        <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 6 }}>이 지점에 등록된 (방탈출) 테마가 없어요.</Text>
      ) : themes.map(t => {
        // 80차 후속: [기능 추가] 이 테마에 그 날짜 이미 입력된 내역이 있으면 표시 —
        // 덮어쓰지 않고 추가된다는 걸 미리 보여줌.
        const productId = `${storeId}_${branchIdx}_${t.__themeIdx}`;
        const ex = existingByTheme[productId];
        return (
          <View key={t.name} style={mr.themeRow}>
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text style={mr.themeRowName} numberOfLines={1}>{t.name}</Text>
              {ex && ex.count > 0 && (
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 1 }}>
                  이미 {ex.count}건 · {ex.revenue.toLocaleString()}원
                </Text>
              )}
            </View>
            <TextInput style={mr.themeRowInput} value={rows[t.name]?.count || ''} onChangeText={v => setRow(t.name, 'count', v)}
              placeholder="건수" placeholderTextColor={TEXT_MUTED} keyboardType="number-pad" />
            <TextInput style={mr.themeRowInput} value={rows[t.name]?.revenue || ''} onChangeText={v => setRow(t.name, 'revenue', v)}
              placeholder="매출" placeholderTextColor={TEXT_MUTED} keyboardType="number-pad" />
          </View>
        );
      })}

      <View style={{ marginTop: 14 }}>
        <Btn label={saving ? '저장 중...' : '✅ 기록하기'} onPress={handleSave} disabled={saving || !branchName} />
      </View>
    </Card>
  );
}

// ─── 메인 ────────────────────────────────────────────────────
// ─── 매장 선택 드롭다운 ──────────────────────────────────────
function StoreDropdown({ stores, selectedId, onSelect }) {
  const [open, setOpen] = useState(false);
  const anim = useRef(new Animated.Value(0)).current;

  const toggle = () => {
    const toVal = open ? 0 : 1;
    setOpen(!open);
    Animated.spring(anim, { toValue: toVal, useNativeDriver: true, speed: 20, bounciness: 4 }).start();
  };

  const handleSelect = (key) => {
    onSelect(key);
    setOpen(false);
    Animated.spring(anim, { toValue: 0, useNativeDriver: true, speed: 20, bounciness: 0 }).start();
  };

  // key 또는 id 필드 모두 지원
  const getKey  = (s) => s.key ?? s.id;
  const selected = stores.find(s => getKey(s) === selectedId);
  const translateY = anim.interpolate({ inputRange: [0, 1], outputRange: [-8, 0] });
  const opacity    = anim.interpolate({ inputRange: [0, 1], outputRange: [0, 1] });

  if (stores.length <= 1) return null;

  return (
    <View style={dd.wrap}>
      <TouchableOpacity style={dd.trigger} onPress={toggle} activeOpacity={0.8}>
        <Text style={dd.triggerText} numberOfLines={1}>
          {selected?.name || '선택'}
        </Text>
        <Text style={[dd.arrow, open && dd.arrowOpen]}>▼</Text>
      </TouchableOpacity>

      {open && (
        <Animated.View style={[dd.menu, { opacity, transform: [{ translateY }] }]}>
          {stores.map(s => {
            const k = getKey(s);
            return (
              <TouchableOpacity
                key={k}
                style={[dd.item, k === selectedId && dd.itemActive]}
                onPress={() => handleSelect(k)}
                activeOpacity={0.7}
              >
                <Text style={[dd.itemText, k === selectedId && dd.itemTextActive]}>
                  {k === selectedId ? '✓ ' : '   '}{s.name}
                </Text>
              </TouchableOpacity>
            );
          })}
        </Animated.View>
      )}
    </View>
  );
}


const dd = StyleSheet.create({
  wrap:         { position: 'relative', zIndex: 999 },
  trigger:      {
    flexDirection: 'row', alignItems: 'center', gap: 5,
    backgroundColor: SURFACE2, borderRadius: 8, borderWidth: 1,
    borderColor: 'rgba(212,168,67,0.4)', paddingHorizontal: 10, paddingVertical: 6,
    minWidth: 100, maxWidth: 200,
  },
  triggerText:  { color: GOLD, fontSize: 12, fontWeight: '800', flex: 1, textAlign: 'right' },
  arrow:        { color: GOLD, fontSize: 9, transform: [{ rotate: '0deg' }] },
  arrowOpen:    { transform: [{ rotate: '180deg' }] },
  menu:         {
    position: 'absolute', top: 36, right: 0,
    backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1,
    borderColor: 'rgba(212,168,67,0.3)', minWidth: 160,
    shadowColor: '#000', shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.5, shadowRadius: 8, elevation: 16,
    overflow: 'hidden',
  },
  item:         { paddingHorizontal: 14, paddingVertical: 11, borderBottomWidth: 1, borderBottomColor: 'rgba(255,255,255,0.05)' },
  itemActive:   { backgroundColor: 'rgba(212,168,67,0.10)' },
  itemText:     { color: TEXT_SEC, fontSize: 13, fontWeight: '600' },
  itemTextActive: { color: GOLD, fontWeight: '800' },
});

export default function StoreAdminScreen({ section, initialSettingsView } = {}) {
  const { profile } = useAuth();
  // 78차: 대시보드 홈의 "고객 리뷰에 답변하기" 카드가 여기로 딥링크할 수 있도록 —
  // ops 섹션이고 initialSettingsView가 지정돼 있으면 "매장 설정" 탭에서 바로 시작.
  const [activeTab,         setActiveTab]         = useState(() =>
    (section === 'ops' && initialSettingsView) ? 'settings' : 'home'
  );
  // 78차 38차: "매장 설정"(운영시간 등)에 저장 안 한 변경사항이 있는 채로 "예약 관리" 등
  // 다른 상단 탭으로 넘어가면 아무 경고 없이 변경사항이 그대로 사라지던 것 — SettingsComboTab
  // 내부(운영시간↔PICK↔리뷰답글↔일괄등록) 전환엔 이미 있던 미저장 경고를 이 상위 탭 전환에도 확장.
  const [settingsHasUnsaved, setSettingsHasUnsaved] = useState(false);
  const handleTopTabSelect = (target) => {
    if (activeTab === 'settings' && target !== 'settings' && settingsHasUnsaved) {
      showAlert(
        '저장하지 않은 변경사항',
        '매장 설정에 저장하지 않은 변경사항이 있어요.\n지금 이동하면 변경사항이 사라집니다. 계속할까요?',
        [
          { text: '취소', style: 'cancel' },
          { text: '이동', style: 'destructive', onPress: () => setActiveTab(target) },
        ]
      );
      return;
    }
    setActiveTab(target);
  };
  const [storeDataMap,      setStoreDataMap]       = useState({}); // storeId → { store, records }
  // 72차: 지점 선택 상태를 매장관리/운영관리 두 하단 탭이 공유하도록 StoreAdminBranchContext에서
  // 끌어올려 받는다. Provider 없이 렌더될 경우(방어적)를 대비해 로컬 state로 폴백.
  const branchCtx = useContext(StoreAdminBranchContext);
  const [localBranchKey, setLocalBranchKey] = useState(null);
  const selectedBranchKey    = branchCtx ? branchCtx.selectedBranchKey    : localBranchKey;
  const setSelectedBranchKey = branchCtx ? branchCtx.setSelectedBranchKey : setLocalBranchKey;
  const [loading,           setLoading]           = useState(true);

  // managedStores 정규화 (문자열/배열 모두 처리)
  const managedStoreIds = (() => {
    const raw = profile?.managedStores;
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return [raw];
    return [];
  })();

  const load = useCallback(async () => {
    if (!managedStoreIds.length) { setLoading(false); return; }
    try {
      const { getDoc, doc: fsDoc } = await import('firebase/firestore');

      // 78차: 관리 매장이 여러 개(멀티 지점 관리자)일 때 매장을 하나씩 순차 조회하던 것을
      // Promise.all로 병렬화 — 매장별 로직(레거시 예약 폴백 포함)은 그대로 유지
      const entries = await Promise.all(managedStoreIds.map(async (sid) => {
        const storeSnap = await getDoc(fsDoc(db, 'stores', sid));
        const storeData = storeSnap.exists() ? { id: sid, ...storeSnap.data() } : null;
        const myThemeNames = (storeData?.branches || [])
          .flatMap(b => (b.themes || []).map(t => t.name));

        const resSnap = await getDocs(
          query(collection(db, 'reservations'), where('storeId', '==', sid))
        );
        const allRes = resSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        const records = allRes.length > 0
          ? allRes
          : (await getAllReservations()).filter(r => myThemeNames.includes(r.productName));

        return [sid, { store: storeData, records }];
      }));

      setStoreDataMap(Object.fromEntries(entries));
      if (!selectedBranchKey) setSelectedBranchKey('all');
    } catch { /* 무음 처리 */ }
    finally { setLoading(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managedStoreIds.join(',')]);

  // 66차: 단건 매장 재로드 — 드롭다운 전환 시 해당 storeId만 최신화
  // 67차: load()와 동일하게 레거시 예약(storeId 필드 없는 문서) fallback 추가
  //       + 같은 storeId에 대해 빠르게 재요청될 경우 오래된 응답이 최신 응답을 덮어쓰지 않도록 요청 순서 가드 추가
  const loadStoreReqRef = useRef({});
  const loadStore = useCallback(async (sid) => {
    if (!sid || sid === 'all') return;
    const reqId = (loadStoreReqRef.current[sid] || 0) + 1;
    loadStoreReqRef.current[sid] = reqId;
    try {
      const { getDoc, doc: fsDoc } = await import('firebase/firestore');
      const storeSnap = await getDoc(fsDoc(db, 'stores', sid));
      const storeData = storeSnap.exists() ? { id: sid, ...storeSnap.data() } : null;
      const myThemeNames = (storeData?.branches || [])
        .flatMap(b => (b.themes || []).map(t => t.name));

      const resSnap = await getDocs(
        query(collection(db, 'reservations'), where('storeId', '==', sid))
      );
      const allRes = resSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      const records = allRes.length > 0
        ? allRes
        : (await getAllReservations()).filter(r => myThemeNames.includes(r.productName));

      // 이 요청 이후에 같은 storeId로 더 최신 요청이 들어왔다면, 이 결과는 버림 (응답 순서 역전 방지)
      if (loadStoreReqRef.current[sid] !== reqId) return;
      setStoreDataMap(prev => ({ ...prev, [sid]: { store: storeData, records } }));
    } catch { /* 무음 */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  // 78차 66차: 예약 목록이 최초 load() 이후 getDocs 스냅샷 그대로 고정돼 있어, 새 예약이
  // 들어와도 새로고침(탭 재진입 등)해야만 보이던 버그 — storeId 필드가 있는(신규 예약)
  // 경로에 한해 실시간 구독으로 교체(레거시 storeId 없는 예약의 productName fallback은
  // load()가 최초 1회만 처리, 극히 드문 옛 데이터라 실시간까지는 불필요).
  useEffect(() => {
    if (!managedStoreIds.length) return;
    const unsubs = managedStoreIds.map(sid => onSnapshot(
      query(collection(db, 'reservations'), where('storeId', '==', sid)),
      snap => {
        if (snap.empty) return;
        const allRes = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setStoreDataMap(prev => {
          const current = prev[sid];
          if (!current) return prev;
          return { ...prev, [sid]: { ...current, records: allRes } };
        });
      },
      () => {},
    ));
    return () => unsubs.forEach(u => u());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managedStoreIds.join(',')]);

  // 73차: 로딩 중에도 AppHeader가 사라지지 않도록 — 매장관리/운영관리 두 탭이 각자
  // 별도 인스턴스로 마운트되어 탭 전환마다 이 로딩 화면을 다시 거치는데, 헤더 없이
  // 스피너만 뜨면 "이 탭엔 헤더가 안 붙어있다"처럼 보인다.
  if (loading) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader />
      <LoadingOverlay />
    </View>
  );

  if (!managedStoreIds.length) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader />
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 }}>
        <EmptyStoresIcon size={64} />
        <Text style={{ color: TEXT_MUTED, fontSize: 14, textAlign: 'center', marginTop: 16 }}>
          담당 매장 정보가 없습니다.{'\n'}총괄 관리자에게 문의해주세요.
        </Text>
      </View>
    </View>
  );

  // ── 지점 목록 생성 ─────────────────────────────────────────
  // { key: 'storeId_branchIdx', storeId, branchIdx, name }
  // 78차 47차: 소프트 삭제된 지점은 매장관리자의 지점 전환 목록에서도 제외
  const branchList = managedStoreIds.flatMap(sid => {
    const branches = storeDataMap[sid]?.store?.branches || [];
    return branches.map((b, bi) => ({ b, bi })).filter(({ b }) => b.isDeleted !== true).map(({ b, bi }) => ({
      key:       `${sid}_${bi}`,
      storeId:   sid,
      branchIdx: bi,
      name:      b.branchName || `지점 ${bi + 1}`,
    }));
  });

  const multiBranch = branchList.length > 1;
  const currentKey  = selectedBranchKey || 'all';

  // ── 현재 선택에 따른 store/records/storeId 계산 ───────────
  // 72차: scopeBranchIdx — 선택된 지점의 실제 branches[] 인덱스. null이면 '전체'.
  // store 자체는 항상 branches 전체를 유지한 채로 전달하고(운영시간 저장·productId 생성 등
  // 위치 인덱스에 의존하는 로직이 배열이 잘리면 깨지므로), 각 탭이 이 인덱스로 표시만 필터링한다.
  let store, records, currentStoreId, currentBranchName, scopeBranchIdx = null;

  if (currentKey === 'all' || !multiBranch) {
    currentStoreId    = managedStoreIds[0];
    store             = storeDataMap[currentStoreId]?.store;
    records           = managedStoreIds.flatMap(sid => storeDataMap[sid]?.records || []);
    currentBranchName = '전체';
  } else {
    const found       = branchList.find(b => b.key === currentKey);
    currentStoreId    = found?.storeId || managedStoreIds[0];
    const branchIdx   = found?.branchIdx ?? 0;
    store             = storeDataMap[currentStoreId]?.store;
    const allRecords  = storeDataMap[currentStoreId]?.records || [];
    const branchName  = store?.branches?.[branchIdx]?.branchName;
    const branchThemeNames = (store?.branches?.[branchIdx]?.themes || []).map(t => t.name);
    records           = allRecords.filter(r =>
      r.branchName === branchName || branchThemeNames.includes(r.productName)
    );
    currentBranchName = found?.name || '지점';
    scopeBranchIdx    = branchIdx;
  }

  const setRecords = (updater) => {
    setStoreDataMap(prev => {
      const current    = prev[currentStoreId] || {};
      const newRecords = typeof updater === 'function'
        ? updater(current.records || [])
        : updater;
      return { ...prev, [currentStoreId]: { ...current, records: newRecords } };
    });
  };

  // 드롭다운 목록: 지점 2개 이상이면 '전체' 추가
  const dropdownItems = [
    ...(multiBranch ? [{ key: 'all', name: '전체' }] : []),
    ...branchList,
  ];

  // 72차: section prop이 있으면(하단 탭 분리) 해당 섹션의 탭만 후보로 두고,
  // 그중 플랜 게이트로 막힌 탭이면 첫 허용 탭으로 대체. section 없으면 기존처럼 4개 전부.
  // visibleTabs가 비면(예: 매장관리[홈,통계] 섹션인데 BASIC 플랜) 탭 대신 잠금 화면을 보여준다 —
  // 이때 candidateTabs[0]으로 fallback하면 플랜 게이트를 우회해 막힌 탭 내용이 그대로 렌더되므로 금지.
  const sectionKeys = section ? SECTION_TAB_KEYS[section] : null;
  const candidateTabs = sectionKeys ? TABS.filter(t => sectionKeys.includes(t.key)) : TABS;
  const visibleTabs = candidateTabs.filter(t => !TAB_NEEDS_OPS.has(t.key) || hasOpsAddon(store, scopeBranchIdx));
  const effectiveActiveTab = visibleTabs.some(t => t.key === activeTab)
    ? activeTab
    : (visibleTabs[0]?.key || 'booking');
  const sectionLocked = candidateTabs.length > 0 && visibleTabs.length === 0;

  return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader
        rightElement={
          multiBranch
            ? (
              <StoreDropdown
                stores={dropdownItems}
                selectedId={currentKey}
                onSelect={(key) => {
                  setSelectedBranchKey(key);
                  // 66차: 전환한 매장의 데이터를 즉시 최신화
                  const targetStoreId = branchList.find(b => b.key === key)?.storeId;
                  if (targetStoreId) loadStore(targetStoreId);
                }}
              />
            )
            : (
              <View style={{ alignItems: 'flex-end' }}>
                <IconLabel Icon={MenuStoreIcon} size={11} color={GOLD} textStyle={{ color: GOLD, fontSize: 12, fontWeight: '800' }} numberOfLines={1}>
                  {currentBranchName}
                </IconLabel>
                <Text style={{ color: TEXT_MUTED, fontSize: 10, marginTop: 2 }}>
                  {profile?.nickname || ''}
                </Text>
              </View>
            )
        }
      />

      {/* 80차 후속: 탭 게이트를 plan이 아니라 매장관리자 기능 애드온(opsAddon)으로 재편 */}
      {sectionLocked ? (
        // 72차: 하단 탭이 매장관리(홈·통계)/운영관리(예약·설정)로 분리되면서, 해당 섹션의
        // 탭이 지금 애드온 여부로 전부 막힌 경우 잠긴 화면 없이 빈 화면만 뜨는 걸 막기
        // 위한 안내 카드
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32, gap: 8 }}>
          <PlanLockedIcon size={48} />
          <Text style={{ color: TEXT, fontSize: 14, fontWeight: '800' }}>매장관리자 기능 애드온이 필요해요</Text>
          <Text style={{ color: TEXT_MUTED, fontSize: 12, textAlign: 'center', lineHeight: 18 }}>
            홈·통계 화면은 매장관리자 기능 애드온을 추가한 매장에서 확인할 수 있어요.{'\n'}총괄 관리자에게 문의하세요.
          </Text>
        </View>
      ) : (
        <>
          <TabBar active={effectiveActiveTab} onSelect={handleTopTabSelect} tabs={visibleTabs} />

          <View style={{ flex: 1 }}>
            {effectiveActiveTab === 'home' && (
              <DashboardTab records={records} store={store} profile={profile} storeId={currentStoreId}
                scopeBranchIdx={scopeBranchIdx} />
            )}
            {effectiveActiveTab === 'booking' && (
              <BookingComboTab records={records} setRecords={setRecords} store={store}
                storeId={currentStoreId} onAdded={load} scopeBranchIdx={scopeBranchIdx} />
            )}
            {effectiveActiveTab === 'stats' && (
              <StatsTab records={records} store={store} storeId={currentStoreId} scopeBranchIdx={scopeBranchIdx} />
            )}
            {effectiveActiveTab === 'settings' && (
              <SettingsComboTab store={store} setStore={(updatedStore) => {
                setStoreDataMap(prev => ({
                  ...prev,
                  [currentStoreId]: { ...prev[currentStoreId], store: updatedStore },
                }));
              }} storeId={currentStoreId} scopeBranchIdx={scopeBranchIdx} onUnsavedChange={setSettingsHasUnsaved}
                initialView={initialSettingsView} />
            )}
          </View>
        </>
      )}
    </View>
  );
}
const main = StyleSheet.create({
  header: {
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start',
    paddingHorizontal: 16, paddingVertical: 14,
    backgroundColor: SURFACE, borderBottomWidth: 1, borderBottomColor: BORDER,
  },
  headerTitle: { color: GOLD, fontSize: 16, fontWeight: '900', letterSpacing: 0.5 },
  headerSub:   { color: TEXT_MUTED, fontSize: 11, marginTop: 2 },
});